// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AddComplaintNoteData, AddComplaintNoteErrors, AddComplaintNoteResponses, AddNoteData, AddNoteErrors, AddNoteResponses, AddNotesBatchData, AddNotesBatchErrors, AddNotesBatchResponses, AdminGetConfigurationSummaryData, AdminGetConfigurationSummaryResponses, AdminGetLlmCostCapData, AdminGetLlmCostCapResponses, AdminReadBulkOperationConfigsData, AdminReadBulkOperationConfigsErrors, AdminReadBulkOperationConfigsResponses, AdminReadRateLimitConfigsData, AdminReadRateLimitConfigsErrors, AdminReadRateLimitConfigsResponses, AdminResetIpRateLimitData, AdminResetIpRateLimitErrors, AdminResetIpRateLimitResponses, AdminResetUserRateLimitData, AdminResetUserRateLimitErrors, AdminResetUserRateLimitResponses, AdminUpdateLlmCostCapData, AdminUpdateLlmCostCapErrors, AdminUpdateLlmCostCapResponses, AdminValidateConfigurationData, AdminValidateConfigurationResponses, AnalyticsHealthData, AnalyticsHealthResponses, AuditBatchEndpointData, AuditBatchEndpointErrors, AuditBatchEndpointResponses, AuditRerunEndpointData, AuditRerunEndpointErrors, AuditRerunEndpointResponses, CheckAuthData, CheckAuthResponses, CheckTestSuiteHealthData, CheckTestSuiteHealthResponses, CleanupOldResultsData, CleanupOldResultsErrors, CleanupOldResultsResponses, CleanupTimedOutBulkOperationsData, CleanupTimedOutBulkOperationsResponses, ClearConfigurationCacheData, ClearConfigurationCacheResponses, ClearProfileImageMeData, ClearProfileImageMeResponses, CloneWorkflowData, CloneWorkflowErrors, CloneWorkflowResponses, CommitWorkflowData, CommitWorkflowErrors, CommitWorkflowResponses, CompareWorkflowsData, CompareWorkflowsErrors, CompareWorkflowsResponses, CompleteSessionHandoffData, CompleteSessionHandoffErrors, CompleteSessionHandoffResponses, ConnectionStatusData, ConnectionStatusResponses, CountReferralsByStatusData, CountReferralsByStatusErrors, CountReferralsByStatusResponses, CreateAccessRequestData, CreateAccessRequestErrors, CreateAccessRequestResponses, CreateAuthorityData, CreateAuthorityErrors, CreateAuthorityResponses, CreateBulkOperationConfigEndpointData, CreateBulkOperationConfigEndpointErrors, CreateBulkOperationConfigEndpointResponses, CreateBulkSummaryOperationData, CreateBulkSummaryOperationErrors, CreateBulkSummaryOperationResponses, CreateCircsGradeData, CreateCircsGradeErrors, CreateCircsGradeResponses, CreateClaimData, CreateClaimErrors, CreateClaimResponses, CreateInsurerData, CreateInsurerErrors, CreateInsurerResponses, CreateMetabaseEmbedTokenData, CreateMetabaseEmbedTokenErrors, CreateMetabaseEmbedTokenResponses, CreateMetabaseReportCatalogEndpointData, CreateMetabaseReportCatalogEndpointErrors, CreateMetabaseReportCatalogEndpointResponses, CreateMetabaseReportScheduleEndpointData, CreateMetabaseReportScheduleEndpointErrors, CreateMetabaseReportScheduleEndpointResponses, CreateNewComplaintData, CreateNewComplaintErrors, CreateNewComplaintResponses, CreatePartnerApiBillingConfigData, CreatePartnerApiBillingConfigErrors, CreatePartnerApiBillingConfigResponses, CreatePartnerData, CreatePartnerErrors, CreatePartnerResponses, CreatePartnerRuleData, CreatePartnerRuleErrors, CreatePartnerRuleResponses, CreatePromptConfigData, CreatePromptConfigErrors, CreatePromptConfigResponses, CreatePromptDraftData, CreatePromptDraftErrors, CreatePromptDraftResponses, CreateRateLimitConfigEndpointData, CreateRateLimitConfigEndpointErrors, CreateRateLimitConfigEndpointResponses, CreateReferralAllocationData, CreateReferralAllocationErrors, CreateReferralAllocationResponses, CreateReferralData, CreateReferralErrors, CreateReferralResponses, CreateReportTemplateData, CreateReportTemplateErrors, CreateReportTemplateResponses, CreateRequestData, CreateRequestErrors, CreateRequestResponses, CreateRoleAllocationData, CreateRoleAllocationErrors, CreateRoleAllocationResponses, CreateRoleData, CreateRoleErrors, CreateRolePermissionData, CreateRolePermissionErrors, CreateRolePermissionResponses, CreateRoleResponses, CreateServiceAccountData, CreateServiceAccountErrors, CreateServiceAccountResponses, CreateSettingData, CreateSettingErrors, CreateSettingResponses, CreateSourceRateData, CreateSourceRateErrors, CreateSourceRateResponses, CreateSupplierRateData, CreateSupplierRateErrors, CreateSupplierRateResponses, CreateTableRowData, CreateTableRowErrors, CreateTableRowResponses, CreateTaskScheduleData, CreateTaskScheduleErrors, CreateTaskScheduleResponses, CreateTestResultData, CreateTestResultErrors, CreateTestResultResponses, CreateUserData, CreateUserErrors, CreateUserPartnerData, CreateUserPartnerErrors, CreateUserPartnerResponses, CreateUserResponses, CreateVehGroupData, CreateVehGroupErrors, CreateVehGroupResponses, CreateWorkflowData, CreateWorkflowErrors, CreateWorkflowRateConfigData, CreateWorkflowRateConfigErrors, CreateWorkflowRateConfigResponses, CreateWorkflowResponses, CreditInvoiceData, CreditInvoiceErrors, CreditInvoiceResponses, CspReportData, CspReportResponses, DeleteAuthorityData, DeleteAuthorityErrors, DeleteAuthorityResponses, DeleteBulkOperationConfigEndpointData, DeleteBulkOperationConfigEndpointErrors, DeleteBulkOperationConfigEndpointResponses, DeleteCircsGradeData, DeleteCircsGradeErrors, DeleteCircsGradeResponses, DeleteClaimData, DeleteClaimErrors, DeleteClaimResponses, DeleteExistingComplaintData, DeleteExistingComplaintErrors, DeleteExistingComplaintResponses, DeleteInsurerData, DeleteInsurerErrors, DeleteInsurerResponses, DeleteInvoiceData, DeleteInvoiceErrors, DeleteInvoiceResponses, DeleteMetabaseReportCatalogEndpointData, DeleteMetabaseReportCatalogEndpointErrors, DeleteMetabaseReportCatalogEndpointResponses, DeleteMetabaseReportScheduleEndpointData, DeleteMetabaseReportScheduleEndpointErrors, DeleteMetabaseReportScheduleEndpointResponses, DeleteNoteData, DeleteNoteErrors, DeleteNoteResponses, DeletePartnerApiBillingConfigData, DeletePartnerApiBillingConfigErrors, DeletePartnerApiBillingConfigResponses, DeletePartnerData, DeletePartnerErrors, DeletePartnerResponses, DeletePartnerRuleData, DeletePartnerRuleErrors, DeletePartnerRuleResponses, DeletePromptConfigData, DeletePromptConfigErrors, DeletePromptConfigResponses, DeleteRateLimitConfigEndpointData, DeleteRateLimitConfigEndpointErrors, DeleteRateLimitConfigEndpointResponses, DeleteReferralAllocationData, DeleteReferralAllocationErrors, DeleteReferralAllocationResponses, DeleteReferralData, DeleteReferralErrors, DeleteReferralResponses, DeleteReportTemplateData, DeleteReportTemplateErrors, DeleteReportTemplateResponses, DeleteRoleAllocationData, DeleteRoleAllocationErrors, DeleteRoleAllocationResponses, DeleteRoleData, DeleteRoleErrors, DeleteRolePermissionData, DeleteRolePermissionErrors, DeleteRolePermissionResponses, DeleteRoleResponses, DeleteSettingData, DeleteSettingErrors, DeleteSettingResponses, DeleteSourceRateData, DeleteSourceRateErrors, DeleteSourceRateResponses, DeleteSupplierRateData, DeleteSupplierRateErrors, DeleteSupplierRateResponses, DeleteTableRowData, DeleteTableRowErrors, DeleteTableRowResponses, DeleteTaskScheduleData, DeleteTaskScheduleErrors, DeleteTaskScheduleResponses, DeleteUserData, DeleteUserErrors, DeleteUserMeData, DeleteUserMeResponses, DeleteUserPartnerData, DeleteUserPartnerErrors, DeleteUserPartnerResponses, DeleteUserResponses, DeleteVehGroupData, DeleteVehGroupErrors, DeleteVehGroupResponses, DeleteWorkflowRateConfigData, DeleteWorkflowRateConfigErrors, DeleteWorkflowRateConfigResponses, DisableProfilerData, DisableProfilerResponses, DownloadCallAuditOutputData, DownloadCallAuditOutputErrors, DownloadCallAuditOutputResponses, DownloadClaimFileData, DownloadClaimFileErrors, DownloadClaimFileResponses, DownloadGtaReferralReportData, DownloadGtaReferralReportErrors, DownloadGtaReferralReportResponses, DownloadMattAuditPdfData, DownloadMattAuditPdfErrors, DownloadMattAuditPdfResponses, DownloadMultipleFilesData, DownloadMultipleFilesErrors, DownloadMultipleFilesResponses, DuplicateReportTemplateData, DuplicateReportTemplateErrors, DuplicateReportTemplateResponses, EnableProfilerData, EnableProfilerResponses, ExpireSourceRatesData, ExpireSourceRatesErrors, ExpireSourceRatesResponses, ExpireSupplierRatesData, ExpireSupplierRatesErrors, ExpireSupplierRatesResponses, ExportAnalyticsDataData, ExportAnalyticsDataErrors, ExportAnalyticsDataResponses, ExportPartnerIssueCsvData, ExportPartnerIssueCsvErrors, ExportPartnerIssueCsvResponses, FlowerAuthData, FlowerAuthResponses, GenerateApiKeyForUserData, GenerateApiKeyForUserErrors, GenerateApiKeyForUserResponses, GenerateApiUsageBillingLinesDirectData, GenerateApiUsageBillingLinesDirectErrors, GenerateApiUsageBillingLinesDirectResponses, GenerateApiUsageInvoicesData, GenerateApiUsageInvoicesResponses, GenerateInvoiceLinesDirectData, GenerateInvoiceLinesDirectErrors, GenerateInvoiceLinesDirectResponses, GenerateInvoiceRequestLinesDirectData, GenerateInvoiceRequestLinesDirectErrors, GenerateInvoiceRequestLinesDirectResponses, GenerateInvoiceRequestPdfBulkData, GenerateInvoiceRequestPdfBulkErrors, GenerateInvoiceRequestPdfBulkResponses, GenerateInvoiceRequestPdfData, GenerateInvoiceRequestPdfErrors, GenerateInvoiceRequestPdfResponses, GenerateInvoiceToXeroData, GenerateInvoiceToXeroResponses, GenerateMattClaimsAuditData, GenerateMattClaimsAuditErrors, GenerateMattClaimsAuditResponses, GenerateOutputData, GenerateOutputErrors, GenerateOutputResponses, GeneratePartnerApiUsageBillingDirectData, GeneratePartnerApiUsageBillingDirectErrors, GeneratePartnerApiUsageBillingDirectResponses, GeneratePromptData, GeneratePromptErrors, GeneratePromptResponses, GenerateSummaryData, GenerateSummaryErrors, GenerateSummaryResponses, GenerateWorkflowClaimsAuditData, GenerateWorkflowClaimsAuditErrors, GenerateWorkflowClaimsAuditResponses, GenerateWorkflowData, GenerateWorkflowErrors, GenerateWorkflowResponses, GetAgentRunData, GetAgentRunErrors, GetAgentRunResponses, GetAgentRunSummaryData, GetAgentRunSummaryErrors, GetAgentRunSummaryResponses, GetAiclaimsDashboardSummaryData, GetAiclaimsDashboardSummaryErrors, GetAiclaimsDashboardSummaryResponses, GetAiclaimsWorkflowCardsData, GetAiclaimsWorkflowCardsErrors, GetAiclaimsWorkflowCardsResponses, GetAiPromptConfigData, GetAiPromptConfigErrors, GetAiPromptConfigResponses, GetApiUsageBillingSummaryAllData, GetApiUsageBillingSummaryAllErrors, GetApiUsageBillingSummaryAllResponses, GetApiUsageBillingSummaryData, GetApiUsageBillingSummaryErrors, GetApiUsageBillingSummaryResponses, GetApiUsageData, GetApiUsageErrors, GetApiUsageResponses, GetAppSettingEndpointData, GetAppSettingEndpointErrors, GetAppSettingEndpointResponses, GetAuditBatchEndpointData, GetAuditBatchEndpointErrors, GetAuditBatchEndpointResponses, GetAuditReportData, GetAuditReportErrors, GetAuditReportResponses, GetAvailableTasksData, GetAvailableTasksResponses, GetBotScoresForReferralData, GetBotScoresForReferralErrors, GetBotScoresForReferralResponses, GetBulkOperationReferralsData, GetBulkOperationReferralsErrors, GetBulkOperationReferralsResponses, GetBulkOperationsHistoryData, GetBulkOperationsHistoryErrors, GetBulkOperationsHistoryResponses, GetBulkOperationsMetricsData, GetBulkOperationsMetricsErrors, GetBulkOperationsMetricsResponses, GetBulkOperationStatusData, GetBulkOperationStatusErrors, GetBulkOperationStatusResponses, GetCacheStatusData, GetCacheStatusResponses, GetCallAnalysisJobData, GetCallAnalysisJobErrors, GetCallAnalysisJobResponses, GetCallAuditConfigEndpointData, GetCallAuditConfigEndpointErrors, GetCallAuditConfigEndpointResponses, GetComplaintNotesData, GetComplaintNotesErrors, GetComplaintNotesResponses, GetCsrfTokenData, GetCsrfTokenResponses, GetDownloadStatusData, GetDownloadStatusErrors, GetDownloadStatusResponses, GetEdgeImportStatusData, GetEdgeImportStatusErrors, GetEdgeImportStatusResponses, GetEligibleRepairsData, GetEligibleRepairsErrors, GetEligibleRepairsResponses, GetEndpointAnalyticsData, GetEndpointAnalyticsErrors, GetEndpointAnalyticsResponses, GetEventsForBillingPeriodData, GetEventsForBillingPeriodErrors, GetEventsForBillingPeriodResponses, GetExecutionDetailData, GetExecutionDetailErrors, GetExecutionDetailResponses, GetGtaReferralHistoryData, GetGtaReferralHistoryErrors, GetGtaReferralHistoryResponses, GetGtaReferralSnapshotData, GetGtaReferralSnapshotErrors, GetGtaReferralSnapshotResponses, GetInsurerClaimData, GetInsurerClaimErrors, GetInsurerClaimResponses, GetInsurerPolicyData, GetInsurerPolicyErrors, GetInsurerPolicyResponses, GetInvoiceLinesData, GetInvoiceLinesErrors, GetInvoiceLinesResponses, GetInvoiceRequestLinesData, GetInvoiceRequestLinesErrors, GetInvoiceRequestLinesResponses, GetInvoiceTaskStatusData, GetInvoiceTaskStatusErrors, GetInvoiceTaskStatusResponses, GetLatestSummaryData, GetLatestSummaryErrors, GetLatestSummaryResponses, GetLoginHistoryData, GetLoginHistoryErrors, GetLoginHistoryResponses, GetMetabaseReportCatalogEndpointData, GetMetabaseReportCatalogEndpointErrors, GetMetabaseReportCatalogEndpointResponses, GetMetabaseReportScheduleEndpointData, GetMetabaseReportScheduleEndpointErrors, GetMetabaseReportScheduleEndpointResponses, GetNotesData, GetNotesErrors, GetNotesResponses, GetNotificationOptionsData, GetNotificationOptionsErrors, GetNotificationOptionsResponses, GetPartnerApiBillingConfigData, GetPartnerApiBillingConfigErrors, GetPartnerApiBillingConfigResponses, GetPartnerApiBillingConfigsData, GetPartnerApiBillingConfigsErrors, GetPartnerApiBillingConfigsResponses, GetPartnerIssueRollupData, GetPartnerIssueRollupErrors, GetPartnerIssueRollupResponses, GetPartnerWorkflowRatesData, GetPartnerWorkflowRatesErrors, GetPartnerWorkflowRatesResponses, GetPendingRequestLinesBySupplierData, GetPendingRequestLinesBySupplierErrors, GetPendingRequestLinesBySupplierResponses, GetProfilerStatsData, GetProfilerStatsResponses, GetPromptHistoryData, GetPromptHistoryErrors, GetPromptHistoryResponses, GetRateLimitRecommendationsData, GetRateLimitRecommendationsResponses, GetRealTimeStatsData, GetRealTimeStatsResponses, GetRecentSummaryRunsData, GetRecentSummaryRunsErrors, GetRecentSummaryRunsResponses, GetRedbeatStatusData, GetRedbeatStatusResponses, GetReferralAllocationAuditHistoryData, GetReferralAllocationAuditHistoryErrors, GetReferralAllocationAuditHistoryResponses, GetRepairAllocationBillingStatusData, GetRepairAllocationBillingStatusErrors, GetRepairAllocationBillingStatusResponses, GetReportTemplateData, GetReportTemplateErrors, GetReportTemplateResponses, GetRequestLogsData, GetRequestLogsErrors, GetRequestLogsResponses, GetRunInspectionData, GetRunInspectionErrors, GetRunInspectionResponses, GetSummaryDetailData, GetSummaryDetailErrors, GetSummaryDetailResponses, GetSummaryHistoryData, GetSummaryHistoryErrors, GetSummaryHistoryResponses, GetSummaryStatusData, GetSummaryStatusErrors, GetSummaryStatusResponses, GetTaskConfigData, GetTaskConfigErrors, GetTaskConfigResponses, GetTaskExecutionHistoryData, GetTaskExecutionHistoryErrors, GetTaskExecutionHistoryResponses, GetWorkflowBillingEventByIdData, GetWorkflowBillingEventByIdErrors, GetWorkflowBillingEventByIdResponses, GetWorkflowBillingLedgerSummaryData, GetWorkflowBillingLedgerSummaryErrors, GetWorkflowBillingLedgerSummaryResponses, GetWorkflowData, GetWorkflowErrors, GetWorkflowRateConfigData, GetWorkflowRateConfigErrors, GetWorkflowRateConfigResponses, GetWorkflowRateConfigsData, GetWorkflowRateConfigsErrors, GetWorkflowRateConfigsResponses, GetWorkflowResponses, GetWorkflowRunData, GetWorkflowRunErrors, GetWorkflowRunResponses, GetXeroOnlineInvoiceUrlData, GetXeroOnlineInvoiceUrlErrors, GetXeroOnlineInvoiceUrlResponses, GrafanaAlertWebhookData, GrafanaAlertWebhookResponses, ImportClaimStatePayloadData, ImportClaimStatePayloadErrors, ImportClaimStatePayloadResponses, ImportInboundClaimData, ImportInboundClaimErrors, ImportInboundClaimResponses, IncomingCallData, IncomingCallErrors, IncomingCallResponses, InternalHealthCheckData, InternalHealthCheckResponses, LiabilityScoreFastData, LiabilityScoreFastErrors, LiabilityScoreFastResponses, ListAgentRunsData, ListAgentRunsErrors, ListAgentRunsResponses, ListAiPromptConfigsData, ListAiPromptConfigsResponses, ListAiPromptSlotsRouteData, ListAiPromptSlotsRouteResponses, ListApiKeysForUserData, ListApiKeysForUserErrors, ListApiKeysForUserResponses, ListAppSettingsData, ListAppSettingsErrors, ListAppSettingsResponses, ListAuditBatchesEndpointData, ListAuditBatchesEndpointErrors, ListAuditBatchesEndpointResponses, ListAvailableMetabaseEmbedsData, ListAvailableMetabaseEmbedsResponses, ListAvailableWorkflowsData, ListAvailableWorkflowsResponses, ListBatchPostprocessorsData, ListBatchPostprocessorsErrors, ListBatchPostprocessorsResponses, ListCallAnalysisJobsData, ListCallAnalysisJobsErrors, ListCallAnalysisJobsResponses, ListCallAnalysisWorkflowsData, ListCallAnalysisWorkflowsErrors, ListCallAnalysisWorkflowsResponses, ListGtaReferralReportsData, ListGtaReferralReportsErrors, ListGtaReferralReportsResponses, ListInsurerClaimFieldChangesData, ListInsurerClaimFieldChangesErrors, ListInsurerClaimFieldChangesResponses, ListMetabaseReportCatalogData, ListMetabaseReportCatalogErrors, ListMetabaseReportCatalogResponses, ListMetabaseReportSchedulesData, ListMetabaseReportSchedulesErrors, ListMetabaseReportSchedulesResponses, ListReferralCsvColumnsData, ListReferralCsvColumnsResponses, ListRegisteredWorkflowEnginesData, ListRegisteredWorkflowEnginesResponses, ListReportTemplatesData, ListReportTemplatesErrors, ListReportTemplatesResponses, ListTablesData, ListTablesResponses, ListTaskConfigsData, ListTaskConfigsErrors, ListTaskConfigsResponses, ListWorkflowBillingEventsData, ListWorkflowBillingEventsErrors, ListWorkflowBillingEventsResponses, ListWorkflowBillingLedgerEventsData, ListWorkflowBillingLedgerEventsErrors, ListWorkflowBillingLedgerEventsResponses, ListWorkflowRunsData, ListWorkflowRunsErrors, ListWorkflowRunsResponses, ListWorkflowsData, ListWorkflowsErrors, ListWorkflowsResponses, ListXeroCompaniesData, ListXeroCompaniesResponses, LoginAccessTokenData, LoginAccessTokenErrors, LoginAccessTokenResponses, LogoutData, LogoutResponses, ManualRequestNoPartnerRulesData, ManualRequestNoPartnerRulesErrors, ManualRequestNoPartnerRulesResponses, MarkBillingEventsBilledData, MarkBillingEventsBilledErrors, MarkBillingEventsBilledResponses, MetricsData, MetricsResponses, MonitoringForceCleanupData, MonitoringForceCleanupResponses, MonitoringGetDashboardDataData, MonitoringGetDashboardDataResponses, MonitoringGetRateLimitAlertsData, MonitoringGetRateLimitAlertsResponses, MonitoringGetRateLimitHealthData, MonitoringGetRateLimitHealthResponses, MonitoringGetRateLimitMetricsData, MonitoringGetRateLimitMetricsErrors, MonitoringGetRateLimitMetricsResponses, MonitoringGetRateLimitStatisticsData, MonitoringGetRateLimitStatisticsErrors, MonitoringGetRateLimitStatisticsResponses, MonitoringGetRedisStatusData, MonitoringGetRedisStatusResponses, ParseEmailData, ParseEmailResponses, PartnerUpdateAllocationData, PartnerUpdateAllocationErrors, PartnerUpdateAllocationResponses, PatchGtaReferralFieldData, PatchGtaReferralFieldErrors, PatchGtaReferralFieldResponses, PatchWorkflowBillingEventData, PatchWorkflowBillingEventErrors, PatchWorkflowBillingEventResponses, PayInvoiceData, PayInvoiceErrors, PayInvoiceLineData, PayInvoiceLineErrors, PayInvoiceLineResponses, PayInvoiceResponses, PayInvoiceWithLinesData, PayInvoiceWithLinesErrors, PayInvoiceWithLinesResponses, PreviewReportTemplateData, PreviewReportTemplateErrors, PreviewReportTemplatePdfData, PreviewReportTemplatePdfErrors, PreviewReportTemplatePdfResponses, PreviewReportTemplateResponses, PreviewScheduleConfigData, PreviewScheduleConfigErrors, PreviewScheduleConfigResponses, PromotePromptDraftData, PromotePromptDraftErrors, PromotePromptDraftResponses, PurgeExpiredPrivacyMappingsData, PurgeExpiredPrivacyMappingsResponses, ReadAnniesData, ReadAnniesErrors, ReadAnniesResponses, ReadAnniesVoiceData, ReadAnniesVoiceResponses, ReadAuthoritiesData, ReadAuthoritiesErrors, ReadAuthoritiesResponses, ReadAuthorityData, ReadAuthorityErrors, ReadAuthorityResponses, ReadBulkOperationConfigByNameData, ReadBulkOperationConfigByNameErrors, ReadBulkOperationConfigByNameResponses, ReadBulkOperationConfigData, ReadBulkOperationConfigErrors, ReadBulkOperationConfigResponses, ReadCircsGradeData, ReadCircsGradeErrors, ReadCircsGradeResponses, ReadCircsGradesData, ReadCircsGradesErrors, ReadCircsGradesResponses, ReadClaimData, ReadClaimErrors, ReadClaimResponses, ReadClaimsData, ReadClaimsErrors, ReadClaimsResponses, ReadComplaintData, ReadComplaintErrors, ReadComplaintResponses, ReadComplaintsByReferralData, ReadComplaintsByReferralErrors, ReadComplaintsByReferralResponses, ReadComplaintsData, ReadComplaintsErrors, ReadComplaintsResponses, ReadInsurerData, ReadInsurerErrors, ReadInsurerResponses, ReadInsurersData, ReadInsurersErrors, ReadInsurersResponses, ReadInvoiceData, ReadInvoiceErrors, ReadInvoiceResponses, ReadInvoicesData, ReadInvoicesErrors, ReadInvoicesResponses, ReadMyPagesData, ReadMyPagesResponses, ReadMyPartnersData, ReadMyPartnersResponses, ReadPartnerData, ReadPartnerErrors, ReadPartnerResponses, ReadPartnerRuleData, ReadPartnerRuleErrors, ReadPartnerRuleResponses, ReadPartnerRulesData, ReadPartnerRulesErrors, ReadPartnerRulesResponses, ReadPartnersData, ReadPartnersErrors, ReadPartnersResponses, ReadPermissionCatalogData, ReadPermissionCatalogResponses, ReadProfileImageMeData, ReadProfileImageMeResponses, ReadRateLimitConfigByEndpointData, ReadRateLimitConfigByEndpointErrors, ReadRateLimitConfigByEndpointResponses, ReadRateLimitConfigData, ReadRateLimitConfigErrors, ReadRateLimitConfigResponses, ReadReferralAllocationData, ReadReferralAllocationErrors, ReadReferralAllocationResponses, ReadReferralAllocationsBytypeData, ReadReferralAllocationsBytypeErrors, ReadReferralAllocationsBytypeResponses, ReadReferralData, ReadReferralErrors, ReadReferralResponses, ReadReferralsData, ReadReferralsErrors, ReadReferralsResponses, ReadRoleAllocationData, ReadRoleAllocationErrors, ReadRoleAllocationResponses, ReadRoleAllocationsData, ReadRoleAllocationsErrors, ReadRoleAllocationsResponses, ReadRoleData, ReadRoleErrors, ReadRolePermissionData, ReadRolePermissionErrors, ReadRolePermissionResponses, ReadRolePermissionsData, ReadRolePermissionsErrors, ReadRolePermissionsResponses, ReadRoleResponses, ReadRolesData, ReadRolesErrors, ReadRolesResponses, ReadSecurityTestResultData, ReadSecurityTestResultErrors, ReadSecurityTestResultResponses, ReadSecurityTestResultsData, ReadSecurityTestResultsErrors, ReadSecurityTestResultsResponses, ReadSecurityTestSummaryData, ReadSecurityTestSummaryErrors, ReadSecurityTestSummaryResponses, ReadServiceAccountsData, ReadServiceAccountsErrors, ReadServiceAccountsResponses, ReadSourceRateData, ReadSourceRateErrors, ReadSourceRateResponses, ReadSourceRatesData, ReadSourceRatesErrors, ReadSourceRatesResponses, ReadSupplierRateData, ReadSupplierRateErrors, ReadSupplierRateResponses, ReadSupplierRatesData, ReadSupplierRatesErrors, ReadSupplierRatesResponses, ReadTableRowData, ReadTableRowErrors, ReadTableRowResponses, ReadTableRowsData, ReadTableRowsErrors, ReadTableRowsResponses, ReadUniqueTypesData, ReadUniqueTypesErrors, ReadUniqueTypesResponses, ReadUserByIdData, ReadUserByIdErrors, ReadUserByIdResponses, ReadUserMeData, ReadUserMeResponses, ReadUserPartnerData, ReadUserPartnerErrors, ReadUserPartnerResponses, ReadUserPartnersData, ReadUserPartnersErrors, ReadUserPartnersResponses, ReadUsersData, ReadUsersErrors, ReadUsersResponses, ReadVehGroupData, ReadVehGroupErrors, ReadVehGroupResponses, ReadVehGroupsData, ReadVehGroupsErrors, ReadVehGroupsResponses, ReallocateReferralData, ReallocateReferralErrors, ReallocateReferralResponses, RecordPerformanceMetricData, RecordPerformanceMetricErrors, RecordPerformanceMetricResponses, RecoverPasswordData, RecoverPasswordErrors, RecoverPasswordHtmlContentData, RecoverPasswordHtmlContentErrors, RecoverPasswordHtmlContentResponses, RecoverPasswordResponses, ReferralChartDataData, ReferralChartDataErrors, ReferralChartDataResponses, ReferralsGenerateSummaryData, ReferralsGenerateSummaryErrors, ReferralsGenerateSummaryResponses, ReferralsGetLatestSummaryData, ReferralsGetLatestSummaryErrors, ReferralsGetLatestSummaryResponses, ReferralsGetSummaryDetailData, ReferralsGetSummaryDetailErrors, ReferralsGetSummaryDetailResponses, ReferralsGetSummaryHistoryData, ReferralsGetSummaryHistoryErrors, ReferralsGetSummaryHistoryResponses, ReferralsGetSummaryStatusData, ReferralsGetSummaryStatusErrors, ReferralsGetSummaryStatusResponses, ReferralTableDataData, ReferralTableDataErrors, ReferralTableDataResponses, RefreshAccessTokenData, RefreshAccessTokenResponses, RegisterUserData, RegisterUserErrors, RegisterUserResponses, RehydratePrivacyTokenData, RehydratePrivacyTokenErrors, RehydratePrivacyTokenResponses, ReloadConfigurationData, ReloadConfigurationResponses, RequestUploadCsvData, RequestUploadCsvErrors, RequestUploadCsvNoPartnerRulesData, RequestUploadCsvNoPartnerRulesErrors, RequestUploadCsvNoPartnerRulesResponses, RequestUploadCsvResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, ResetProfilerData, ResetProfilerResponses, RetirePromptConfigData, RetirePromptConfigErrors, RetirePromptConfigResponses, RunSecurityTestsData, RunSecurityTestsErrors, RunSecurityTestsResponses, SchedulerUpdateTaskScheduleData, SchedulerUpdateTaskScheduleErrors, SchedulerUpdateTaskScheduleResponses, SearchInsurerClaimsData, SearchInsurerClaimsErrors, SearchInsurerClaimsResponses, SeedDefaultConfigData, SeedDefaultConfigResponses, SetActiveBrandMeData, SetActiveBrandMeErrors, SetActiveBrandMeResponses, SetCurrentPartnerMeData, SetCurrentPartnerMeErrors, SetCurrentPartnerMeResponses, SetProfileImageMeData, SetProfileImageMeErrors, SetProfileImageMeResponses, SmsHandlerData, SmsHandlerResponses, StartSessionHandoffData, StartSessionHandoffErrors, StartSessionHandoffResponses, StreamBulkOperationsHistoryData, StreamBulkOperationsHistoryResponses, StreamBulkOperationUpdatesData, StreamBulkOperationUpdatesErrors, StreamBulkOperationUpdatesResponses, StreamSummaryStatusData, StreamSummaryStatusErrors, StreamSummaryStatusResponses, SubmitCallAnalysisJobData, SubmitCallAnalysisJobErrors, SubmitCallAnalysisJobResponses, SubmitSummaryFeedbackData, SubmitSummaryFeedbackErrors, SubmitSummaryFeedbackResponses, SwitchXeroCompanyData, SwitchXeroCompanyErrors, SwitchXeroCompanyResponses, TestEmailData, TestEmailErrors, TestEmailResponses, TestWorkflowOnClaimData, TestWorkflowOnClaimErrors, TestWorkflowOnClaimResponses, TriggerInvoiceGenerationData, TriggerInvoiceGenerationErrors, TriggerInvoiceGenerationResponses, TriggerRedbeatSyncData, TriggerRedbeatSyncResponses, TriggerRepairBillingData, TriggerRepairBillingErrors, TriggerRepairBillingResponses, TriggerTaskNowData, TriggerTaskNowErrors, TriggerTaskNowResponses, UpdateApiKeyForUserData, UpdateApiKeyForUserErrors, UpdateApiKeyForUserResponses, UpdateApiUsageBillingStatusData, UpdateApiUsageBillingStatusErrors, UpdateApiUsageBillingStatusResponses, UpdateAuthorityData, UpdateAuthorityErrors, UpdateAuthorityResponses, UpdateBulkOperationConfigEndpointData, UpdateBulkOperationConfigEndpointErrors, UpdateBulkOperationConfigEndpointResponses, UpdateCacheTtlData, UpdateCacheTtlErrors, UpdateCacheTtlResponses, UpdateCircsGradeData, UpdateCircsGradeErrors, UpdateCircsGradeResponses, UpdateClaimData, UpdateClaimErrors, UpdateClaimResponses, UpdateExistingComplaintData, UpdateExistingComplaintErrors, UpdateExistingComplaintResponses, UpdateInsurerData, UpdateInsurerErrors, UpdateInsurerResponses, UpdateInvoiceLineAmountData, UpdateInvoiceLineAmountErrors, UpdateInvoiceLineAmountResponses, UpdateInvoiceLineRateData, UpdateInvoiceLineRateErrors, UpdateInvoiceLineRateResponses, UpdateInvoiceLineStatusData, UpdateInvoiceLineStatusErrors, UpdateInvoiceLineStatusResponses, UpdateInvoiceStatusData, UpdateInvoiceStatusErrors, UpdateInvoiceStatusResponses, UpdateMetabaseReportCatalogEndpointData, UpdateMetabaseReportCatalogEndpointErrors, UpdateMetabaseReportCatalogEndpointResponses, UpdateMetabaseReportScheduleEndpointData, UpdateMetabaseReportScheduleEndpointErrors, UpdateMetabaseReportScheduleEndpointResponses, UpdateNoteData, UpdateNoteErrors, UpdateNoteResponses, UpdatePartnerApiBillingConfigData, UpdatePartnerApiBillingConfigErrors, UpdatePartnerApiBillingConfigResponses, UpdatePartnerData, UpdatePartnerErrors, UpdatePartnerResponses, UpdatePartnerRuleData, UpdatePartnerRuleErrors, UpdatePartnerRuleResponses, UpdatePasswordMeData, UpdatePasswordMeErrors, UpdatePasswordMeResponses, UpdatePromptConfigData, UpdatePromptConfigErrors, UpdatePromptConfigResponses, UpdatePromptDraftData, UpdatePromptDraftErrors, UpdatePromptDraftResponses, UpdateRateLimitConfigEndpointData, UpdateRateLimitConfigEndpointErrors, UpdateRateLimitConfigEndpointResponses, UpdateReferralAllocationData, UpdateReferralAllocationErrors, UpdateReferralAllocationResponses, UpdateReferralData, UpdateReferralErrors, UpdateReferralResponses, UpdateReportTemplateData, UpdateReportTemplateErrors, UpdateReportTemplateResponses, UpdateRoleAllocationData, UpdateRoleAllocationErrors, UpdateRoleAllocationResponses, UpdateRoleData, UpdateRoleErrors, UpdateRolePermissionData, UpdateRolePermissionErrors, UpdateRolePermissionResponses, UpdateRoleResponses, UpdateSettingData, UpdateSettingErrors, UpdateSettingResponses, UpdateSourceRateData, UpdateSourceRateErrors, UpdateSourceRateResponses, UpdateSupplierRateData, UpdateSupplierRateErrors, UpdateSupplierRateResponses, UpdateTableRowData, UpdateTableRowErrors, UpdateTableRowResponses, UpdateTaskScheduleData, UpdateTaskScheduleErrors, UpdateTaskScheduleResponses, UpdateUserData, UpdateUserErrors, UpdateUserMeData, UpdateUserMeErrors, UpdateUserMeResponses, UpdateUserPartnerData, UpdateUserPartnerErrors, UpdateUserPartnerResponses, UpdateUserResponses, UpdateVehGroupData, UpdateVehGroupErrors, UpdateVehGroupResponses, UpdateWorkflowData, UpdateWorkflowErrors, UpdateWorkflowRateConfigData, UpdateWorkflowRateConfigErrors, UpdateWorkflowRateConfigResponses, UpdateWorkflowResponses, UploadCallAnalysisData, UploadCallAnalysisErrors, UploadCallAnalysisResponses, UploadEdgeCsvData, UploadEdgeCsvErrors, UploadEdgeCsvResponses, UploadFilesData, UploadFilesErrors, UploadFilesResponses, UpsertCallAuditConfigEndpointData, UpsertCallAuditConfigEndpointErrors, UpsertCallAuditConfigEndpointResponses, UtilsGetGrafanaMcpContextData, UtilsGetGrafanaMcpContextErrors, UtilsGetGrafanaMcpContextResponses, ValidateOtpData, ValidateOtpErrors, ValidateOtpResponses, ValidateSettingByKeyData, ValidateSettingByKeyErrors, ValidateSettingByKeyResponses, WyseaiClearBrandingLogoData, WyseaiClearBrandingLogoErrors, WyseaiClearBrandingLogoResponses, WyseaiDownloadBatchOutputData, WyseaiDownloadBatchOutputErrors, WyseaiDownloadBatchOutputResponses, WyseaiDownloadGtaReportData, WyseaiDownloadGtaReportErrors, WyseaiDownloadGtaReportResponses, WyseaiDownloadQuoteCheckData, WyseaiDownloadQuoteCheckErrors, WyseaiDownloadQuoteCheckResponses, WyseaiListAuditBatchesData, WyseaiListAuditBatchesErrors, WyseaiListAuditBatchesResponses, WyseaiListAuditedCallsData, WyseaiListAuditedCallsErrors, WyseaiListAuditedCallsResponses, WyseaiListAvailableReportsData, WyseaiListAvailableReportsErrors, WyseaiListAvailableReportsResponses, WyseaiListClaimsData, WyseaiListClaimsErrors, WyseaiListClaimsResponses, WyseaiListGtaReferralsData, WyseaiListGtaReferralsErrors, WyseaiListGtaReferralsResponses, WyseaiListPartnerRunsData, WyseaiListPartnerRunsErrors, WyseaiListPartnerRunsResponses, WyseaiListPartnersData, WyseaiListPartnersResponses, WyseaiListQuoteChecksData, WyseaiListQuoteChecksErrors, WyseaiListQuoteChecksResponses, WyseaiListTeamData, WyseaiListTeamErrors, WyseaiListTeamResponses, WyseaiListWorkflowsData, WyseaiListWorkflowsErrors, WyseaiListWorkflowsResponses, WyseaiParseQuoteCheckEmailData, WyseaiParseQuoteCheckEmailErrors, WyseaiParseQuoteCheckEmailResponses, WyseaiReadAuditBatchData, WyseaiReadAuditBatchErrors, WyseaiReadAuditBatchResponses, WyseaiReadAuditedCallData, WyseaiReadAuditedCallErrors, WyseaiReadAuditedCallResponses, WyseaiReadBootstrapData, WyseaiReadBootstrapErrors, WyseaiReadBootstrapResponses, WyseaiReadBrandingData, WyseaiReadBrandingErrors, WyseaiReadBrandingResponses, WyseaiReadClaimData, WyseaiReadClaimErrors, WyseaiReadClaimResponses, WyseaiReadCostsData, WyseaiReadCostsErrors, WyseaiReadCostsResponses, WyseaiReadDashboardSummaryData, WyseaiReadDashboardSummaryErrors, WyseaiReadDashboardSummaryResponses, WyseaiReadGtaReferralData, WyseaiReadGtaReferralErrors, WyseaiReadGtaReferralResponses, WyseaiReadHomeSummaryData, WyseaiReadHomeSummaryErrors, WyseaiReadHomeSummaryResponses, WyseaiReadPartnerEntitlementsData, WyseaiReadPartnerEntitlementsErrors, WyseaiReadPartnerEntitlementsResponses, WyseaiReadPartnerLogoData, WyseaiReadPartnerLogoErrors, WyseaiReadPartnerLogoResponses, WyseaiReadPartnerRunData, WyseaiReadPartnerRunErrors, WyseaiReadPartnerRunResponses, WyseaiReadQuoteCheckData, WyseaiReadQuoteCheckErrors, WyseaiReadQuoteCheckResponses, WyseaiReadReportEmbedData, WyseaiReadReportEmbedErrors, WyseaiReadReportEmbedResponses, WyseaiReadWorkflowData, WyseaiReadWorkflowErrors, WyseaiReadWorkflowResponses, WyseaiRemoveCapabilitiesData, WyseaiRemoveCapabilitiesErrors, WyseaiRemoveCapabilitiesResponses, WyseaiRerunAuditBatchData, WyseaiRerunAuditBatchErrors, WyseaiRerunAuditBatchResponses, WyseaiSetBrandingData, WyseaiSetBrandingErrors, WyseaiSetBrandingLogoData, WyseaiSetBrandingLogoErrors, WyseaiSetBrandingLogoResponses, WyseaiSetBrandingResponses, WyseaiSetCapabilitiesData, WyseaiSetCapabilitiesErrors, WyseaiSetCapabilitiesResponses, WyseaiSubmitAuditBatchData, WyseaiSubmitAuditBatchErrors, WyseaiSubmitAuditBatchResponses, WyseaiSubmitQuoteCheckData, WyseaiSubmitQuoteCheckErrors, WyseaiSubmitQuoteCheckResponses, WyseaiTransportAdjustStopOrderData, WyseaiTransportAdjustStopOrderErrors, WyseaiTransportAdjustStopOrderResponses, WyseaiTransportApprovePlanData, WyseaiTransportApprovePlanErrors, WyseaiTransportApprovePlanResponses, WyseaiTransportCreateDriverData, WyseaiTransportCreateDriverErrors, WyseaiTransportCreateDriverResponses, WyseaiTransportCreateJobData, WyseaiTransportCreateJobErrors, WyseaiTransportCreateJobResponses, WyseaiTransportCreatePlanData, WyseaiTransportCreatePlanErrors, WyseaiTransportCreatePlanResponses, WyseaiTransportCreateVanData, WyseaiTransportCreateVanErrors, WyseaiTransportCreateVanResponses, WyseaiTransportCreateWarehouseData, WyseaiTransportCreateWarehouseErrors, WyseaiTransportCreateWarehouseResponses, WyseaiTransportDeleteDriverData, WyseaiTransportDeleteDriverErrors, WyseaiTransportDeleteDriverResponses, WyseaiTransportDeleteJobData, WyseaiTransportDeleteJobErrors, WyseaiTransportDeleteJobResponses, WyseaiTransportDeleteVanData, WyseaiTransportDeleteVanErrors, WyseaiTransportDeleteVanResponses, WyseaiTransportImportJobsData, WyseaiTransportImportJobsErrors, WyseaiTransportImportJobsResponses, WyseaiTransportListDriversData, WyseaiTransportListDriversErrors, WyseaiTransportListDriversResponses, WyseaiTransportListJobsData, WyseaiTransportListJobsErrors, WyseaiTransportListJobsResponses, WyseaiTransportListPlansData, WyseaiTransportListPlansErrors, WyseaiTransportListPlansResponses, WyseaiTransportListVansData, WyseaiTransportListVansErrors, WyseaiTransportListVansResponses, WyseaiTransportListWarehousesData, WyseaiTransportListWarehousesErrors, WyseaiTransportListWarehousesResponses, WyseaiTransportOptimizeRoutesData, WyseaiTransportOptimizeRoutesErrors, WyseaiTransportOptimizeRoutesResponses, WyseaiTransportReadItineraryData, WyseaiTransportReadItineraryErrors, WyseaiTransportReadItineraryResponses, WyseaiTransportReadPlanData, WyseaiTransportReadPlanErrors, WyseaiTransportReadPlanResponses, WyseaiTransportReadSettingsData, WyseaiTransportReadSettingsErrors, WyseaiTransportReadSettingsResponses, WyseaiTransportReadStartingLoadsData, WyseaiTransportReadStartingLoadsErrors, WyseaiTransportReadStartingLoadsResponses, WyseaiTransportReadWorkspaceData, WyseaiTransportReadWorkspaceErrors, WyseaiTransportReadWorkspaceResponses, WyseaiTransportReassignJobData, WyseaiTransportReassignJobErrors, WyseaiTransportReassignJobResponses, WyseaiTransportReoptimizeRoutesData, WyseaiTransportReoptimizeRoutesErrors, WyseaiTransportReoptimizeRoutesResponses, WyseaiTransportSavePlanVersionData, WyseaiTransportSavePlanVersionErrors, WyseaiTransportSavePlanVersionResponses, WyseaiTransportUpdateDriverData, WyseaiTransportUpdateDriverErrors, WyseaiTransportUpdateDriverResponses, WyseaiTransportUpdateJobData, WyseaiTransportUpdateJobErrors, WyseaiTransportUpdateJobResponses, WyseaiTransportUpdateSettingsData, WyseaiTransportUpdateSettingsErrors, WyseaiTransportUpdateSettingsResponses, WyseaiTransportUpdateVanData, WyseaiTransportUpdateVanErrors, WyseaiTransportUpdateVanResponses, WyseaiTransportUpdateWarehouseData, WyseaiTransportUpdateWarehouseErrors, WyseaiTransportUpdateWarehouseResponses, WyseaiTransportValidateJobAddressesData, WyseaiTransportValidateJobAddressesErrors, WyseaiTransportValidateJobAddressesResponses, WyseaiUpsertPartnerEntitlementData, WyseaiUpsertPartnerEntitlementErrors, WyseaiUpsertPartnerEntitlementResponses, XeroCallbackData, XeroCallbackErrors, XeroCallbackResponses, XeroLoginData, XeroLoginResponses, XeroLogoutData, XeroLogoutResponses, XeroSeedData, XeroSeedErrors, XeroSeedResponses, XeroStatusData, XeroStatusResponses, XeroWebhookData, XeroWebhookResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Login Access Token
 *
 * OAuth2 compatible token login, get an access token for future requests, set in an HttpOnly cookie.
 */
export const loginAccessToken = <ThrowOnError extends boolean = false>(options: Options<LoginAccessTokenData, ThrowOnError>): RequestResult<LoginAccessTokenResponses, LoginAccessTokenErrors, ThrowOnError> => (options.client ?? client).post<LoginAccessTokenResponses, LoginAccessTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    url: '/api/v1/login/access-token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Refresh Access Token
 *
 * Rotate refresh cookie and issue a new short-lived access cookie.
 *
 * Tokens are set via HttpOnly cookies only — not returned in the JSON body.
 */
export const refreshAccessToken = <ThrowOnError extends boolean = false>(options?: Options<RefreshAccessTokenData, ThrowOnError>): RequestResult<RefreshAccessTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RefreshAccessTokenResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/login/refresh',
    ...options
});

/**
 * Complete Session Handoff
 *
 * Exchange a one-time handoff token for auth cookies on the current host.
 */
export const completeSessionHandoff = <ThrowOnError extends boolean = false>(options: Options<CompleteSessionHandoffData, ThrowOnError>): RequestResult<CompleteSessionHandoffResponses, CompleteSessionHandoffErrors, ThrowOnError> => (options.client ?? client).get<CompleteSessionHandoffResponses, CompleteSessionHandoffErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/login/session-handoff/complete',
    ...options
});

/**
 * Logout
 *
 * Clear access/refresh cookies and invalidate server-side session allowlists.
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/logout/',
    ...options
});

/**
 * Check Auth
 *
 * Endpoint to verify if the user is authenticated based on the access token.
 */
export const checkAuth = <ThrowOnError extends boolean = false>(options?: Options<CheckAuthData, ThrowOnError>): RequestResult<CheckAuthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CheckAuthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/check-auth/',
    ...options
});

/**
 * Recover Password
 *
 * Password Recovery
 */
export const recoverPassword = <ThrowOnError extends boolean = false>(options: Options<RecoverPasswordData, ThrowOnError>): RequestResult<RecoverPasswordResponses, RecoverPasswordErrors, ThrowOnError> => (options.client ?? client).post<RecoverPasswordResponses, RecoverPasswordErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/password-recovery/{email}',
    ...options
});

/**
 * Reset Password
 *
 * Reset password
 *
 * SECURITY FIX (AUTH-VULN-06): Token replay prevention - each token can only be used once.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/reset-password/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recover Password Html Content
 *
 * HTML Content for Password Recovery
 */
export const recoverPasswordHtmlContent = <ThrowOnError extends boolean = false>(options: Options<RecoverPasswordHtmlContentData, ThrowOnError>): RequestResult<RecoverPasswordHtmlContentResponses, RecoverPasswordHtmlContentErrors, ThrowOnError> => (options.client ?? client).post<RecoverPasswordHtmlContentResponses, RecoverPasswordHtmlContentErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/password-recovery-html-content/{email}',
    ...options
});

/**
 * Start Session Handoff
 *
 * Create a one-time handoff token and redirect to the target portal host.
 */
export const startSessionHandoff = <ThrowOnError extends boolean = false>(options: Options<StartSessionHandoffData, ThrowOnError>): RequestResult<StartSessionHandoffResponses, StartSessionHandoffErrors, ThrowOnError> => (options.client ?? client).get<StartSessionHandoffResponses, StartSessionHandoffErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/login/session-handoff/start',
    ...options
});

/**
 * Flower Auth
 *
 * Traefik ForwardAuth gate for the Flower Celery dashboard.
 *
 * Restricted to System Administrators so supplier/partner users cannot view
 * task queues, broker credentials, or cross-tenant task payloads.
 */
export const flowerAuth = <ThrowOnError extends boolean = false>(options?: Options<FlowerAuthData, ThrowOnError>): RequestResult<FlowerAuthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FlowerAuthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/flower-auth/',
    ...options
});

/**
 * Get Csrf Token
 *
 * Generate and return a CSRF token for frontend forms.
 * The token is also set as a cookie for double submit protection.
 */
export const getCsrfToken = <ThrowOnError extends boolean = false>(options?: Options<GetCsrfTokenData, ThrowOnError>): RequestResult<GetCsrfTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCsrfTokenResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/csrf-token/',
    ...options
});

/**
 * Set Active Brand Me
 *
 * Set httpOnly cookie for active product brand (wysehub | aiclaims).
 */
export const setActiveBrandMe = <ThrowOnError extends boolean = false>(options: Options<SetActiveBrandMeData, ThrowOnError>): RequestResult<SetActiveBrandMeResponses, SetActiveBrandMeErrors, ThrowOnError> => (options.client ?? client).post<SetActiveBrandMeResponses, SetActiveBrandMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me/active-brand',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read My Partners
 *
 * Partners the caller may select as session current.
 *
 * Staff: ``User_Partner`` rows only. System Administrator: every partner.
 */
export const readMyPartners = <ThrowOnError extends boolean = false>(options?: Options<ReadMyPartnersData, ThrowOnError>): RequestResult<ReadMyPartnersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadMyPartnersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me/partners',
    ...options
});

/**
 * Set Current Partner Me
 *
 * Write the ``wyseai_partner`` session cookie.
 *
 * Staff: membership-bounded. System Administrator: any existing partner.
 * Not a grant. Does not mint a second cookie. SysAdmin preview stays on
 * ``previewPartnerId`` / ``wyseai_view_as``.
 */
export const setCurrentPartnerMe = <ThrowOnError extends boolean = false>(options: Options<SetCurrentPartnerMeData, ThrowOnError>): RequestResult<SetCurrentPartnerMeResponses, SetCurrentPartnerMeErrors, ThrowOnError> => (options.client ?? client).post<SetCurrentPartnerMeResponses, SetCurrentPartnerMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me/current-partner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Users
 *
 * Retrieve users.
 */
export const readUsers = <ThrowOnError extends boolean = false>(options?: Options<ReadUsersData, ThrowOnError>): RequestResult<ReadUsersResponses, ReadUsersErrors, ThrowOnError> => (options?.client ?? client).get<ReadUsersResponses, ReadUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/',
    ...options
});

/**
 * Create User
 *
 * Create new user.
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>): RequestResult<CreateUserResponses, CreateUserErrors, ThrowOnError> => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User Me
 *
 * Delete own user.
 */
export const deleteUserMe = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserMeData, ThrowOnError>): RequestResult<DeleteUserMeResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteUserMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me',
    ...options
});

/**
 * Read User Me
 *
 * Get current user information after successful login and OTP verification.
 * Requires a valid access token in the HttpOnly cookie.
 */
export const readUserMe = <ThrowOnError extends boolean = false>(options?: Options<ReadUserMeData, ThrowOnError>): RequestResult<ReadUserMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadUserMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me',
    ...options
});

/**
 * Update User Me
 *
 * Update own user.
 */
export const updateUserMe = <ThrowOnError extends boolean = false>(options: Options<UpdateUserMeData, ThrowOnError>): RequestResult<UpdateUserMeResponses, UpdateUserMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserMeResponses, UpdateUserMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Password Me
 *
 * Update own password.
 */
export const updatePasswordMe = <ThrowOnError extends boolean = false>(options: Options<UpdatePasswordMeData, ThrowOnError>): RequestResult<UpdatePasswordMeResponses, UpdatePasswordMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePasswordMeResponses, UpdatePasswordMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Profile Image Me
 *
 * Remove your own profile image, falling back to initials.
 */
export const clearProfileImageMe = <ThrowOnError extends boolean = false>(options?: Options<ClearProfileImageMeData, ThrowOnError>): RequestResult<ClearProfileImageMeResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<ClearProfileImageMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me/profile-image',
    ...options
});

/**
 * Read Profile Image Me
 *
 * Your own profile image bytes, or 404 when you have not set one.
 *
 * 404 rather than a placeholder: the caller is a client deciding whether to render
 * an image at all, and a 200 carrying a default would make "no image" and "an image
 * that happens to look like our fallback" indistinguishable.
 */
export const readProfileImageMe = <ThrowOnError extends boolean = false>(options?: Options<ReadProfileImageMeData, ThrowOnError>): RequestResult<ReadProfileImageMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadProfileImageMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/me/profile-image',
    ...options
});

/**
 * Set Profile Image Me
 *
 * Upload your own profile image, replacing any previous one.
 *
 * Self-scoped, and that is the whole authorization story: `CurrentUser` is the only
 * subject, so unlike the partner logo there is no partner to resolve and no
 * capability to check. A user may always change their own picture.
 *
 * Stored in the same bucket as call recordings and cleanse reports, under an
 * `avatars/user-<id>/` prefix, and served back through the application rather than
 * made public — the bucket holds partner audio and claim documents, and a profile
 * image is not reason enough to change that.
 *
 * Put synchronously rather than through `upload_file_to_spaces`: that task is
 * referral-scoped and creates an `Upload` row, neither of which fits an avatar, and
 * someone watching a picker needs the answer now rather than a task id.
 */
export const setProfileImageMe = <ThrowOnError extends boolean = false>(options: Options<SetProfileImageMeData, ThrowOnError>): RequestResult<SetProfileImageMeResponses, SetProfileImageMeErrors, ThrowOnError> => (options.client ?? client).put<SetProfileImageMeResponses, SetProfileImageMeErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/users/me/profile-image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Register User
 *
 * Create new user without the need to be logged in.
 */
export const registerUser = <ThrowOnError extends boolean = false>(options: Options<RegisterUserData, ThrowOnError>): RequestResult<RegisterUserResponses, RegisterUserErrors, ThrowOnError> => (options.client ?? client).post<RegisterUserResponses, RegisterUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Service Accounts
 */
export const readServiceAccounts = <ThrowOnError extends boolean = false>(options?: Options<ReadServiceAccountsData, ThrowOnError>): RequestResult<ReadServiceAccountsResponses, ReadServiceAccountsErrors, ThrowOnError> => (options?.client ?? client).get<ReadServiceAccountsResponses, ReadServiceAccountsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/service-accounts',
    ...options
});

/**
 * Create Service Account
 */
export const createServiceAccount = <ThrowOnError extends boolean = false>(options: Options<CreateServiceAccountData, ThrowOnError>): RequestResult<CreateServiceAccountResponses, CreateServiceAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateServiceAccountResponses, CreateServiceAccountErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/service-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 *
 * Delete a user.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>): RequestResult<DeleteUserResponses, DeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Read User By Id
 *
 * Get a specific user by id.
 *
 * SECURITY (AUTHZ-VULN-01): Users can only read their own profile
 * unless they are a System Administrator or have explicit permission.
 */
export const readUserById = <ThrowOnError extends boolean = false>(options: Options<ReadUserByIdData, ThrowOnError>): RequestResult<ReadUserByIdResponses, ReadUserByIdErrors, ThrowOnError> => (options.client ?? client).get<ReadUserByIdResponses, ReadUserByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Update User
 *
 * Update a user.
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Login History
 *
 * Retrieve login history for a specific user.
 */
export const getLoginHistory = <ThrowOnError extends boolean = false>(options: Options<GetLoginHistoryData, ThrowOnError>): RequestResult<GetLoginHistoryResponses, GetLoginHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetLoginHistoryResponses, GetLoginHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}/login-history',
    ...options
});

/**
 * Generate Api Key For User
 *
 * Generate and save an API key for a specific user.
 *
 * SECURITY (AUTHZ-VULN-03): Users can only generate API keys for themselves
 * unless they are a System Administrator.
 */
export const generateApiKeyForUser = <ThrowOnError extends boolean = false>(options: Options<GenerateApiKeyForUserData, ThrowOnError>): RequestResult<GenerateApiKeyForUserResponses, GenerateApiKeyForUserErrors, ThrowOnError> => (options.client ?? client).post<GenerateApiKeyForUserResponses, GenerateApiKeyForUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}/generate-api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Api Keys For User
 */
export const listApiKeysForUser = <ThrowOnError extends boolean = false>(options: Options<ListApiKeysForUserData, ThrowOnError>): RequestResult<ListApiKeysForUserResponses, ListApiKeysForUserErrors, ThrowOnError> => (options.client ?? client).get<ListApiKeysForUserResponses, ListApiKeysForUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}/api-keys',
    ...options
});

/**
 * Update Api Key For User
 */
export const updateApiKeyForUser = <ThrowOnError extends boolean = false>(options: Options<UpdateApiKeyForUserData, ThrowOnError>): RequestResult<UpdateApiKeyForUserResponses, UpdateApiKeyForUserErrors, ThrowOnError> => (options.client ?? client).patch<UpdateApiKeyForUserResponses, UpdateApiKeyForUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/users/{user_id}/api-keys/{api_key_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Email
 *
 * Test emails.
 */
export const testEmail = <ThrowOnError extends boolean = false>(options: Options<TestEmailData, ThrowOnError>): RequestResult<TestEmailResponses, TestEmailErrors, ThrowOnError> => (options.client ?? client).post<TestEmailResponses, TestEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/test-email/',
    ...options
});

/**
 * Csp Report
 */
export const cspReport = <ThrowOnError extends boolean = false>(options?: Options<CspReportData, ThrowOnError>): RequestResult<CspReportResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CspReportResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/csp-report/',
    ...options
});

/**
 * Internal Health Check
 */
export const internalHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<InternalHealthCheckData, ThrowOnError>): RequestResult<InternalHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InternalHealthCheckResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/health',
    ...options
});

/**
 * Connection Status
 *
 * Get database connection pool status and active connections
 */
export const connectionStatus = <ThrowOnError extends boolean = false>(options?: Options<ConnectionStatusData, ThrowOnError>): RequestResult<ConnectionStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConnectionStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/connection-status',
    ...options
});

/**
 * Metrics
 *
 * Expose Prometheus metrics endpoint.
 * This endpoint is used by Prometheus to scrape metrics from the application.
 */
export const metrics = <ThrowOnError extends boolean = false>(options?: Options<MetricsData, ThrowOnError>): RequestResult<MetricsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MetricsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/metrics',
    ...options
});

/**
 * Get Grafana Mcp Context
 *
 * Fetch monitoring data from Grafana for Model Context Protocol (MCP).
 * This function provides monitoring data in a format that conforms to the Model Context Protocol.
 *
 * Returns:
 * Dict[str, Any]: A dictionary containing monitoring data in MCP format
 */
export const utilsGetGrafanaMcpContext = <ThrowOnError extends boolean = false>(options?: Options<UtilsGetGrafanaMcpContextData, ThrowOnError>): RequestResult<UtilsGetGrafanaMcpContextResponses, UtilsGetGrafanaMcpContextErrors, ThrowOnError> => (options?.client ?? client).get<UtilsGetGrafanaMcpContextResponses, UtilsGetGrafanaMcpContextErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/grafanamcp',
    ...options
});

/**
 * Sms Handler
 *
 * Handle incoming SMS messages from Twilio.
 *
 * This endpoint:
 * 1. Receives SMS messages sent via Twilio
 * 2. Extracts the sender's phone number
 * 3. Looks up the number in the client phone numbers in the claim table
 * 4. Forwards the message to info@wysehub.co.uk
 * 5. Responds with a thank you message
 *
 * Returns:
 * Response: A TwiML response with a thank you message
 */
export const smsHandler = <ThrowOnError extends boolean = false>(options?: Options<SmsHandlerData, ThrowOnError>): RequestResult<SmsHandlerResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SmsHandlerResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/utils/sms/',
    ...options
});

/**
 * List Agent Runs
 */
export const listAgentRuns = <ThrowOnError extends boolean = false>(options?: Options<ListAgentRunsData, ThrowOnError>): RequestResult<ListAgentRunsResponses, ListAgentRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListAgentRunsResponses, ListAgentRunsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/agent-runs/',
    ...options
});

/**
 * Get Agent Run Summary
 */
export const getAgentRunSummary = <ThrowOnError extends boolean = false>(options?: Options<GetAgentRunSummaryData, ThrowOnError>): RequestResult<GetAgentRunSummaryResponses, GetAgentRunSummaryErrors, ThrowOnError> => (options?.client ?? client).get<GetAgentRunSummaryResponses, GetAgentRunSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/agent-runs/summary',
    ...options
});

/**
 * Get Agent Run
 */
export const getAgentRun = <ThrowOnError extends boolean = false>(options: Options<GetAgentRunData, ThrowOnError>): RequestResult<GetAgentRunResponses, GetAgentRunErrors, ThrowOnError> => (options.client ?? client).get<GetAgentRunResponses, GetAgentRunErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/agent-runs/{run_id}',
    ...options
});

/**
 * Get Aiclaims Dashboard Summary
 */
export const getAiclaimsDashboardSummary = <ThrowOnError extends boolean = false>(options?: Options<GetAiclaimsDashboardSummaryData, ThrowOnError>): RequestResult<GetAiclaimsDashboardSummaryResponses, GetAiclaimsDashboardSummaryErrors, ThrowOnError> => (options?.client ?? client).get<GetAiclaimsDashboardSummaryResponses, GetAiclaimsDashboardSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/dashboard-summary',
    ...options
});

/**
 * Get Aiclaims Workflow Cards
 */
export const getAiclaimsWorkflowCards = <ThrowOnError extends boolean = false>(options?: Options<GetAiclaimsWorkflowCardsData, ThrowOnError>): RequestResult<GetAiclaimsWorkflowCardsResponses, GetAiclaimsWorkflowCardsErrors, ThrowOnError> => (options?.client ?? client).get<GetAiclaimsWorkflowCardsResponses, GetAiclaimsWorkflowCardsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/workflow-cards',
    ...options
});

/**
 * List Call Analysis Workflows
 */
export const listCallAnalysisWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListCallAnalysisWorkflowsData, ThrowOnError>): RequestResult<ListCallAnalysisWorkflowsResponses, ListCallAnalysisWorkflowsErrors, ThrowOnError> => (options?.client ?? client).get<ListCallAnalysisWorkflowsResponses, ListCallAnalysisWorkflowsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-analysis/workflows',
    ...options
});

/**
 * Upload Call Analysis
 */
export const uploadCallAnalysis = <ThrowOnError extends boolean = false>(options: Options<UploadCallAnalysisData, ThrowOnError>): RequestResult<UploadCallAnalysisResponses, UploadCallAnalysisErrors, ThrowOnError> => (options.client ?? client).post<UploadCallAnalysisResponses, UploadCallAnalysisErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/aiclaims/call-analysis/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Call Analysis Jobs
 */
export const listCallAnalysisJobs = <ThrowOnError extends boolean = false>(options?: Options<ListCallAnalysisJobsData, ThrowOnError>): RequestResult<ListCallAnalysisJobsResponses, ListCallAnalysisJobsErrors, ThrowOnError> => (options?.client ?? client).get<ListCallAnalysisJobsResponses, ListCallAnalysisJobsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-analysis/jobs',
    ...options
});

/**
 * Get Call Analysis Job
 */
export const getCallAnalysisJob = <ThrowOnError extends boolean = false>(options: Options<GetCallAnalysisJobData, ThrowOnError>): RequestResult<GetCallAnalysisJobResponses, GetCallAnalysisJobErrors, ThrowOnError> => (options.client ?? client).get<GetCallAnalysisJobResponses, GetCallAnalysisJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-analysis/jobs/{job_id}',
    ...options
});

/**
 * Submit Call Analysis Job
 *
 * Queue a transcribed job into the aiclaims intake pipeline for a given workflow.
 */
export const submitCallAnalysisJob = <ThrowOnError extends boolean = false>(options: Options<SubmitCallAnalysisJobData, ThrowOnError>): RequestResult<SubmitCallAnalysisJobResponses, SubmitCallAnalysisJobErrors, ThrowOnError> => (options.client ?? client).post<SubmitCallAnalysisJobResponses, SubmitCallAnalysisJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-analysis/jobs/{job_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Audit Batch Endpoint
 */
export const auditBatchEndpoint = <ThrowOnError extends boolean = false>(options: Options<AuditBatchEndpointData, ThrowOnError>): RequestResult<AuditBatchEndpointResponses, AuditBatchEndpointErrors, ThrowOnError> => (options.client ?? client).post<AuditBatchEndpointResponses, AuditBatchEndpointErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/aiclaims/call-auditing/audit/batch',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Audit Rerun Endpoint
 */
export const auditRerunEndpoint = <ThrowOnError extends boolean = false>(options: Options<AuditRerunEndpointData, ThrowOnError>): RequestResult<AuditRerunEndpointResponses, AuditRerunEndpointErrors, ThrowOnError> => (options.client ?? client).post<AuditRerunEndpointResponses, AuditRerunEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-auditing/audit/rerun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Audit Batch Endpoint
 */
export const getAuditBatchEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetAuditBatchEndpointData, ThrowOnError>): RequestResult<GetAuditBatchEndpointResponses, GetAuditBatchEndpointErrors, ThrowOnError> => (options.client ?? client).get<GetAuditBatchEndpointResponses, GetAuditBatchEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-auditing/audit/batch/{batch_id}',
    ...options
});

/**
 * List Audit Batches Endpoint
 */
export const listAuditBatchesEndpoint = <ThrowOnError extends boolean = false>(options?: Options<ListAuditBatchesEndpointData, ThrowOnError>): RequestResult<ListAuditBatchesEndpointResponses, ListAuditBatchesEndpointErrors, ThrowOnError> => (options?.client ?? client).get<ListAuditBatchesEndpointResponses, ListAuditBatchesEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-auditing/audit/batches',
    ...options
});

/**
 * Download Call Audit Output
 *
 * Stream a rendered call-audit output (pdf/csv/xlsx) for a run/batch.
 */
export const downloadCallAuditOutput = <ThrowOnError extends boolean = false>(options: Options<DownloadCallAuditOutputData, ThrowOnError>): RequestResult<DownloadCallAuditOutputResponses, DownloadCallAuditOutputErrors, ThrowOnError> => (options.client ?? client).get<DownloadCallAuditOutputResponses, DownloadCallAuditOutputErrors, ThrowOnError>({ url: '/api/v1/aiclaims/call-auditing/audit/{run_id}/download', ...options });

/**
 * Get Call Audit Config Endpoint
 *
 * Get the per-partner call-audit binding (review agent + report template).
 */
export const getCallAuditConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetCallAuditConfigEndpointData, ThrowOnError>): RequestResult<GetCallAuditConfigEndpointResponses, GetCallAuditConfigEndpointErrors, ThrowOnError> => (options.client ?? client).get<GetCallAuditConfigEndpointResponses, GetCallAuditConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-auditing/config',
    ...options
});

/**
 * Upsert Call Audit Config Endpoint
 *
 * Create or update the per-partner call-audit binding. Superuser only.
 */
export const upsertCallAuditConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpsertCallAuditConfigEndpointData, ThrowOnError>): RequestResult<UpsertCallAuditConfigEndpointResponses, UpsertCallAuditConfigEndpointErrors, ThrowOnError> => (options.client ?? client).put<UpsertCallAuditConfigEndpointResponses, UpsertCallAuditConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/call-auditing/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Prompt
 *
 * Generate an editable AI prompt draft payload from admin intent.
 */
export const generatePrompt = <ThrowOnError extends boolean = false>(options: Options<GeneratePromptData, ThrowOnError>): RequestResult<GeneratePromptResponses, GeneratePromptErrors, ThrowOnError> => (options.client ?? client).post<GeneratePromptResponses, GeneratePromptErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/workflow-builder/generate-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Workflow
 *
 * Generate editable workflow_definition JSON from prompt metadata.
 */
export const generateWorkflow = <ThrowOnError extends boolean = false>(options: Options<GenerateWorkflowData, ThrowOnError>): RequestResult<GenerateWorkflowResponses, GenerateWorkflowErrors, ThrowOnError> => (options.client ?? client).post<GenerateWorkflowResponses, GenerateWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/workflow-builder/generate-workflow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Output
 *
 * Generate editable ReportTemplate content for workflow output.
 */
export const generateOutput = <ThrowOnError extends boolean = false>(options: Options<GenerateOutputData, ThrowOnError>): RequestResult<GenerateOutputResponses, GenerateOutputErrors, ThrowOnError> => (options.client ?? client).post<GenerateOutputResponses, GenerateOutputErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/workflow-builder/generate-output',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Commit Workflow
 *
 * Create live prompt/workflow/template artifacts and a disabled schedule.
 */
export const commitWorkflow = <ThrowOnError extends boolean = false>(options: Options<CommitWorkflowData, ThrowOnError>): RequestResult<CommitWorkflowResponses, CommitWorkflowErrors, ThrowOnError> => (options.client ?? client).post<CommitWorkflowResponses, CommitWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/workflow-builder/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Gta Referral Snapshot
 *
 * Return the working GTA date snapshot for a referral (search via /referrals/table).
 */
export const getGtaReferralSnapshot = <ThrowOnError extends boolean = false>(options: Options<GetGtaReferralSnapshotData, ThrowOnError>): RequestResult<GetGtaReferralSnapshotResponses, GetGtaReferralSnapshotErrors, ThrowOnError> => (options.client ?? client).get<GetGtaReferralSnapshotResponses, GetGtaReferralSnapshotErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/gta/referrals/{referral_id}',
    ...options
});

/**
 * Patch Gta Referral Field
 *
 * Correct one GTA field, append history, and record feedback (rating=down).
 */
export const patchGtaReferralField = <ThrowOnError extends boolean = false>(options: Options<PatchGtaReferralFieldData, ThrowOnError>): RequestResult<PatchGtaReferralFieldResponses, PatchGtaReferralFieldErrors, ThrowOnError> => (options.client ?? client).patch<PatchGtaReferralFieldResponses, PatchGtaReferralFieldErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/gta/referrals/{referral_id}/fields/{field_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Gta Referral History
 *
 * Return correction history for a referral.
 */
export const getGtaReferralHistory = <ThrowOnError extends boolean = false>(options: Options<GetGtaReferralHistoryData, ThrowOnError>): RequestResult<GetGtaReferralHistoryResponses, GetGtaReferralHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetGtaReferralHistoryResponses, GetGtaReferralHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/gta/referrals/{referral_id}/history',
    ...options
});

/**
 * List Gta Referral Reports
 *
 * List GTA cleanse PDF reports for a referral (newest first).
 */
export const listGtaReferralReports = <ThrowOnError extends boolean = false>(options: Options<ListGtaReferralReportsData, ThrowOnError>): RequestResult<ListGtaReferralReportsResponses, ListGtaReferralReportsErrors, ThrowOnError> => (options.client ?? client).get<ListGtaReferralReportsResponses, ListGtaReferralReportsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/gta/referrals/{referral_id}/reports',
    ...options
});

/**
 * Download Gta Referral Report
 *
 * Download a GTA cleanse PDF (aiclaims_gta read; upload must be a GTA report).
 */
export const downloadGtaReferralReport = <ThrowOnError extends boolean = false>(options: Options<DownloadGtaReferralReportData, ThrowOnError>): RequestResult<DownloadGtaReferralReportResponses, DownloadGtaReferralReportErrors, ThrowOnError> => (options.client ?? client).get<DownloadGtaReferralReportResponses, DownloadGtaReferralReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/aiclaims/gta/referrals/{referral_id}/reports/{upload_id}/download',
    ...options
});

/**
 * Get Run Inspection
 *
 * Get aggregated run inspection data for a referral:
 * - All agent_runs for the referral (timeline)
 * - All claim summaries for the referral
 * - Workflow definition if workflow_id exists on claim summary or agent run
 * - Optional from_date/to_date filter on started_at and created_datetime
 */
export const getRunInspection = <ThrowOnError extends boolean = false>(options: Options<GetRunInspectionData, ThrowOnError>): RequestResult<GetRunInspectionResponses, GetRunInspectionErrors, ThrowOnError> => (options.client ?? client).get<GetRunInspectionResponses, GetRunInspectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/run-inspector/referral/{referral_id}',
    ...options
});

/**
 * List Registered Workflow Engines
 *
 * List workflow engines available for engine steps (remote registry).
 */
export const listRegisteredWorkflowEngines = <ThrowOnError extends boolean = false>(options?: Options<ListRegisteredWorkflowEnginesData, ThrowOnError>): RequestResult<ListRegisteredWorkflowEnginesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListRegisteredWorkflowEnginesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/engines',
    ...options
});

/**
 * List Workflows
 *
 * List all workflow definitions, optionally filtered by status.
 */
export const listWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowsData, ThrowOnError>): RequestResult<ListWorkflowsResponses, ListWorkflowsErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkflowsResponses, ListWorkflowsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/',
    ...options
});

/**
 * Create Workflow
 *
 * Create a new workflow definition row.
 */
export const createWorkflow = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowData, ThrowOnError>): RequestResult<CreateWorkflowResponses, CreateWorkflowErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkflowResponses, CreateWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Workflow
 *
 * Get a single workflow by ID.
 */
export const getWorkflow = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowData, ThrowOnError>): RequestResult<GetWorkflowResponses, GetWorkflowErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowResponses, GetWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/{workflow_id}',
    ...options
});

/**
 * Update Workflow
 *
 * Update a workflow's definition in place.
 */
export const updateWorkflow = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowData, ThrowOnError>): RequestResult<UpdateWorkflowResponses, UpdateWorkflowErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWorkflowResponses, UpdateWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/{workflow_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clone Workflow
 *
 * Clone a workflow to a partner override or the default scope.
 */
export const cloneWorkflow = <ThrowOnError extends boolean = false>(options: Options<CloneWorkflowData, ThrowOnError>): RequestResult<CloneWorkflowResponses, CloneWorkflowErrors, ThrowOnError> => (options.client ?? client).post<CloneWorkflowResponses, CloneWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/{workflow_id}/clone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Workflow On Claim
 *
 * Run this workflow on a referral. Dispatches the selected workflow audit scope.
 * Returns task_id for polling; user can use Run Inspector to see results.
 */
export const testWorkflowOnClaim = <ThrowOnError extends boolean = false>(options: Options<TestWorkflowOnClaimData, ThrowOnError>): RequestResult<TestWorkflowOnClaimResponses, TestWorkflowOnClaimErrors, ThrowOnError> => (options.client ?? client).post<TestWorkflowOnClaimResponses, TestWorkflowOnClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/{workflow_id}/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Compare Workflows
 *
 * Run two workflows on the same referral for side-by-side comparison.
 * Returns task_id_a and task_id_b for polling.
 */
export const compareWorkflows = <ThrowOnError extends boolean = false>(options: Options<CompareWorkflowsData, ThrowOnError>): RequestResult<CompareWorkflowsResponses, CompareWorkflowsErrors, ThrowOnError> => (options.client ?? client).post<CompareWorkflowsResponses, CompareWorkflowsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-definitions/compare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Workflow Billing Events
 */
export const listWorkflowBillingEvents = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowBillingEventsData, ThrowOnError>): RequestResult<ListWorkflowBillingEventsResponses, ListWorkflowBillingEventsErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkflowBillingEventsResponses, ListWorkflowBillingEventsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-billing/',
    ...options
});

/**
 * Get Events For Billing Period
 *
 * Return all pending billing events for a given month, suitable for invoice generation.
 */
export const getEventsForBillingPeriod = <ThrowOnError extends boolean = false>(options: Options<GetEventsForBillingPeriodData, ThrowOnError>): RequestResult<GetEventsForBillingPeriodResponses, GetEventsForBillingPeriodErrors, ThrowOnError> => (options.client ?? client).get<GetEventsForBillingPeriodResponses, GetEventsForBillingPeriodErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-billing/for-period',
    ...options
});

/**
 * Get Workflow Billing Event By Id
 */
export const getWorkflowBillingEventById = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowBillingEventByIdData, ThrowOnError>): RequestResult<GetWorkflowBillingEventByIdResponses, GetWorkflowBillingEventByIdErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowBillingEventByIdResponses, GetWorkflowBillingEventByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-billing/{event_id}',
    ...options
});

/**
 * Patch Workflow Billing Event
 *
 * Update status or invoice_id on a billing event (e.g. mark as excluded/capped).
 */
export const patchWorkflowBillingEvent = <ThrowOnError extends boolean = false>(options: Options<PatchWorkflowBillingEventData, ThrowOnError>): RequestResult<PatchWorkflowBillingEventResponses, PatchWorkflowBillingEventErrors, ThrowOnError> => (options.client ?? client).patch<PatchWorkflowBillingEventResponses, PatchWorkflowBillingEventErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-billing/{event_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Billing Events Billed
 *
 * Mark a set of billing events (by task_id) as billed and associate an invoice.
 */
export const markBillingEventsBilled = <ThrowOnError extends boolean = false>(options: Options<MarkBillingEventsBilledData, ThrowOnError>): RequestResult<MarkBillingEventsBilledResponses, MarkBillingEventsBilledErrors, ThrowOnError> => (options.client ?? client).post<MarkBillingEventsBilledResponses, MarkBillingEventsBilledErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/workflow-billing/mark-billed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Partners
 *
 * Retrieve partners.
 */
export const readPartners = <ThrowOnError extends boolean = false>(options?: Options<ReadPartnersData, ThrowOnError>): RequestResult<ReadPartnersResponses, ReadPartnersErrors, ThrowOnError> => (options?.client ?? client).get<ReadPartnersResponses, ReadPartnersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partners/',
    ...options
});

/**
 * Create Partner
 *
 * Create new partner.
 */
export const createPartner = <ThrowOnError extends boolean = false>(options: Options<CreatePartnerData, ThrowOnError>): RequestResult<CreatePartnerResponses, CreatePartnerErrors, ThrowOnError> => (options.client ?? client).post<CreatePartnerResponses, CreatePartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partners/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Partner
 *
 * Delete an partner.
 */
export const deletePartner = <ThrowOnError extends boolean = false>(options: Options<DeletePartnerData, ThrowOnError>): RequestResult<DeletePartnerResponses, DeletePartnerErrors, ThrowOnError> => (options.client ?? client).delete<DeletePartnerResponses, DeletePartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partners/{id}',
    ...options
});

/**
 * Read Partner
 *
 * Get partner by ID.
 *
 * SECURITY (AUTHZ-VULN-04): Users can only read partners they are affiliated with
 * unless they are a System Administrator.
 */
export const readPartner = <ThrowOnError extends boolean = false>(options: Options<ReadPartnerData, ThrowOnError>): RequestResult<ReadPartnerResponses, ReadPartnerErrors, ThrowOnError> => (options.client ?? client).get<ReadPartnerResponses, ReadPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partners/{id}',
    ...options
});

/**
 * Update Partner
 *
 * Update a partner.
 *
 * SECURITY (AUTHZ-VULN-05): Users can only update partners they are affiliated with
 * unless they are a System Administrator.
 */
export const updatePartner = <ThrowOnError extends boolean = false>(options: Options<UpdatePartnerData, ThrowOnError>): RequestResult<UpdatePartnerResponses, UpdatePartnerErrors, ThrowOnError> => (options.client ?? client).put<UpdatePartnerResponses, UpdatePartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partners/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read My Pages
 *
 * Return frontend page keys that the authenticated user can access.
 */
export const readMyPages = <ThrowOnError extends boolean = false>(options?: Options<ReadMyPagesData, ThrowOnError>): RequestResult<ReadMyPagesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadMyPagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/permissions/my-pages',
    ...options
});

/**
 * Read Permission Catalog
 *
 * Return dynamic endpoint and page permission catalog for matrix UIs.
 */
export const readPermissionCatalog = <ThrowOnError extends boolean = false>(options?: Options<ReadPermissionCatalogData, ThrowOnError>): RequestResult<ReadPermissionCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadPermissionCatalogResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/permissions/catalog',
    ...options
});

/**
 * Read Bootstrap
 *
 * Everything the WyseAi shell needs for one request, resolved server-side.
 *
 * Two partner notions, deliberately separate. The *active* partner is one of the
 * caller's own partners and is what any data read is scoped to. A *preview* partner is
 * a composition a platform admin is inspecting: it changes what the shell displays and
 * nothing about what data the caller can reach.
 */
export const wyseaiReadBootstrap = <ThrowOnError extends boolean = false>(options?: Options<WyseaiReadBootstrapData, ThrowOnError>): RequestResult<WyseaiReadBootstrapResponses, WyseaiReadBootstrapErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiReadBootstrapResponses, WyseaiReadBootstrapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/bootstrap',
    ...options
});

/**
 * List Wyseai Partners
 *
 * Partners and their enabled modules, for the platform-admin toggle surface.
 */
export const wyseaiListPartners = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListPartnersData, ThrowOnError>): RequestResult<WyseaiListPartnersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WyseaiListPartnersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partners',
    ...options
});

/**
 * Read Partner Entitlements
 *
 * Every stored entitlement row for one partner, enabled or not.
 */
export const wyseaiReadPartnerEntitlements = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadPartnerEntitlementsData, ThrowOnError>): RequestResult<WyseaiReadPartnerEntitlementsResponses, WyseaiReadPartnerEntitlementsErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadPartnerEntitlementsResponses, WyseaiReadPartnerEntitlementsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partners/{partner_id}/entitlements',
    ...options
});

/**
 * Upsert Partner Entitlement
 *
 * Enable, disable or reconfigure one module for one partner.
 *
 * Never deletes rows or data: disabling flips a flag so re-enabling restores the
 * previous state, and every change appends an audit event.
 */
export const wyseaiUpsertPartnerEntitlement = <ThrowOnError extends boolean = false>(options: Options<WyseaiUpsertPartnerEntitlementData, ThrowOnError>): RequestResult<WyseaiUpsertPartnerEntitlementResponses, WyseaiUpsertPartnerEntitlementErrors, ThrowOnError> => (options.client ?? client).put<WyseaiUpsertPartnerEntitlementResponses, WyseaiUpsertPartnerEntitlementErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partners/{partner_id}/entitlements/{module_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Home Summary
 *
 * A figure per module this partner has, for the cards on ``/app``.
 *
 * ``resolve_module_partner_id`` is deliberately not used. There is no entitlement row
 * for home — home is always on, which is what makes it the page that can say "you are
 * still being set up". The entitlement check happens per contributor instead, which is
 * the same check, made where it decides something.
 *
 * It does take the preview parameter, though: home is the first page a support engineer
 * lands on, and headline figures belonging to the previewer rather than the partner they
 * are looking at would be wrong in the most misleading way available — every label on
 * the page says the partner's name.
 */
export const wyseaiReadHomeSummary = <ThrowOnError extends boolean = false>(options?: Options<WyseaiReadHomeSummaryData, ThrowOnError>): RequestResult<WyseaiReadHomeSummaryResponses, WyseaiReadHomeSummaryErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiReadHomeSummaryResponses, WyseaiReadHomeSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/home/summary',
    ...options
});

/**
 * List Partner Runs
 *
 * One page of this partner's AI requests, newest first.
 *
 * Paginated in SQL rather than fetched whole and sliced in the app tier, unlike the
 * platform-admin partner list: this table holds tens of thousands of rows per
 * partner, which is well past the size where reading everything to show 25 of them
 * is honest.
 *
 * Sourced from two kinds of run — referral-linked and call-audit (see
 * ``_partner_run_scope``) — but from a single ``AgentRun``-only query: scoping,
 * filtering, ordering and pagination all happen in one pass over ``agent_runs``, with
 * ``Referral``/``Claim`` looked up afterwards only for the page's rows that have one
 * (``_referral_claim_lookup``). A call-audit row has no referral to inner-join
 * against, so joining it in up front — the previous approach — silently dropped
 * every one of them.
 */
export const wyseaiListPartnerRuns = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListPartnerRunsData, ThrowOnError>): RequestResult<WyseaiListPartnerRunsResponses, WyseaiListPartnerRunsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListPartnerRunsResponses, WyseaiListPartnerRunsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/request-log/runs',
    ...options
});

/**
 * Read Partner Run
 *
 * One request in full.
 *
 * A run outside this partner's scope is a 404 and not a 403: a 403 would confirm that
 * a run with that id exists, which for another partner's run is the thing not to say.
 */
export const wyseaiReadPartnerRun = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadPartnerRunData, ThrowOnError>): RequestResult<WyseaiReadPartnerRunResponses, WyseaiReadPartnerRunErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadPartnerRunResponses, WyseaiReadPartnerRunErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/request-log/runs/{run_id}',
    ...options
});

/**
 * Read Dashboard Summary
 *
 * Everything the dashboard shows, in one request.
 *
 * One round trip rather than a tile-per-endpoint: the page has no independent loading
 * states, so splitting it would buy nothing and leave seven guards to keep in step.
 *
 * ``resolve_module_partner_id`` is deliberately not used, the same way — and for the
 * same reason — ``read_home_summary`` does not use it: there is no entitlement row for
 * this any more, so neither can check one. The permission check follows the same
 * change: it asks whether the caller may open ``wyseai-home``, not a
 * ``wyseai-dashboard`` page key that no longer exists anywhere in this codebase.
 */
export const wyseaiReadDashboardSummary = <ThrowOnError extends boolean = false>(options?: Options<WyseaiReadDashboardSummaryData, ThrowOnError>): RequestResult<WyseaiReadDashboardSummaryResponses, WyseaiReadDashboardSummaryErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiReadDashboardSummaryResponses, WyseaiReadDashboardSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/dashboard/summary',
    ...options
});

/**
 * Read Costs
 *
 * Billed cost per month, newest first, with the usage behind it.
 *
 * The current month is reported as in progress: it is still accruing, and a partner
 * reading a part-month total as a bill would be misled.
 */
export const wyseaiReadCosts = <ThrowOnError extends boolean = false>(options?: Options<WyseaiReadCostsData, ThrowOnError>): RequestResult<WyseaiReadCostsResponses, WyseaiReadCostsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiReadCostsResponses, WyseaiReadCostsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/costs/periods',
    ...options
});

/**
 * List Available Reports
 *
 * Reports published to this partner. No token is minted here.
 */
export const wyseaiListAvailableReports = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListAvailableReportsData, ThrowOnError>): RequestResult<WyseaiListAvailableReportsResponses, WyseaiListAvailableReportsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListAvailableReportsResponses, WyseaiListAvailableReportsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/reports/available',
    ...options
});

/**
 * Read Report Embed
 *
 * A short-lived signed embed URL, locked to this partner.
 *
 * The partner parameter is stamped server-side from the resolved partner and cannot be
 * influenced by the caller — the whole point of a *locked* parameter is that the
 * browser holding the URL cannot widen what it shows.
 *
 * 404 rather than 403 for a report this partner does not have, consistent with the rest
 * of WyseAi: a 403 would confirm the report exists.
 */
export const wyseaiReadReportEmbed = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadReportEmbedData, ThrowOnError>): RequestResult<WyseaiReadReportEmbedResponses, WyseaiReadReportEmbedErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadReportEmbedResponses, WyseaiReadReportEmbedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/reports/{report_id}/embed',
    ...options
});

/**
 * List Audited Calls
 *
 * This partner's audited calls, newest first.
 */
export const wyseaiListAuditedCalls = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListAuditedCallsData, ThrowOnError>): RequestResult<WyseaiListAuditedCallsResponses, WyseaiListAuditedCallsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListAuditedCallsResponses, WyseaiListAuditedCallsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/call-auditing/calls',
    ...options
});

/**
 * Read Audited Call
 *
 * One audited call. 404 for another partner's, as everywhere else in WyseAi.
 */
export const wyseaiReadAuditedCall = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadAuditedCallData, ThrowOnError>): RequestResult<WyseaiReadAuditedCallResponses, WyseaiReadAuditedCallErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadAuditedCallResponses, WyseaiReadAuditedCallErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/call-auditing/calls/{call_id}',
    ...options
});

/**
 * Submit Audit Batch
 *
 * Submit a new call-audit batch: a quote PDF plus one or more call
 * recordings, transcribed and reviewed either immediately (`mode='run_now'`)
 * or queued for the overnight batch (`mode='queue'`, the default).
 *
 * Open to any user with Call Auditing module access — partner-admin and
 * partner-user alike, gated on ``dispatch`` rather than ``view`` (see
 * ``DISPATCH_OPERATION``) — because the legacy AiClaims precedent
 * (``run_audit``) is likewise granted to any role with dashboard access, not
 * admin-restricted. This is the first mutation in the entire ``wyseai/``
 * backend a plain partner user, not just a platform admin, can trigger.
 *
 * **No ``preview_partner_id`` parameter, deliberately** — every read endpoint
 * in this router (and every other WyseAi module) accepts one and threads it
 * into ``resolve_module_partner_id`` so a platform administrator can preview a
 * partner's data. This endpoint does not declare, accept, or consult one:
 * ``resolve_module_partner_id`` is called with no fourth argument, so its
 * ``preview_partner_id`` parameter keeps its default of ``None`` and can never
 * resolve to a previewed partner, no matter what a caller puts on the query
 * string — FastAPI drops undeclared query params before this function body
 * ever runs, so a crafted ``previewPartnerId`` is inert here by construction,
 * not by a runtime check that could be forgotten. This is the actual
 * property that keeps a platform administrator merely *previewing* a partner
 * from ever being able to kick off a real, billed transcription + LLM job
 * against that partner's account: preview is an inspection feature, not an
 * acting-as feature. A future maintainer who copy-pastes a sibling GET
 * endpoint's ``preview_partner_id: PreviewPartnerId = None`` parameter onto
 * this one would silently reopen exactly the hole this comment exists to
 * prevent — don't.
 *
 * Uploads are validated the same way, in the same order, with the same
 * limits and error messages as the legacy AiClaims endpoint (see
 * ``app.services.call_audit_batch``'s ``MAX_PDF_BYTES`` /
 * ``MAX_AUDIO_BYTES`` / ``ALLOWED_PDF_CONTENT_TYPES`` /
 * ``ALLOWED_AUDIO_CONTENT_TYPES``). ``partner_id`` is always
 * ``scope_partner_id`` — the caller's own resolved partner — never taken from
 * the request: unlike the legacy endpoint, which lets AiClaims staff submit
 * on behalf of any partner via a partner-supplied ``partner_id``, this WyseAi
 * endpoint has no staff-acting-for-a-partner concept, so there is nothing for
 * a request to legitimately override.
 */
export const wyseaiSubmitAuditBatch = <ThrowOnError extends boolean = false>(options: Options<WyseaiSubmitAuditBatchData, ThrowOnError>): RequestResult<WyseaiSubmitAuditBatchResponses, WyseaiSubmitAuditBatchErrors, ThrowOnError> => (options.client ?? client).post<WyseaiSubmitAuditBatchResponses, WyseaiSubmitAuditBatchErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/wyseai/call-auditing/audit/batch',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Audit Batches
 *
 * "Previous Runs": this partner's call-audit batches, newest first.
 *
 * One row per batch — the parent ``AgentRun`` only (``call_audit_parent_run_filter``,
 * never the ``::transcription``/``::review`` sibling rows a batch also writes) —
 * windowed to the last ``days`` (7/30/90, default 30, same convention as
 * ``wyseai/src/modules/dashboard/metrics.ts``'s ``RANGE_OPTIONS``/``DEFAULT_RANGE``)
 * and paginated the same SQL-side way ``list_audited_calls`` already is.
 * ``days=0`` drops the window; ``q`` matches reference, agent or submitter
 * (``wyseai_search.submitted_run_matches``) and narrows ``count`` too. A read,
 * so gated on ``view`` like every other endpoint in this router — ``dispatch`` is
 * only for starting a new batch.
 */
export const wyseaiListAuditBatches = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListAuditBatchesData, ThrowOnError>): RequestResult<WyseaiListAuditBatchesResponses, WyseaiListAuditBatchesErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListAuditBatchesResponses, WyseaiListAuditBatchesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/call-auditing/batches',
    ...options
});

/**
 * Read Audit Batch
 *
 * One call-audit batch — the "Previous Runs" list's own detail view.
 *
 * 404 for another partner's batch, same as every other single-row read in this
 * router (see ``read_audited_call``) — ``_find_partner_batch`` already makes "not
 * yours" and "doesn't exist" indistinguishable, so there is nothing further to
 * do here to preserve that.
 */
export const wyseaiReadAuditBatch = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadAuditBatchData, ThrowOnError>): RequestResult<WyseaiReadAuditBatchResponses, WyseaiReadAuditBatchErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadAuditBatchResponses, WyseaiReadAuditBatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/call-auditing/batches/{batch_id}',
    ...options
});

/**
 * Download Batch Output
 *
 * Stream one call-audit batch's transcript or a rendered report output.
 *
 * ``channel='transcript'`` streams the combined call transcript; any other
 * value is looked up in this batch's
 * ``run_metadata['storage_keys']['report_outputs']`` — the same channel keys
 * ``GET /batches`` echoes per row as ``reportChannels``. Same response shape
 * as the legacy AiClaims endpoint (``aiclaims_call_auditing.py``'s
 * ``download_call_audit_output``): raw bytes, the channel's own content
 * type, ``Content-Disposition: attachment`` with a
 * ``call-audit-<batchId>[-transcript].<ext>`` filename.
 *
 * Gated on ``download`` (bundled with ``view``/``dispatch`` — see
 * ``DOWNLOAD_OPERATION``), open to any user with Call Auditing access,
 * unlike ``POST /audit/rerun`` below. Honours ``previewPartnerId`` the normal
 * way, like every other read in this router — unlike ``submit_audit_batch``,
 * this is a read, not a dispatch, so preview's ordinary "look at a partner's
 * data" use is exactly what it is for here.
 */
export const wyseaiDownloadBatchOutput = <ThrowOnError extends boolean = false>(options: Options<WyseaiDownloadBatchOutputData, ThrowOnError>): RequestResult<WyseaiDownloadBatchOutputResponses, WyseaiDownloadBatchOutputErrors, ThrowOnError> => (options.client ?? client).get<WyseaiDownloadBatchOutputResponses, WyseaiDownloadBatchOutputErrors, ThrowOnError>({ url: '/api/v1/wyseai/call-auditing/audit/{batch_id}/download', ...options });

/**
 * Rerun Audit Batch
 *
 * Re-run a prior call-audit batch: reuse its transcript + quote PDF, skip
 * transcription, go straight to OCR + review.
 *
 * **Staff only, gated directly on ``is_wyseai_platform_admin`` — not a
 * ``check_permission``/``role_permission`` grant like every other
 * operation in this router.** Deliberately not folded into the existing
 * ``PermissionAction`` union (``wyseai/src/kernel/modules/types.ts``):
 * ``dispatch`` is documented there as "open to any user with the module, not
 * admin-restricted" — the wrong fit for a staff-only action — and ``manage``
 * is ``wyseai-partner-admin``'s own grant, a different capability for a
 * different thing. Extending that shared kernel type for one staff-only
 * action on one module would be a bigger, wider-blast-radius change than
 * this needs. Instead this mirrors the precedent already set for exactly
 * this shape elsewhere in WyseAi — a direct role check with a 403, no
 * partner-grantable path, no migration to seed: ``partner_admin.py``'s
 * and ``bootstrap.py``'s own ``_require_platform_admin`` helpers are the same
 * "raise 403 directly in the endpoint" shape this follows. (AI Logs
 * (``agent_runs.py``) reaches the *same* staff-only outcome for its
 * module as a whole, but by a different mechanism — omitting
 * ``wyseai-request-log`` from ``CAPABILITY_ROLE_BY_GRANT`` entirely so no
 * role can ever be granted it; the ``is_wyseai_platform_admin`` calls inside
 * that file gate individual *fields* on an otherwise partner-reachable
 * endpoint, not the endpoint itself, so it is not this endpoint's precedent.)
 * ``is_wyseai_platform_admin`` (not the legacy endpoint's
 * ``require_system_administrator``) is used deliberately: it is the
 * WyseAi-native staff check, and it is broader — it also admits the
 * ``WyseAi Platform Admin`` role, not only ``System Administrator``.
 *
 * **No ``previewPartnerId`` handling, unlike every read in this router:**
 * this endpoint is platform-admin-only by construction, and a platform
 * admin is already the actor preview exists to let act across partners —
 * unlike ``submit_audit_batch``, which needs preview-safety hardening
 * specifically because it is reachable by a plain partner user, there is no
 * equivalent hole here to close.
 *
 * **Deliberately does not pass `partner_id` to `create_rerun_batch`.** That
 * function accepts an optional caller-supplied owner — the legacy AiClaims
 * endpoint now resolves and passes the *runner's own* partner there, so a
 * re-run is attributed to whoever triggered it rather than the source
 * batch's tenant (a real ownership fix; see that function's own docstring).
 * WyseAi's re-run stays on the older shape on purpose: a platform admin
 * re-running a partner's batch is doing it *on that partner's behalf* — the
 * new batch should stay visible in that partner's own Workflows/Previous
 * Runs, not silently move into whatever partner the admin happens to be
 * scoped to (which, for a platform admin acting broadly, may be none at
 * all). Omitting `partner_id` here falls back to inheriting the *source*
 * batch's own partner — the first job's `partner_id` for an ordinary source
 * batch, or the source's own pinned `run_metadata['partner_id']` when the
 * source is itself a re-run — exactly this endpoint's original behaviour,
 * preserved unchanged.
 */
export const wyseaiRerunAuditBatch = <ThrowOnError extends boolean = false>(options: Options<WyseaiRerunAuditBatchData, ThrowOnError>): RequestResult<WyseaiRerunAuditBatchResponses, WyseaiRerunAuditBatchErrors, ThrowOnError> => (options.client ?? client).post<WyseaiRerunAuditBatchResponses, WyseaiRerunAuditBatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/call-auditing/audit/rerun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Gta Referrals
 *
 * This partner's referrals that have been through the GTA cleanse.
 *
 * ``q`` matches the claim reference or the claimant — first name, last name, or
 * both as the table shows them — and narrows ``count`` too, so pages are of matches.
 */
export const wyseaiListGtaReferrals = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListGtaReferralsData, ThrowOnError>): RequestResult<WyseaiListGtaReferralsResponses, WyseaiListGtaReferralsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListGtaReferralsResponses, WyseaiListGtaReferralsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/gta/referrals',
    ...options
});

/**
 * Read Gta Referral
 *
 * The milestone dates for one referral, and the reports produced from them.
 */
export const wyseaiReadGtaReferral = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadGtaReferralData, ThrowOnError>): RequestResult<WyseaiReadGtaReferralResponses, WyseaiReadGtaReferralErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadGtaReferralResponses, WyseaiReadGtaReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/gta/referrals/{referral_id}',
    ...options
});

/**
 * Download Gta Report
 *
 * Stream one cleanse report PDF.
 *
 * Proxied rather than linked to the AiClaims endpoint, which requires `run_audit`-class
 * permissions a partner will never hold. Membership is checked twice — the referral must
 * be this partner's, and the upload must belong to that referral — because an upload id
 * is a guessable integer and the first check alone would let one be swapped for another.
 */
export const wyseaiDownloadGtaReport = <ThrowOnError extends boolean = false>(options: Options<WyseaiDownloadGtaReportData, ThrowOnError>): RequestResult<WyseaiDownloadGtaReportResponses, WyseaiDownloadGtaReportErrors, ThrowOnError> => (options.client ?? client).get<WyseaiDownloadGtaReportResponses, WyseaiDownloadGtaReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/gta/referrals/{referral_id}/reports/{upload_id}',
    ...options
});

/**
 * List Claims
 *
 * This partner's claims, newest first.
 *
 * ``session`` is used for exactly two things — resolving the partner and checking the
 * permission — and never touches a claim; ``ops`` reads the mirror and never touches a
 * partner. Keeping the two straight is the whole reason both are named.
 */
export const wyseaiListClaims = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListClaimsData, ThrowOnError>): RequestResult<WyseaiListClaimsResponses, WyseaiListClaimsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListClaimsResponses, WyseaiListClaimsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/claims',
    ...options
});

/**
 * Read Claim
 *
 * One claim, with all five sections. Each frontend tab renders one of them.
 */
export const wyseaiReadClaim = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadClaimData, ThrowOnError>): RequestResult<WyseaiReadClaimResponses, WyseaiReadClaimErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadClaimResponses, WyseaiReadClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/claims/{claim_id}',
    ...options
});

/**
 * Parse Quote Check Email Upload
 *
 * Unpack a .eml quote pack. No preview path — see this module's docstring.
 */
export const wyseaiParseQuoteCheckEmail = <ThrowOnError extends boolean = false>(options: Options<WyseaiParseQuoteCheckEmailData, ThrowOnError>): RequestResult<WyseaiParseQuoteCheckEmailResponses, WyseaiParseQuoteCheckEmailErrors, ThrowOnError> => (options.client ?? client).post<WyseaiParseQuoteCheckEmailResponses, WyseaiParseQuoteCheckEmailErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/wyseai/quote-check/parse-email',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Quote Checks
 *
 * This client's quote checks, newest first: windowed, searchable, paginated.
 *
 * ``q`` narrows the list and its ``count`` (so pagination pages through matches
 * only) but not the three summary figures, which are the page's all-time headline
 * and would otherwise move every time someone typed in the box.
 */
export const wyseaiListQuoteChecks = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListQuoteChecksData, ThrowOnError>): RequestResult<WyseaiListQuoteChecksResponses, WyseaiListQuoteChecksErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListQuoteChecksResponses, WyseaiListQuoteChecksErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/quote-check/runs',
    ...options
});

/**
 * Submit Quote Check
 *
 * Submit a quote pack. No preview path — see this module's docstring.
 */
export const wyseaiSubmitQuoteCheck = <ThrowOnError extends boolean = false>(options: Options<WyseaiSubmitQuoteCheckData, ThrowOnError>): RequestResult<WyseaiSubmitQuoteCheckResponses, WyseaiSubmitQuoteCheckErrors, ThrowOnError> => (options.client ?? client).post<WyseaiSubmitQuoteCheckResponses, WyseaiSubmitQuoteCheckErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/wyseai/quote-check/runs',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Read Quote Check
 */
export const wyseaiReadQuoteCheck = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadQuoteCheckData, ThrowOnError>): RequestResult<WyseaiReadQuoteCheckResponses, WyseaiReadQuoteCheckErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadQuoteCheckResponses, WyseaiReadQuoteCheckErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/quote-check/runs/{run_id}',
    ...options
});

/**
 * Download Quote Check
 */
export const wyseaiDownloadQuoteCheck = <ThrowOnError extends boolean = false>(options: Options<WyseaiDownloadQuoteCheckData, ThrowOnError>): RequestResult<WyseaiDownloadQuoteCheckResponses, WyseaiDownloadQuoteCheckErrors, ThrowOnError> => (options.client ?? client).get<WyseaiDownloadQuoteCheckResponses, WyseaiDownloadQuoteCheckErrors, ThrowOnError>({ url: '/api/v1/wyseai/quote-check/runs/{run_id}/download', ...options });

/**
 * Read Workspace
 */
export const wyseaiTransportReadWorkspace = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportReadWorkspaceData, ThrowOnError>): RequestResult<WyseaiTransportReadWorkspaceResponses, WyseaiTransportReadWorkspaceErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportReadWorkspaceResponses, WyseaiTransportReadWorkspaceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/workspace',
    ...options
});

/**
 * Read Settings
 */
export const wyseaiTransportReadSettings = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportReadSettingsData, ThrowOnError>): RequestResult<WyseaiTransportReadSettingsResponses, WyseaiTransportReadSettingsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportReadSettingsResponses, WyseaiTransportReadSettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/settings',
    ...options
});

/**
 * Update Settings
 */
export const wyseaiTransportUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportUpdateSettingsData, ThrowOnError>): RequestResult<WyseaiTransportUpdateSettingsResponses, WyseaiTransportUpdateSettingsErrors, ThrowOnError> => (options.client ?? client).patch<WyseaiTransportUpdateSettingsResponses, WyseaiTransportUpdateSettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Warehouses
 */
export const wyseaiTransportListWarehouses = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportListWarehousesData, ThrowOnError>): RequestResult<WyseaiTransportListWarehousesResponses, WyseaiTransportListWarehousesErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportListWarehousesResponses, WyseaiTransportListWarehousesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/warehouses',
    ...options
});

/**
 * Create Warehouse
 */
export const wyseaiTransportCreateWarehouse = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportCreateWarehouseData, ThrowOnError>): RequestResult<WyseaiTransportCreateWarehouseResponses, WyseaiTransportCreateWarehouseErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportCreateWarehouseResponses, WyseaiTransportCreateWarehouseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/warehouses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Warehouse
 */
export const wyseaiTransportUpdateWarehouse = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportUpdateWarehouseData, ThrowOnError>): RequestResult<WyseaiTransportUpdateWarehouseResponses, WyseaiTransportUpdateWarehouseErrors, ThrowOnError> => (options.client ?? client).patch<WyseaiTransportUpdateWarehouseResponses, WyseaiTransportUpdateWarehouseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/warehouses/{warehouse_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Vans
 */
export const wyseaiTransportListVans = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportListVansData, ThrowOnError>): RequestResult<WyseaiTransportListVansResponses, WyseaiTransportListVansErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportListVansResponses, WyseaiTransportListVansErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/vans',
    ...options
});

/**
 * Create Van
 */
export const wyseaiTransportCreateVan = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportCreateVanData, ThrowOnError>): RequestResult<WyseaiTransportCreateVanResponses, WyseaiTransportCreateVanErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportCreateVanResponses, WyseaiTransportCreateVanErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/vans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Van
 */
export const wyseaiTransportDeleteVan = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportDeleteVanData, ThrowOnError>): RequestResult<WyseaiTransportDeleteVanResponses, WyseaiTransportDeleteVanErrors, ThrowOnError> => (options.client ?? client).delete<WyseaiTransportDeleteVanResponses, WyseaiTransportDeleteVanErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/vans/{van_id}',
    ...options
});

/**
 * Update Van
 */
export const wyseaiTransportUpdateVan = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportUpdateVanData, ThrowOnError>): RequestResult<WyseaiTransportUpdateVanResponses, WyseaiTransportUpdateVanErrors, ThrowOnError> => (options.client ?? client).patch<WyseaiTransportUpdateVanResponses, WyseaiTransportUpdateVanErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/vans/{van_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Drivers
 */
export const wyseaiTransportListDrivers = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportListDriversData, ThrowOnError>): RequestResult<WyseaiTransportListDriversResponses, WyseaiTransportListDriversErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportListDriversResponses, WyseaiTransportListDriversErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/drivers',
    ...options
});

/**
 * Create Driver
 */
export const wyseaiTransportCreateDriver = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportCreateDriverData, ThrowOnError>): RequestResult<WyseaiTransportCreateDriverResponses, WyseaiTransportCreateDriverErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportCreateDriverResponses, WyseaiTransportCreateDriverErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/drivers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Driver
 */
export const wyseaiTransportDeleteDriver = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportDeleteDriverData, ThrowOnError>): RequestResult<WyseaiTransportDeleteDriverResponses, WyseaiTransportDeleteDriverErrors, ThrowOnError> => (options.client ?? client).delete<WyseaiTransportDeleteDriverResponses, WyseaiTransportDeleteDriverErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/drivers/{driver_id}',
    ...options
});

/**
 * Update Driver
 */
export const wyseaiTransportUpdateDriver = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportUpdateDriverData, ThrowOnError>): RequestResult<WyseaiTransportUpdateDriverResponses, WyseaiTransportUpdateDriverErrors, ThrowOnError> => (options.client ?? client).patch<WyseaiTransportUpdateDriverResponses, WyseaiTransportUpdateDriverErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/drivers/{driver_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Jobs
 */
export const wyseaiTransportListJobs = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportListJobsData, ThrowOnError>): RequestResult<WyseaiTransportListJobsResponses, WyseaiTransportListJobsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportListJobsResponses, WyseaiTransportListJobsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/jobs',
    ...options
});

/**
 * Create Job
 */
export const wyseaiTransportCreateJob = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportCreateJobData, ThrowOnError>): RequestResult<WyseaiTransportCreateJobResponses, WyseaiTransportCreateJobErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportCreateJobResponses, WyseaiTransportCreateJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Job
 */
export const wyseaiTransportDeleteJob = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportDeleteJobData, ThrowOnError>): RequestResult<WyseaiTransportDeleteJobResponses, WyseaiTransportDeleteJobErrors, ThrowOnError> => (options.client ?? client).delete<WyseaiTransportDeleteJobResponses, WyseaiTransportDeleteJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/jobs/{job_id}',
    ...options
});

/**
 * Update Job
 */
export const wyseaiTransportUpdateJob = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportUpdateJobData, ThrowOnError>): RequestResult<WyseaiTransportUpdateJobResponses, WyseaiTransportUpdateJobErrors, ThrowOnError> => (options.client ?? client).patch<WyseaiTransportUpdateJobResponses, WyseaiTransportUpdateJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/jobs/{job_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import Jobs
 */
export const wyseaiTransportImportJobs = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportImportJobsData, ThrowOnError>): RequestResult<WyseaiTransportImportJobsResponses, WyseaiTransportImportJobsErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportImportJobsResponses, WyseaiTransportImportJobsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/jobs/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Validate Job Addresses
 */
export const wyseaiTransportValidateJobAddresses = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportValidateJobAddressesData, ThrowOnError>): RequestResult<WyseaiTransportValidateJobAddressesResponses, WyseaiTransportValidateJobAddressesErrors, ThrowOnError> => (options?.client ?? client).post<WyseaiTransportValidateJobAddressesResponses, WyseaiTransportValidateJobAddressesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/jobs/validate-addresses',
    ...options
});

/**
 * List Plans
 */
export const wyseaiTransportListPlans = <ThrowOnError extends boolean = false>(options?: Options<WyseaiTransportListPlansData, ThrowOnError>): RequestResult<WyseaiTransportListPlansResponses, WyseaiTransportListPlansErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiTransportListPlansResponses, WyseaiTransportListPlansErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans',
    ...options
});

/**
 * Create Plan
 */
export const wyseaiTransportCreatePlan = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportCreatePlanData, ThrowOnError>): RequestResult<WyseaiTransportCreatePlanResponses, WyseaiTransportCreatePlanErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportCreatePlanResponses, WyseaiTransportCreatePlanErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Plan
 */
export const wyseaiTransportReadPlan = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportReadPlanData, ThrowOnError>): RequestResult<WyseaiTransportReadPlanResponses, WyseaiTransportReadPlanErrors, ThrowOnError> => (options.client ?? client).get<WyseaiTransportReadPlanResponses, WyseaiTransportReadPlanErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}',
    ...options
});

/**
 * Optimize Routes
 *
 * Explicit Plan routes action. Does not run on job/van edits.
 */
export const wyseaiTransportOptimizeRoutes = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportOptimizeRoutesData, ThrowOnError>): RequestResult<WyseaiTransportOptimizeRoutesResponses, WyseaiTransportOptimizeRoutesErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportOptimizeRoutesResponses, WyseaiTransportOptimizeRoutesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/optimize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reoptimize Routes
 *
 * Explicit Re-optimise action. Creates a new version if the current plan is approved.
 */
export const wyseaiTransportReoptimizeRoutes = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportReoptimizeRoutesData, ThrowOnError>): RequestResult<WyseaiTransportReoptimizeRoutesResponses, WyseaiTransportReoptimizeRoutesErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportReoptimizeRoutesResponses, WyseaiTransportReoptimizeRoutesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/reoptimize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save Plan Version
 */
export const wyseaiTransportSavePlanVersion = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportSavePlanVersionData, ThrowOnError>): RequestResult<WyseaiTransportSavePlanVersionResponses, WyseaiTransportSavePlanVersionErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportSavePlanVersionResponses, WyseaiTransportSavePlanVersionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/save-version',
    ...options
});

/**
 * Approve Route Plan
 */
export const wyseaiTransportApprovePlan = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportApprovePlanData, ThrowOnError>): RequestResult<WyseaiTransportApprovePlanResponses, WyseaiTransportApprovePlanErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportApprovePlanResponses, WyseaiTransportApprovePlanErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/approve',
    ...options
});

/**
 * Adjust Stop Order
 */
export const wyseaiTransportAdjustStopOrder = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportAdjustStopOrderData, ThrowOnError>): RequestResult<WyseaiTransportAdjustStopOrderResponses, WyseaiTransportAdjustStopOrderErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportAdjustStopOrderResponses, WyseaiTransportAdjustStopOrderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reassign Job
 */
export const wyseaiTransportReassignJob = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportReassignJobData, ThrowOnError>): RequestResult<WyseaiTransportReassignJobResponses, WyseaiTransportReassignJobErrors, ThrowOnError> => (options.client ?? client).post<WyseaiTransportReassignJobResponses, WyseaiTransportReassignJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/reassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Starting Loads
 */
export const wyseaiTransportReadStartingLoads = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportReadStartingLoadsData, ThrowOnError>): RequestResult<WyseaiTransportReadStartingLoadsResponses, WyseaiTransportReadStartingLoadsErrors, ThrowOnError> => (options.client ?? client).get<WyseaiTransportReadStartingLoadsResponses, WyseaiTransportReadStartingLoadsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/plans/{plan_id}/starting-loads',
    ...options
});

/**
 * Read Itinerary
 */
export const wyseaiTransportReadItinerary = <ThrowOnError extends boolean = false>(options: Options<WyseaiTransportReadItineraryData, ThrowOnError>): RequestResult<WyseaiTransportReadItineraryResponses, WyseaiTransportReadItineraryErrors, ThrowOnError> => (options.client ?? client).get<WyseaiTransportReadItineraryResponses, WyseaiTransportReadItineraryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/transport-planning/itinerary/{token}',
    ...options
});

/**
 * List Workflows
 *
 * This partner's workflow runs — call-audit batches and GTA cleanses — newest
 * "last activity" first.
 *
 * Merged and paginated in Python, not SQL: a departure from `agent_runs.py`'s
 * "paginate in SQL" rule, deliberate here because that rule exists for a table that
 * can hold tens of thousands of rows per partner. A call-audit batch or a GTA referral
 * is one row per *batch**referral*, not per underlying agent run — orders of
 * magnitude fewer — so reading a partner's full set and merge-sort-slicing it in the
 * app tier is honest at this scale.
 *
 * `source`, when given, skips querying the other source entirely rather than
 * filtering a combined list after the fact. `q` is the opposite, and deliberately:
 * it filters the merged list here, before the sort and slice, so `count` and the
 * pages are of matches only — at this scale the list is already in memory anyway.
 */
export const wyseaiListWorkflows = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListWorkflowsData, ThrowOnError>): RequestResult<WyseaiListWorkflowsResponses, WyseaiListWorkflowsErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListWorkflowsResponses, WyseaiListWorkflowsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/workflows',
    ...options
});

/**
 * Read Workflow
 *
 * One workflow run in full, including its stage-by-stage progress and any
 * downloadable report.
 *
 * 404, never 403, for an id that does not parse, names an unrecognised source, or
 * belongs to another partner — the same "do not differentiate malformed from
 * out-of-scope" reasoning `agent_runs.py`'s `read_partner_run` documents: a
 * 403 would confirm a run with that id exists, which for another partner's run is the
 * one thing not to say. The parsed id is never trusted alone; both branches below
 * re-verify ownership the same way the list endpoint scopes its own rows.
 */
export const wyseaiReadWorkflow = <ThrowOnError extends boolean = false>(options: Options<WyseaiReadWorkflowData, ThrowOnError>): RequestResult<WyseaiReadWorkflowResponses, WyseaiReadWorkflowErrors, ThrowOnError> => (options.client ?? client).get<WyseaiReadWorkflowResponses, WyseaiReadWorkflowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/workflows/{workflow_id}',
    ...options
});

/**
 * List Team
 *
 * The people at this partner, and what each of them may open.
 */
export const wyseaiListTeam = <ThrowOnError extends boolean = false>(options?: Options<WyseaiListTeamData, ThrowOnError>): RequestResult<WyseaiListTeamResponses, WyseaiListTeamErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiListTeamResponses, WyseaiListTeamErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/users',
    ...options
});

/**
 * Remove Capabilities
 *
 * Revoke everything this colleague may open **at this partner**.
 *
 * Deliberately not a deactivation: a leaver at one partner may be a current employee at
 * another, and this endpoint has no authority over that relationship.
 */
export const wyseaiRemoveCapabilities = <ThrowOnError extends boolean = false>(options: Options<WyseaiRemoveCapabilitiesData, ThrowOnError>): RequestResult<WyseaiRemoveCapabilitiesResponses, WyseaiRemoveCapabilitiesErrors, ThrowOnError> => (options.client ?? client).delete<WyseaiRemoveCapabilitiesResponses, WyseaiRemoveCapabilitiesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/users/{user_id}/capabilities',
    ...options
});

/**
 * Set Capabilities
 *
 * Set exactly what one colleague may open, at this partner.
 */
export const wyseaiSetCapabilities = <ThrowOnError extends boolean = false>(options: Options<WyseaiSetCapabilitiesData, ThrowOnError>): RequestResult<WyseaiSetCapabilitiesResponses, WyseaiSetCapabilitiesErrors, ThrowOnError> => (options.client ?? client).put<WyseaiSetCapabilitiesResponses, WyseaiSetCapabilitiesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/users/{user_id}/capabilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Branding
 *
 * This partner's chosen primary colour, or `null` for the default palette.
 */
export const wyseaiReadBranding = <ThrowOnError extends boolean = false>(options?: Options<WyseaiReadBrandingData, ThrowOnError>): RequestResult<WyseaiReadBrandingResponses, WyseaiReadBrandingErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiReadBrandingResponses, WyseaiReadBrandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/branding',
    ...options
});

/**
 * Set Branding
 *
 * Set, or clear with `null`, this partner's chosen primary colour.
 *
 * One row per partner, upserted rather than replaced: the first write for a partner
 * creates it, every later write — including a clearing `null` — updates the same row
 * so its `updated_by_user_id`/`updated_datetime` trail stays with it rather than being
 * lost to a delete-and-recreate.
 *
 * Every call is audited, matching `_replace_capabilities` above: `table` names the
 * table, `record_id` is the partner whose branding changed, and `changes` carries
 * only the two colours and the partner id — `Audit_log.changes` runs `screen_payload`
 * on write, so nothing personal need be kept out by hand here.
 */
export const wyseaiSetBranding = <ThrowOnError extends boolean = false>(options: Options<WyseaiSetBrandingData, ThrowOnError>): RequestResult<WyseaiSetBrandingResponses, WyseaiSetBrandingErrors, ThrowOnError> => (options.client ?? client).put<WyseaiSetBrandingResponses, WyseaiSetBrandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/branding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Branding Logo
 *
 * Remove this partner's logo, leaving the WyseAi wordmark on its own.
 */
export const wyseaiClearBrandingLogo = <ThrowOnError extends boolean = false>(options?: Options<WyseaiClearBrandingLogoData, ThrowOnError>): RequestResult<WyseaiClearBrandingLogoResponses, WyseaiClearBrandingLogoErrors, ThrowOnError> => (options?.client ?? client).delete<WyseaiClearBrandingLogoResponses, WyseaiClearBrandingLogoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/branding/logo',
    ...options
});

/**
 * Set Branding Logo
 *
 * Upload this partner's logo, replacing any previous one.
 *
 * Stored in the same bucket as call recordings and cleanse reports, under a
 * `logos/partner-<id>/` prefix, and served back through the application rather than
 * made public — the bucket holds partner audio and claim documents, and a logo is not
 * reason enough to change that.
 *
 * Put synchronously rather than through `upload_file_to_spaces`: that task is
 * referral-scoped and creates an `Upload` row, neither of which fits a logo, and an
 * administrator watching a picker needs the answer now rather than a task id.
 */
export const wyseaiSetBrandingLogo = <ThrowOnError extends boolean = false>(options: Options<WyseaiSetBrandingLogoData, ThrowOnError>): RequestResult<WyseaiSetBrandingLogoResponses, WyseaiSetBrandingLogoErrors, ThrowOnError> => (options.client ?? client).put<WyseaiSetBrandingLogoResponses, WyseaiSetBrandingLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/wyseai/partner-admin/branding/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Read Partner Logo
 *
 * This partner's logo, or 404 when they have not set one.
 *
 * 404 rather than a placeholder image: the caller is the shell deciding whether to
 * render a logo at all, and a 200 carrying a default would make "no logo" and "a logo
 * that happens to look like ours" indistinguishable.
 *
 * Follows the preview, and must: the bootstrap already reports the *previewed*
 * partner's logo version, so without this the shell would ask for that version and be
 * served the previewer's own logo — or a 404 if they have none. Not audited, unlike
 * the data surfaces; see ``resolve_partner_id``.
 */
export const wyseaiReadPartnerLogo = <ThrowOnError extends boolean = false>(options?: Options<WyseaiReadPartnerLogoData, ThrowOnError>): RequestResult<WyseaiReadPartnerLogoResponses, WyseaiReadPartnerLogoErrors, ThrowOnError> => (options?.client ?? client).get<WyseaiReadPartnerLogoResponses, WyseaiReadPartnerLogoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/wyseai/branding/logo',
    ...options
});

/**
 * Read Insurers
 *
 * Retrieve insurers.
 */
export const readInsurers = <ThrowOnError extends boolean = false>(options?: Options<ReadInsurersData, ThrowOnError>): RequestResult<ReadInsurersResponses, ReadInsurersErrors, ThrowOnError> => (options?.client ?? client).get<ReadInsurersResponses, ReadInsurersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurers/',
    ...options
});

/**
 * Create Insurer
 *
 * Create new insurer.
 */
export const createInsurer = <ThrowOnError extends boolean = false>(options: Options<CreateInsurerData, ThrowOnError>): RequestResult<CreateInsurerResponses, CreateInsurerErrors, ThrowOnError> => (options.client ?? client).post<CreateInsurerResponses, CreateInsurerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurers/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Insurer
 *
 * Delete an insurer.
 */
export const deleteInsurer = <ThrowOnError extends boolean = false>(options: Options<DeleteInsurerData, ThrowOnError>): RequestResult<DeleteInsurerResponses, DeleteInsurerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInsurerResponses, DeleteInsurerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurers/{id}',
    ...options
});

/**
 * Read Insurer
 *
 * Get insurer by ID.
 */
export const readInsurer = <ThrowOnError extends boolean = false>(options: Options<ReadInsurerData, ThrowOnError>): RequestResult<ReadInsurerResponses, ReadInsurerErrors, ThrowOnError> => (options.client ?? client).get<ReadInsurerResponses, ReadInsurerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurers/{id}',
    ...options
});

/**
 * Update Insurer
 *
 * Update an insurer.
 */
export const updateInsurer = <ThrowOnError extends boolean = false>(options: Options<UpdateInsurerData, ThrowOnError>): RequestResult<UpdateInsurerResponses, UpdateInsurerErrors, ThrowOnError> => (options.client ?? client).put<UpdateInsurerResponses, UpdateInsurerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Partner Rules
 *
 * Retrieve partner_rule_rates.
 */
export const readPartnerRules = <ThrowOnError extends boolean = false>(options?: Options<ReadPartnerRulesData, ThrowOnError>): RequestResult<ReadPartnerRulesResponses, ReadPartnerRulesErrors, ThrowOnError> => (options?.client ?? client).get<ReadPartnerRulesResponses, ReadPartnerRulesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner_rules/',
    ...options
});

/**
 * Create Partner Rule
 *
 * Create new partner_rule or update existing one.
 */
export const createPartnerRule = <ThrowOnError extends boolean = false>(options: Options<CreatePartnerRuleData, ThrowOnError>): RequestResult<CreatePartnerRuleResponses, CreatePartnerRuleErrors, ThrowOnError> => (options.client ?? client).post<CreatePartnerRuleResponses, CreatePartnerRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner_rules/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Partner Rule
 *
 * Delete an partner_rule.
 */
export const deletePartnerRule = <ThrowOnError extends boolean = false>(options: Options<DeletePartnerRuleData, ThrowOnError>): RequestResult<DeletePartnerRuleResponses, DeletePartnerRuleErrors, ThrowOnError> => (options.client ?? client).delete<DeletePartnerRuleResponses, DeletePartnerRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner_rules/{id}',
    ...options
});

/**
 * Read Partner Rule
 *
 * Get partner_rule_rate by ID.
 */
export const readPartnerRule = <ThrowOnError extends boolean = false>(options: Options<ReadPartnerRuleData, ThrowOnError>): RequestResult<ReadPartnerRuleResponses, ReadPartnerRuleErrors, ThrowOnError> => (options.client ?? client).get<ReadPartnerRuleResponses, ReadPartnerRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner_rules/{id}',
    ...options
});

/**
 * Update Partner Rule
 *
 * Update an partner_rule.
 */
export const updatePartnerRule = <ThrowOnError extends boolean = false>(options: Options<UpdatePartnerRuleData, ThrowOnError>): RequestResult<UpdatePartnerRuleResponses, UpdatePartnerRuleErrors, ThrowOnError> => (options.client ?? client).put<UpdatePartnerRuleResponses, UpdatePartnerRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner_rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Circs Grades
 *
 * Retrieve circs_grades.
 */
export const readCircsGrades = <ThrowOnError extends boolean = false>(options?: Options<ReadCircsGradesData, ThrowOnError>): RequestResult<ReadCircsGradesResponses, ReadCircsGradesErrors, ThrowOnError> => (options?.client ?? client).get<ReadCircsGradesResponses, ReadCircsGradesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/circs_grades/',
    ...options
});

/**
 * Create Circs Grade
 *
 * Create new circs_grade.
 */
export const createCircsGrade = <ThrowOnError extends boolean = false>(options: Options<CreateCircsGradeData, ThrowOnError>): RequestResult<CreateCircsGradeResponses, CreateCircsGradeErrors, ThrowOnError> => (options.client ?? client).post<CreateCircsGradeResponses, CreateCircsGradeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/circs_grades/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Circs Grade
 *
 * Delete an circs_grade.
 */
export const deleteCircsGrade = <ThrowOnError extends boolean = false>(options: Options<DeleteCircsGradeData, ThrowOnError>): RequestResult<DeleteCircsGradeResponses, DeleteCircsGradeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCircsGradeResponses, DeleteCircsGradeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/circs_grades/{id}',
    ...options
});

/**
 * Read Circs Grade
 *
 * Get circs_grade by ID.
 */
export const readCircsGrade = <ThrowOnError extends boolean = false>(options: Options<ReadCircsGradeData, ThrowOnError>): RequestResult<ReadCircsGradeResponses, ReadCircsGradeErrors, ThrowOnError> => (options.client ?? client).get<ReadCircsGradeResponses, ReadCircsGradeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/circs_grades/{id}',
    ...options
});

/**
 * Update Circs Grade
 *
 * Update an circs_grade.
 */
export const updateCircsGrade = <ThrowOnError extends boolean = false>(options: Options<UpdateCircsGradeData, ThrowOnError>): RequestResult<UpdateCircsGradeResponses, UpdateCircsGradeErrors, ThrowOnError> => (options.client ?? client).put<UpdateCircsGradeResponses, UpdateCircsGradeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/circs_grades/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Claims
 *
 * Retrieve claims.
 */
export const readClaims = <ThrowOnError extends boolean = false>(options?: Options<ReadClaimsData, ThrowOnError>): RequestResult<ReadClaimsResponses, ReadClaimsErrors, ThrowOnError> => (options?.client ?? client).get<ReadClaimsResponses, ReadClaimsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/claims/',
    ...options
});

/**
 * Create Claim
 *
 * Create new claim.
 */
export const createClaim = <ThrowOnError extends boolean = false>(options: Options<CreateClaimData, ThrowOnError>): RequestResult<CreateClaimResponses, CreateClaimErrors, ThrowOnError> => (options.client ?? client).post<CreateClaimResponses, CreateClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/claims/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Claim
 *
 * Delete an claim.
 */
export const deleteClaim = <ThrowOnError extends boolean = false>(options: Options<DeleteClaimData, ThrowOnError>): RequestResult<DeleteClaimResponses, DeleteClaimErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClaimResponses, DeleteClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/claims/{id}',
    ...options
});

/**
 * Read Claim
 *
 * Get claim by ID.
 */
export const readClaim = <ThrowOnError extends boolean = false>(options: Options<ReadClaimData, ThrowOnError>): RequestResult<ReadClaimResponses, ReadClaimErrors, ThrowOnError> => (options.client ?? client).get<ReadClaimResponses, ReadClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/claims/{id}',
    ...options
});

/**
 * Update Claim
 *
 * Update an claim.
 */
export const updateClaim = <ThrowOnError extends boolean = false>(options: Options<UpdateClaimData, ThrowOnError>): RequestResult<UpdateClaimResponses, UpdateClaimErrors, ThrowOnError> => (options.client ?? client).put<UpdateClaimResponses, UpdateClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/claims/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Insurer Claims
 */
export const searchInsurerClaims = <ThrowOnError extends boolean = false>(options?: Options<SearchInsurerClaimsData, ThrowOnError>): RequestResult<SearchInsurerClaimsResponses, SearchInsurerClaimsErrors, ThrowOnError> => (options?.client ?? client).get<SearchInsurerClaimsResponses, SearchInsurerClaimsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurer-claims/search',
    ...options
});

/**
 * Import Claim State Payload
 *
 * Import a single Claim State JSON object (admin/script-friendly).
 */
export const importClaimStatePayload = <ThrowOnError extends boolean = false>(options: Options<ImportClaimStatePayloadData, ThrowOnError>): RequestResult<ImportClaimStatePayloadResponses, ImportClaimStatePayloadErrors, ThrowOnError> => (options.client ?? client).post<ImportClaimStatePayloadResponses, ImportClaimStatePayloadErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurer-claims/import/claim-state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import a canonical inbound claim (heads, parties, vehicles, financials)
 *
 * Upsert a nested claim into OperationalDB. Does not accept source=claim_state.
 */
export const importInboundClaim = <ThrowOnError extends boolean = false>(options: Options<ImportInboundClaimData, ThrowOnError>): RequestResult<ImportInboundClaimResponses, ImportInboundClaimErrors, ThrowOnError> => (options.client ?? client).post<ImportInboundClaimResponses, ImportInboundClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurer-claims/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Insurer Claim Field Changes
 */
export const listInsurerClaimFieldChanges = <ThrowOnError extends boolean = false>(options: Options<ListInsurerClaimFieldChangesData, ThrowOnError>): RequestResult<ListInsurerClaimFieldChangesResponses, ListInsurerClaimFieldChangesErrors, ThrowOnError> => (options.client ?? client).get<ListInsurerClaimFieldChangesResponses, ListInsurerClaimFieldChangesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurer-claims/{claim_id}/field-changes',
    ...options
});

/**
 * Get Insurer Claim
 */
export const getInsurerClaim = <ThrowOnError extends boolean = false>(options: Options<GetInsurerClaimData, ThrowOnError>): RequestResult<GetInsurerClaimResponses, GetInsurerClaimErrors, ThrowOnError> => (options.client ?? client).get<GetInsurerClaimResponses, GetInsurerClaimErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurer-claims/{claim_id}',
    ...options
});

/**
 * Get Insurer Policy
 */
export const getInsurerPolicy = <ThrowOnError extends boolean = false>(options: Options<GetInsurerPolicyData, ThrowOnError>): RequestResult<GetInsurerPolicyResponses, GetInsurerPolicyErrors, ThrowOnError> => (options.client ?? client).get<GetInsurerPolicyResponses, GetInsurerPolicyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/insurer-policies/{policy_id}',
    ...options
});

/**
 * Read Complaints
 *
 * Retrieve complaints.
 */
export const readComplaints = <ThrowOnError extends boolean = false>(options?: Options<ReadComplaintsData, ThrowOnError>): RequestResult<ReadComplaintsResponses, ReadComplaintsErrors, ThrowOnError> => (options?.client ?? client).get<ReadComplaintsResponses, ReadComplaintsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/complaints/',
    ...options
});

/**
 * Create New Complaint
 *
 * Create new complaint.
 */
export const createNewComplaint = <ThrowOnError extends boolean = false>(options: Options<CreateNewComplaintData, ThrowOnError>): RequestResult<CreateNewComplaintResponses, CreateNewComplaintErrors, ThrowOnError> => (options.client ?? client).post<CreateNewComplaintResponses, CreateNewComplaintErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/complaints/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Existing Complaint
 *
 * Delete a complaint.
 */
export const deleteExistingComplaint = <ThrowOnError extends boolean = false>(options: Options<DeleteExistingComplaintData, ThrowOnError>): RequestResult<DeleteExistingComplaintResponses, DeleteExistingComplaintErrors, ThrowOnError> => (options.client ?? client).delete<DeleteExistingComplaintResponses, DeleteExistingComplaintErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/complaints/{complaint_id}',
    ...options
});

/**
 * Read Complaint
 *
 * Get complaint by ID.
 *
 * SECURITY (AUTHZ-VULN-09): Users can only read complaints for referrals
 * they are involved with, unless they are a System Administrator.
 */
export const readComplaint = <ThrowOnError extends boolean = false>(options: Options<ReadComplaintData, ThrowOnError>): RequestResult<ReadComplaintResponses, ReadComplaintErrors, ThrowOnError> => (options.client ?? client).get<ReadComplaintResponses, ReadComplaintErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/complaints/{complaint_id}',
    ...options
});

/**
 * Update Existing Complaint
 *
 * Update a complaint.
 *
 * SECURITY (AUTHZ-VULN-10): Users can only update complaints for referrals
 * they are involved with, unless they are a System Administrator.
 */
export const updateExistingComplaint = <ThrowOnError extends boolean = false>(options: Options<UpdateExistingComplaintData, ThrowOnError>): RequestResult<UpdateExistingComplaintResponses, UpdateExistingComplaintErrors, ThrowOnError> => (options.client ?? client).put<UpdateExistingComplaintResponses, UpdateExistingComplaintErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/complaints/{complaint_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Complaints By Referral
 *
 * Get all complaints for a specific referral.
 */
export const readComplaintsByReferral = <ThrowOnError extends boolean = false>(options: Options<ReadComplaintsByReferralData, ThrowOnError>): RequestResult<ReadComplaintsByReferralResponses, ReadComplaintsByReferralErrors, ThrowOnError> => (options.client ?? client).get<ReadComplaintsByReferralResponses, ReadComplaintsByReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/complaints/referral/{referral_id}',
    ...options
});

/**
 * Read Referral Allocations Bytype
 *
 * Retrieve referral_allocations.
 */
export const readReferralAllocationsBytype = <ThrowOnError extends boolean = false>(options?: Options<ReadReferralAllocationsBytypeData, ThrowOnError>): RequestResult<ReadReferralAllocationsBytypeResponses, ReadReferralAllocationsBytypeErrors, ThrowOnError> => (options?.client ?? client).get<ReadReferralAllocationsBytypeResponses, ReadReferralAllocationsBytypeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/',
    ...options
});

/**
 * Create Referral Allocation
 *
 * Create new referral_allocation.
 */
export const createReferralAllocation = <ThrowOnError extends boolean = false>(options: Options<CreateReferralAllocationData, ThrowOnError>): RequestResult<CreateReferralAllocationResponses, CreateReferralAllocationErrors, ThrowOnError> => (options.client ?? client).post<CreateReferralAllocationResponses, CreateReferralAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Referral Allocation
 *
 * Delete an referral_allocation.
 */
export const deleteReferralAllocation = <ThrowOnError extends boolean = false>(options: Options<DeleteReferralAllocationData, ThrowOnError>): RequestResult<DeleteReferralAllocationResponses, DeleteReferralAllocationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteReferralAllocationResponses, DeleteReferralAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/{id}',
    ...options
});

/**
 * Read Referral Allocation
 *
 * Get referral_allocation by ID.
 *
 * SECURITY FIX (AUTHZ-VULN-06): Enforces referral involvement check.
 * Non-superusers can only access allocations for referrals they are involved with.
 */
export const readReferralAllocation = <ThrowOnError extends boolean = false>(options: Options<ReadReferralAllocationData, ThrowOnError>): RequestResult<ReadReferralAllocationResponses, ReadReferralAllocationErrors, ThrowOnError> => (options.client ?? client).get<ReadReferralAllocationResponses, ReadReferralAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/{id}',
    ...options
});

/**
 * Update Referral Allocation
 *
 * Update an referral_allocation.
 */
export const updateReferralAllocation = <ThrowOnError extends boolean = false>(options: Options<UpdateReferralAllocationData, ThrowOnError>): RequestResult<UpdateReferralAllocationResponses, UpdateReferralAllocationErrors, ThrowOnError> => (options.client ?? client).put<UpdateReferralAllocationResponses, UpdateReferralAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Partner Update Allocation
 *
 * Update an referral_allocation and notify the source partner of any changes.
 */
export const partnerUpdateAllocation = <ThrowOnError extends boolean = false>(options: Options<PartnerUpdateAllocationData, ThrowOnError>): RequestResult<PartnerUpdateAllocationResponses, PartnerUpdateAllocationErrors, ThrowOnError> => (options.client ?? client).post<PartnerUpdateAllocationResponses, PartnerUpdateAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reallocate Referral
 *
 * Allocate or reallocate a referral to a supplier partner.
 * If existing allocations exist, they will be cancelled and a new one created (reallocation).
 * If no existing allocations exist, a new allocation will be created (initial allocation).
 */
export const reallocateReferral = <ThrowOnError extends boolean = false>(options: Options<ReallocateReferralData, ThrowOnError>): RequestResult<ReallocateReferralResponses, ReallocateReferralErrors, ThrowOnError> => (options.client ?? client).post<ReallocateReferralResponses, ReallocateReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/reallocate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Referral Allocation Audit History
 *
 * Get audit history for a referral allocation.
 * Returns all changes tracked for this allocation with timestamps and user information.
 */
export const getReferralAllocationAuditHistory = <ThrowOnError extends boolean = false>(options: Options<GetReferralAllocationAuditHistoryData, ThrowOnError>): RequestResult<GetReferralAllocationAuditHistoryResponses, GetReferralAllocationAuditHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetReferralAllocationAuditHistoryResponses, GetReferralAllocationAuditHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_allocations/{id}/audit-history',
    ...options
});

/**
 * Generate Summary
 *
 * Generate an AI claim summary for a referral using the Celery AI task.
 */
export const referralsGenerateSummary = <ThrowOnError extends boolean = false>(options: Options<ReferralsGenerateSummaryData, ThrowOnError>): RequestResult<ReferralsGenerateSummaryResponses, ReferralsGenerateSummaryErrors, ThrowOnError> => (options.client ?? client).post<ReferralsGenerateSummaryResponses, ReferralsGenerateSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/generate-summary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Summary Status
 *
 * Poll the status/result of a claim summary generation task.
 */
export const referralsGetSummaryStatus = <ThrowOnError extends boolean = false>(options: Options<ReferralsGetSummaryStatusData, ThrowOnError>): RequestResult<ReferralsGetSummaryStatusResponses, ReferralsGetSummaryStatusErrors, ThrowOnError> => (options.client ?? client).get<ReferralsGetSummaryStatusResponses, ReferralsGetSummaryStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/summary-status/{task_id}',
    ...options
});

/**
 * Get Latest Summary
 *
 * Get the latest successful AI-generated summary for a referral.
 */
export const referralsGetLatestSummary = <ThrowOnError extends boolean = false>(options: Options<ReferralsGetLatestSummaryData, ThrowOnError>): RequestResult<ReferralsGetLatestSummaryResponses, ReferralsGetLatestSummaryErrors, ThrowOnError> => (options.client ?? client).get<ReferralsGetLatestSummaryResponses, ReferralsGetLatestSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/{referral_id}/summary/latest',
    ...options
});

/**
 * Get Summary History
 *
 * Get the history of AI-generated summaries for a referral.
 */
export const referralsGetSummaryHistory = <ThrowOnError extends boolean = false>(options: Options<ReferralsGetSummaryHistoryData, ThrowOnError>): RequestResult<ReferralsGetSummaryHistoryResponses, ReferralsGetSummaryHistoryErrors, ThrowOnError> => (options.client ?? client).get<ReferralsGetSummaryHistoryResponses, ReferralsGetSummaryHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/{referral_id}/summary/history',
    ...options
});

/**
 * Get Summary Detail
 *
 * Get detailed information about a specific summary including prompts and context.
 */
export const referralsGetSummaryDetail = <ThrowOnError extends boolean = false>(options: Options<ReferralsGetSummaryDetailData, ThrowOnError>): RequestResult<ReferralsGetSummaryDetailResponses, ReferralsGetSummaryDetailErrors, ThrowOnError> => (options.client ?? client).get<ReferralsGetSummaryDetailResponses, ReferralsGetSummaryDetailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/summary/{summary_id}/detail',
    ...options
});

/**
 * Read Referrals
 *
 * Retrieve referrals.
 */
export const readReferrals = <ThrowOnError extends boolean = false>(options?: Options<ReadReferralsData, ThrowOnError>): RequestResult<ReadReferralsResponses, ReadReferralsErrors, ThrowOnError> => (options?.client ?? client).get<ReadReferralsResponses, ReadReferralsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/',
    ...options
});

/**
 * Create Referral
 *
 * Create new referral.
 */
export const createReferral = <ThrowOnError extends boolean = false>(options: Options<CreateReferralData, ThrowOnError>): RequestResult<CreateReferralResponses, CreateReferralErrors, ThrowOnError> => (options.client ?? client).post<CreateReferralResponses, CreateReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Referral Table Data
 *
 * Get paginated referral table data with search and sorting capabilities.
 * Optimized for table display with server-side pagination, search, and sorting.
 */
export const referralTableData = <ThrowOnError extends boolean = false>(options?: Options<ReferralTableDataData, ThrowOnError>): RequestResult<ReferralTableDataResponses, ReferralTableDataErrors, ThrowOnError> => (options?.client ?? client).get<ReferralTableDataResponses, ReferralTableDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/table',
    ...options
});

/**
 * Referral Chart Data
 *
 * Get chart data for referrals with optimized, chart-specific queries.
 * Each chart type now uses only the data it actually needs, improving performance and accuracy.
 */
export const referralChartData = <ThrowOnError extends boolean = false>(options: Options<ReferralChartDataData, ThrowOnError>): RequestResult<ReferralChartDataResponses, ReferralChartDataErrors, ThrowOnError> => (options.client ?? client).get<ReferralChartDataResponses, ReferralChartDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/chartdata',
    ...options
});

/**
 * Count Referrals By Status
 *
 * Count referrals matching the specified allocation statuses.
 *
 * This endpoint is used by the bulk claim summaries feature to show administrators
 * how many referrals will be processed before initiating a bulk operation.
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * statuses: List of allocation statuses (e.g., ["pending/new", "On Hire", "Booked in", "Cancelled"])
 *
 * Returns:
 * Dictionary with count and statuses
 *
 * Raises:
 * HTTPException: 403 if user lacks permission
 * HTTPException: 400 if no statuses provided
 */
export const countReferralsByStatus = <ThrowOnError extends boolean = false>(options: Options<CountReferralsByStatusData, ThrowOnError>): RequestResult<CountReferralsByStatusResponses, CountReferralsByStatusErrors, ThrowOnError> => (options.client ?? client).get<CountReferralsByStatusResponses, CountReferralsByStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/count-by-status/',
    ...options
});

/**
 * Create Bulk Summary Operation
 *
 * Create a bulk operation to generate claim summaries for multiple referrals.
 *
 * This endpoint initiates a background task that will process all referrals matching
 * the specified allocation statuses and generate AI-powered claim summaries for each.
 *
 * Security measures:
 * - Rate limiting: 5 operations per hour per user
 * - Concurrent operations: Maximum 3 system-wide
 * - Operation timeout: 1 hour maximum
 * - Audit logging: All attempts logged
 * - Permission enforcement: System Administrator role required
 *
 * Args:
 * request: FastAPI request object
 * session: Database session
 * current_user: Current authenticated user
 * allocation_statuses: List of allocation statuses to filter referrals
 * model: AI model key (see BEDROCK_SUMMARY_MODEL_KEYS)
 * version: Summary length ('simple', 'standard', or 'enhanced')
 * priority: Task priority (0-9, where 9 is highest priority)
 *
 * Returns:
 * BulkOperationPublic: Created bulk operation with task details
 *
 * Raises:
 * HTTPException: 403 if user is not a System Administrator
 * HTTPException: 400 if validation fails
 * HTTPException: 429 if rate limit exceeded
 * HTTPException: 503 if concurrent operation limit reached
 */
export const createBulkSummaryOperation = <ThrowOnError extends boolean = false>(options: Options<CreateBulkSummaryOperationData, ThrowOnError>): RequestResult<CreateBulkSummaryOperationResponses, CreateBulkSummaryOperationErrors, ThrowOnError> => (options.client ?? client).post<CreateBulkSummaryOperationResponses, CreateBulkSummaryOperationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-generate-summaries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cleanup Timed Out Bulk Operations
 *
 * Clean up bulk operations that have timed out.
 *
 * This endpoint manually triggers cleanup of operations that are stuck in
 * 'pending' or 'in_progress' status but have exceeded the 1-hour timeout.
 *
 * This is useful for:
 * - Freeing up concurrent operation slots
 * - Cleaning up after worker crashes
 * - Manual intervention when operations are stuck
 *
 * Security:
 * - System Administrator role required
 *
 * Returns:
 * dict: Summary of cleanup operation
 *
 * Raises:
 * HTTPException: 403 if user is not a System Administrator
 */
export const cleanupTimedOutBulkOperations = <ThrowOnError extends boolean = false>(options?: Options<CleanupTimedOutBulkOperationsData, ThrowOnError>): RequestResult<CleanupTimedOutBulkOperationsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CleanupTimedOutBulkOperationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations/cleanup-timed-out',
    ...options
});

/**
 * Get Bulk Operations History
 *
 * Get paginated list of bulk operations for the current user.
 *
 * This endpoint retrieves the history of bulk summary generation operations,
 * ordered by creation date (most recent first).
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * skip: Number of records to skip (default: 0)
 * limit: Maximum number of records to return (default: 20, max: 100)
 *
 * Returns:
 * BulkOperationsPublic: Paginated list with count
 *
 * Raises:
 * HTTPException: 403 if user lacks permission
 */
export const getBulkOperationsHistory = <ThrowOnError extends boolean = false>(options?: Options<GetBulkOperationsHistoryData, ThrowOnError>): RequestResult<GetBulkOperationsHistoryResponses, GetBulkOperationsHistoryErrors, ThrowOnError> => (options?.client ?? client).get<GetBulkOperationsHistoryResponses, GetBulkOperationsHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations',
    ...options
});

/**
 * Get Bulk Operation Status
 *
 * Get the status and details of a bulk operation.
 *
 * This endpoint retrieves the current status of a bulk summary generation operation,
 * including progress information, success/failure counts, and any errors that occurred.
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * operation_id: ID of the bulk operation to retrieve
 *
 * Returns:
 * BulkOperationPublic: Operation status with all details including errors array
 *
 * Raises:
 * HTTPException: 403 if user lacks permission
 * HTTPException: 404 if operation not found
 */
export const getBulkOperationStatus = <ThrowOnError extends boolean = false>(options: Options<GetBulkOperationStatusData, ThrowOnError>): RequestResult<GetBulkOperationStatusResponses, GetBulkOperationStatusErrors, ThrowOnError> => (options.client ?? client).get<GetBulkOperationStatusResponses, GetBulkOperationStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations/{operation_id}',
    ...options
});

/**
 * Get Bulk Operation Referrals
 *
 * List the referrals (claims) targeted by a bulk operation.
 *
 * Uses the stored configuration on the bulk operation to reconstruct the
 * referral selection (allocation_statuses) and returns referral + claim info.
 */
export const getBulkOperationReferrals = <ThrowOnError extends boolean = false>(options: Options<GetBulkOperationReferralsData, ThrowOnError>): RequestResult<GetBulkOperationReferralsResponses, GetBulkOperationReferralsErrors, ThrowOnError> => (options.client ?? client).get<GetBulkOperationReferralsResponses, GetBulkOperationReferralsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations/{operation_id}/referrals',
    ...options
});

/**
 * Stream Bulk Operation Updates
 *
 * Server-Sent Events stream for real-time bulk operation updates.
 *
 * Authentication: uses the same cookie/JWT auth as other internal endpoints.
 * Implementation: publishes updates on Redis pub/sub channel 'bulk_operation:{id}'.
 */
export const streamBulkOperationUpdates = <ThrowOnError extends boolean = false>(options: Options<StreamBulkOperationUpdatesData, ThrowOnError>): RequestResult<StreamBulkOperationUpdatesResponses, StreamBulkOperationUpdatesErrors, ThrowOnError> => (options.client ?? client).get<StreamBulkOperationUpdatesResponses, StreamBulkOperationUpdatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations/stream/{operation_id}',
    ...options
});

/**
 * Stream Bulk Operations History
 *
 * Server-Sent Events stream for bulk operations history updates for the current user.
 *
 * Publishes lightweight notifications to trigger client-side refetch of the history list.
 * Channel: 'bulk_operations:user:{user_id}'.
 */
export const streamBulkOperationsHistory = <ThrowOnError extends boolean = false>(options?: Options<StreamBulkOperationsHistoryData, ThrowOnError>): RequestResult<StreamBulkOperationsHistoryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StreamBulkOperationsHistoryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations/stream/history',
    ...options
});

/**
 * Get Bulk Operations Metrics
 *
 * Get aggregated metrics for bulk operations over a specified time period.
 *
 * This endpoint provides monitoring data including:
 * - Total operations count
 * - Success/failure rates
 * - Average processing time
 * - Average referrals per operation
 * - Performance trends
 *
 * Args:
 * session: Database session
 * current_user: Current authenticated user
 * days: Number of days to analyze (default: 7, max: 90)
 *
 * Returns:
 * Dictionary with aggregated metrics
 *
 * Raises:
 * HTTPException: 403 if user is not a System Administrator
 */
export const getBulkOperationsMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetBulkOperationsMetricsData, ThrowOnError>): RequestResult<GetBulkOperationsMetricsResponses, GetBulkOperationsMetricsErrors, ThrowOnError> => (options?.client ?? client).get<GetBulkOperationsMetricsResponses, GetBulkOperationsMetricsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/bulk-operations/metrics/summary',
    ...options
});

/**
 * Delete Referral
 *
 * Delete a referral.
 */
export const deleteReferral = <ThrowOnError extends boolean = false>(options: Options<DeleteReferralData, ThrowOnError>): RequestResult<DeleteReferralResponses, DeleteReferralErrors, ThrowOnError> => (options.client ?? client).delete<DeleteReferralResponses, DeleteReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/{id}',
    ...options
});

/**
 * Read Referral
 *
 * Get referral by ID.
 */
export const readReferral = <ThrowOnError extends boolean = false>(options: Options<ReadReferralData, ThrowOnError>): RequestResult<ReadReferralResponses, ReadReferralErrors, ThrowOnError> => (options.client ?? client).get<ReadReferralResponses, ReadReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/{id}',
    ...options
});

/**
 * Update Referral
 *
 * Update an referral.
 */
export const updateReferral = <ThrowOnError extends boolean = false>(options: Options<UpdateReferralData, ThrowOnError>): RequestResult<UpdateReferralResponses, UpdateReferralErrors, ThrowOnError> => (options.client ?? client).put<UpdateReferralResponses, UpdateReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referrals/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Available Workflows
 *
 * List published workflows available for claim summary generation.
 * Returns workflow_key, display_name, and description for each workflow.
 * Uses referrals permission (same as other claim summary endpoints).
 */
export const listAvailableWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListAvailableWorkflowsData, ThrowOnError>): RequestResult<ListAvailableWorkflowsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAvailableWorkflowsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/workflows',
    ...options
});

/**
 * Generate Summary
 *
 * Generate an AI claim summary for a referral using the Celery AI task (async).
 * Returns a task_id for polling.
 *
 * Security features:
 * - Rate limiting: 100 requests per hour per user
 * - Input sanitization: All context data is sanitized
 * - Audit logging: All requests are logged
 * - Role-based access control: Checks user permissions
 *
 * Request body:
 * - referral_id: int (required) - The referral ID to generate summary for
 * - version: str (optional) - Summary version: 'simple', 'standard', or 'enhanced' (default: 'standard')
 * - model: str (optional) - AI model key (default: 'sonnet46'; see BEDROCK_SUMMARY_MODEL_KEYS)
 * - priority: int (optional) - Task priority (0-9, default 5, higher = more urgent)
 *
 * Summary versions:
 * - simple: Brief overview (1-2 sentences, ~150 tokens)
 * - standard: Balanced summary (1 paragraph, ~250 tokens)
 * - enhanced: Detailed analysis (2-3 paragraphs, ~500 tokens)
 *
 * Model options:
 * - sonnet46: Claude Sonnet 4.6 on Bedrock (default)
 * - sonnet: Claude Sonnet 4.5 via AWS Bedrock
 */
export const generateSummary = <ThrowOnError extends boolean = false>(options: Options<GenerateSummaryData, ThrowOnError>): RequestResult<GenerateSummaryResponses, GenerateSummaryErrors, ThrowOnError> => (options.client ?? client).post<GenerateSummaryResponses, GenerateSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Summary Status
 *
 * Poll the status/result of a claim summary generation task.
 *
 * Returns:
 * - status: Task state (pending, started, success, failure, retry)
 * - result: Task result (if success)
 * - error: Error message (if failure)
 * - metadata: Task metadata including generation time, model version, etc.
 * - summary_id: Database ID of the saved summary (if available)
 */
export const getSummaryStatus = <ThrowOnError extends boolean = false>(options: Options<GetSummaryStatusData, ThrowOnError>): RequestResult<GetSummaryStatusResponses, GetSummaryStatusErrors, ThrowOnError> => (options.client ?? client).get<GetSummaryStatusResponses, GetSummaryStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/status/{task_id}',
    ...options
});

/**
 * Stream Summary Status
 *
 * Stream the status of a claim summary generation task using Server-Sent Events.
 *
 * Returns real-time updates as the task progresses:
 * - started: Task has begun processing
 * - processing: Task is still running with elapsed time
 * - success: Task completed with result
 * - failure: Task failed with error message
 *
 * Connection remains open until task completes or client disconnects.
 */
export const streamSummaryStatus = <ThrowOnError extends boolean = false>(options: Options<StreamSummaryStatusData, ThrowOnError>): RequestResult<StreamSummaryStatusResponses, StreamSummaryStatusErrors, ThrowOnError> => (options.client ?? client).get<StreamSummaryStatusResponses, StreamSummaryStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/stream/{task_id}',
    ...options
});

/**
 * Get Latest Summary
 *
 * Get the latest successful AI-generated summary for a referral.
 *
 * Returns the most recent successful summary with metadata.
 */
export const getLatestSummary = <ThrowOnError extends boolean = false>(options: Options<GetLatestSummaryData, ThrowOnError>): RequestResult<GetLatestSummaryResponses, GetLatestSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetLatestSummaryResponses, GetLatestSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/latest/referral/{referral_id}',
    ...options
});

/**
 * Get Recent Summary Runs
 *
 * List recent claim summary runs across referrals for AI Claims users.
 */
export const getRecentSummaryRuns = <ThrowOnError extends boolean = false>(options?: Options<GetRecentSummaryRunsData, ThrowOnError>): RequestResult<GetRecentSummaryRunsResponses, GetRecentSummaryRunsErrors, ThrowOnError> => (options?.client ?? client).get<GetRecentSummaryRunsResponses, GetRecentSummaryRunsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/recent',
    ...options
});

/**
 * Get Summary History
 *
 * Get the history of AI-generated summaries for a referral.
 *
 * Returns up to `limit` summaries ordered by creation date (newest first).
 * Useful for tracking how summaries change over time as data changes.
 */
export const getSummaryHistory = <ThrowOnError extends boolean = false>(options: Options<GetSummaryHistoryData, ThrowOnError>): RequestResult<GetSummaryHistoryResponses, GetSummaryHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetSummaryHistoryResponses, GetSummaryHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/history/referral/{referral_id}',
    ...options
});

/**
 * Get Summary Detail
 *
 * Get detailed information about a specific summary including prompts and context.
 *
 * This endpoint is useful for debugging and understanding how the AI generated
 * a particular summary. Only accessible to authorized users for audit purposes.
 */
export const getSummaryDetail = <ThrowOnError extends boolean = false>(options: Options<GetSummaryDetailData, ThrowOnError>): RequestResult<GetSummaryDetailResponses, GetSummaryDetailErrors, ThrowOnError> => (options.client ?? client).get<GetSummaryDetailResponses, GetSummaryDetailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/detail/{summary_id}',
    ...options
});

/**
 * Get Bot Scores For Referral
 *
 * Get the latest score and summary for each Matt bot (Priya, Layla, Robyn, Tony, Omar, Remi)
 * for a referral.
 *
 * Uses agent_runs to find the most recent successful run per bot across all workflow runs.
 * Bots that have not run show score=None and summary='Not run'.
 */
export const getBotScoresForReferral = <ThrowOnError extends boolean = false>(options: Options<GetBotScoresForReferralData, ThrowOnError>): RequestResult<GetBotScoresForReferralResponses, GetBotScoresForReferralErrors, ThrowOnError> => (options.client ?? client).get<GetBotScoresForReferralResponses, GetBotScoresForReferralErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/referral/{referral_id}/bot-scores',
    ...options
});

/**
 * Get Audit Report
 *
 * Generate a Matt audit report as HTML or PDF.
 *
 * Accepts the parsed Matt audit structure (alex, sally, finalUrgency) from the frontend.
 * Use format="html" (default) for viewable HTML, format="pdf" for downloadable PDF.
 */
export const getAuditReport = <ThrowOnError extends boolean = false>(options: Options<GetAuditReportData, ThrowOnError>): RequestResult<GetAuditReportResponses, GetAuditReportErrors, ThrowOnError> => (options.client ?? client).post<GetAuditReportResponses, GetAuditReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/audit-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Matt Audit Pdf
 *
 * Legacy endpoint: generate and download a Matt audit report as PDF.
 * Prefer POST /audit-report with format=pdf.
 */
export const downloadMattAuditPdf = <ThrowOnError extends boolean = false>(options: Options<DownloadMattAuditPdfData, ThrowOnError>): RequestResult<DownloadMattAuditPdfResponses, DownloadMattAuditPdfErrors, ThrowOnError> => (options.client ?? client).post<DownloadMattAuditPdfResponses, DownloadMattAuditPdfErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/audit-report-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Workflow Claims Audit
 *
 * Run a config-driven workflow audit for a single referral.
 *
 * Request body:
 * - referral_id: int (required)
 * - workflow_key: str (required for non-default flows; defaults to matt)
 * - priority: int (optional, 0-9, default 5)
 * - partner_id: int (optional) - workflow partner override for admin/testing
 *
 * Returns:
 * - task_id: Celery task ID for polling / SSE
 * - summary_id: pending ClaimSummary record ID
 * - version: persisted summary version label
 * - workflow_key: workflow that was dispatched
 * - priority: task priority used
 */
export const generateWorkflowClaimsAudit = <ThrowOnError extends boolean = false>(options: Options<GenerateWorkflowClaimsAuditData, ThrowOnError>): RequestResult<GenerateWorkflowClaimsAuditResponses, GenerateWorkflowClaimsAuditErrors, ThrowOnError> => (options.client ?? client).post<GenerateWorkflowClaimsAuditResponses, GenerateWorkflowClaimsAuditErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/workflow/audit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Matt Claims Audit
 *
 * Deprecated: use POST /workflow/audit. Kept for backward compatibility.
 *
 * Accepts the same body as /workflow/audit (including workflow_key).
 *
 * @deprecated
 */
export const generateMattClaimsAudit = <ThrowOnError extends boolean = false>(options: Options<GenerateMattClaimsAuditData, ThrowOnError>): RequestResult<GenerateMattClaimsAuditResponses, GenerateMattClaimsAuditErrors, ThrowOnError> => (options.client ?? client).post<GenerateMattClaimsAuditResponses, GenerateMattClaimsAuditErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/matt/audit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Summary Feedback
 *
 * Submit in-app thumbs-up/down feedback for an AI claim summary.
 *
 * Creates a ``FeedbackRequest`` + ``FeedbackResponse`` pair for local reporting
 * and Grafana trace linkage via ``agent_runs.otel_trace_id``.
 */
export const submitSummaryFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitSummaryFeedbackData, ThrowOnError>): RequestResult<SubmitSummaryFeedbackResponses, SubmitSummaryFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitSummaryFeedbackResponses, SubmitSummaryFeedbackErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/summaries/referral/{referral_id}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Grafana Alert Webhook
 *
 * Receive Grafana Cloud webhook notifications with shared-secret validation.
 */
export const grafanaAlertWebhook = <ThrowOnError extends boolean = false>(options?: Options<GrafanaAlertWebhookData, ThrowOnError>): RequestResult<GrafanaAlertWebhookResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GrafanaAlertWebhookResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/grafana/webhook/',
    ...options
});

/**
 * Read Source Rates
 *
 * Retrieve source_rate_rates.
 */
export const readSourceRates = <ThrowOnError extends boolean = false>(options?: Options<ReadSourceRatesData, ThrowOnError>): RequestResult<ReadSourceRatesResponses, ReadSourceRatesErrors, ThrowOnError> => (options?.client ?? client).get<ReadSourceRatesResponses, ReadSourceRatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/source_rates/',
    ...options
});

/**
 * Create Source Rate
 *
 * Create new source_rate.
 */
export const createSourceRate = <ThrowOnError extends boolean = false>(options: Options<CreateSourceRateData, ThrowOnError>): RequestResult<CreateSourceRateResponses, CreateSourceRateErrors, ThrowOnError> => (options.client ?? client).post<CreateSourceRateResponses, CreateSourceRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/source_rates/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Source Rate
 *
 * Delete an source_rate.
 */
export const deleteSourceRate = <ThrowOnError extends boolean = false>(options: Options<DeleteSourceRateData, ThrowOnError>): RequestResult<DeleteSourceRateResponses, DeleteSourceRateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSourceRateResponses, DeleteSourceRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/source_rates/{id}',
    ...options
});

/**
 * Read Source Rate
 *
 * Get source_rate_rate by ID.
 */
export const readSourceRate = <ThrowOnError extends boolean = false>(options: Options<ReadSourceRateData, ThrowOnError>): RequestResult<ReadSourceRateResponses, ReadSourceRateErrors, ThrowOnError> => (options.client ?? client).get<ReadSourceRateResponses, ReadSourceRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/source_rates/{id}',
    ...options
});

/**
 * Update Source Rate
 *
 * Update an source_rate.
 */
export const updateSourceRate = <ThrowOnError extends boolean = false>(options: Options<UpdateSourceRateData, ThrowOnError>): RequestResult<UpdateSourceRateResponses, UpdateSourceRateErrors, ThrowOnError> => (options.client ?? client).put<UpdateSourceRateResponses, UpdateSourceRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/source_rates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Expire Source Rates
 *
 * Expire source rates for a given vehicle_type, partner_id, source_partner_id, and tier.
 *
 * If tier is provided, only rates for that specific tier will be expired.
 * Otherwise, all tiers will be affected.
 */
export const expireSourceRates = <ThrowOnError extends boolean = false>(options: Options<ExpireSourceRatesData, ThrowOnError>): RequestResult<ExpireSourceRatesResponses, ExpireSourceRatesErrors, ThrowOnError> => (options.client ?? client).post<ExpireSourceRatesResponses, ExpireSourceRatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/source_rates/expire',
    ...options
});

/**
 * Read Supplier Rates
 *
 * Retrieve supplier_rates.
 */
export const readSupplierRates = <ThrowOnError extends boolean = false>(options?: Options<ReadSupplierRatesData, ThrowOnError>): RequestResult<ReadSupplierRatesResponses, ReadSupplierRatesErrors, ThrowOnError> => (options?.client ?? client).get<ReadSupplierRatesResponses, ReadSupplierRatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/supplier_rates/',
    ...options
});

/**
 * Create Supplier Rate
 *
 * Create new supplier_rate.
 */
export const createSupplierRate = <ThrowOnError extends boolean = false>(options: Options<CreateSupplierRateData, ThrowOnError>): RequestResult<CreateSupplierRateResponses, CreateSupplierRateErrors, ThrowOnError> => (options.client ?? client).post<CreateSupplierRateResponses, CreateSupplierRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/supplier_rates/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Supplier Rate
 *
 * Delete an supplier_rate.
 */
export const deleteSupplierRate = <ThrowOnError extends boolean = false>(options: Options<DeleteSupplierRateData, ThrowOnError>): RequestResult<DeleteSupplierRateResponses, DeleteSupplierRateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSupplierRateResponses, DeleteSupplierRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/supplier_rates/{id}',
    ...options
});

/**
 * Read Supplier Rate
 *
 * Get supplier_rate_rate by ID.
 */
export const readSupplierRate = <ThrowOnError extends boolean = false>(options: Options<ReadSupplierRateData, ThrowOnError>): RequestResult<ReadSupplierRateResponses, ReadSupplierRateErrors, ThrowOnError> => (options.client ?? client).get<ReadSupplierRateResponses, ReadSupplierRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/supplier_rates/{id}',
    ...options
});

/**
 * Update Supplier Rate
 *
 * Update an supplier_rate.
 */
export const updateSupplierRate = <ThrowOnError extends boolean = false>(options: Options<UpdateSupplierRateData, ThrowOnError>): RequestResult<UpdateSupplierRateResponses, UpdateSupplierRateErrors, ThrowOnError> => (options.client ?? client).put<UpdateSupplierRateResponses, UpdateSupplierRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/supplier_rates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Expire Supplier Rates
 *
 * Expire supplier rates for a given vehicle_type, partner_id, and source_partner_id.
 */
export const expireSupplierRates = <ThrowOnError extends boolean = false>(options: Options<ExpireSupplierRatesData, ThrowOnError>): RequestResult<ExpireSupplierRatesResponses, ExpireSupplierRatesErrors, ThrowOnError> => (options.client ?? client).post<ExpireSupplierRatesResponses, ExpireSupplierRatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/supplier_rates/expire',
    ...options
});

/**
 * Read Veh Groups
 *
 * Retrieve veh_groups.
 */
export const readVehGroups = <ThrowOnError extends boolean = false>(options?: Options<ReadVehGroupsData, ThrowOnError>): RequestResult<ReadVehGroupsResponses, ReadVehGroupsErrors, ThrowOnError> => (options?.client ?? client).get<ReadVehGroupsResponses, ReadVehGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/veh_groups/',
    ...options
});

/**
 * Create Veh Group
 *
 * Create new veh_group.
 */
export const createVehGroup = <ThrowOnError extends boolean = false>(options: Options<CreateVehGroupData, ThrowOnError>): RequestResult<CreateVehGroupResponses, CreateVehGroupErrors, ThrowOnError> => (options.client ?? client).post<CreateVehGroupResponses, CreateVehGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/veh_groups/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Unique Types
 *
 * Retrieve a unique list of values from the 'type' column in veh_group.
 */
export const readUniqueTypes = <ThrowOnError extends boolean = false>(options?: Options<ReadUniqueTypesData, ThrowOnError>): RequestResult<ReadUniqueTypesResponses, ReadUniqueTypesErrors, ThrowOnError> => (options?.client ?? client).get<ReadUniqueTypesResponses, ReadUniqueTypesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/veh_groups/types',
    ...options
});

/**
 * Delete Veh Group
 *
 * Delete an veh_group.
 */
export const deleteVehGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteVehGroupData, ThrowOnError>): RequestResult<DeleteVehGroupResponses, DeleteVehGroupErrors, ThrowOnError> => (options.client ?? client).delete<DeleteVehGroupResponses, DeleteVehGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/veh_groups/{id}',
    ...options
});

/**
 * Read Veh Group
 *
 * Get veh_group by ID.
 */
export const readVehGroup = <ThrowOnError extends boolean = false>(options: Options<ReadVehGroupData, ThrowOnError>): RequestResult<ReadVehGroupResponses, ReadVehGroupErrors, ThrowOnError> => (options.client ?? client).get<ReadVehGroupResponses, ReadVehGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/veh_groups/{id}',
    ...options
});

/**
 * Update Veh Group
 *
 * Update an veh_group.
 */
export const updateVehGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateVehGroupData, ThrowOnError>): RequestResult<UpdateVehGroupResponses, UpdateVehGroupErrors, ThrowOnError> => (options.client ?? client).put<UpdateVehGroupResponses, UpdateVehGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/veh_groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Authorities
 *
 * Retrieve authorities.
 */
export const readAuthorities = <ThrowOnError extends boolean = false>(options?: Options<ReadAuthoritiesData, ThrowOnError>): RequestResult<ReadAuthoritiesResponses, ReadAuthoritiesErrors, ThrowOnError> => (options?.client ?? client).get<ReadAuthoritiesResponses, ReadAuthoritiesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/authorities/',
    ...options
});

/**
 * Create Authority
 *
 * Create new authority.
 */
export const createAuthority = <ThrowOnError extends boolean = false>(options: Options<CreateAuthorityData, ThrowOnError>): RequestResult<CreateAuthorityResponses, CreateAuthorityErrors, ThrowOnError> => (options.client ?? client).post<CreateAuthorityResponses, CreateAuthorityErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/authorities/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Authority
 *
 * Delete an authority.
 */
export const deleteAuthority = <ThrowOnError extends boolean = false>(options: Options<DeleteAuthorityData, ThrowOnError>): RequestResult<DeleteAuthorityResponses, DeleteAuthorityErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAuthorityResponses, DeleteAuthorityErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/authorities/{authority_id}',
    ...options
});

/**
 * Read Authority
 *
 * Get authority by ID.
 */
export const readAuthority = <ThrowOnError extends boolean = false>(options: Options<ReadAuthorityData, ThrowOnError>): RequestResult<ReadAuthorityResponses, ReadAuthorityErrors, ThrowOnError> => (options.client ?? client).get<ReadAuthorityResponses, ReadAuthorityErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/authorities/{authority_id}',
    ...options
});

/**
 * Update Authority
 *
 * Update an authority.
 */
export const updateAuthority = <ThrowOnError extends boolean = false>(options: Options<UpdateAuthorityData, ThrowOnError>): RequestResult<UpdateAuthorityResponses, UpdateAuthorityErrors, ThrowOnError> => (options.client ?? client).put<UpdateAuthorityResponses, UpdateAuthorityErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/authorities/{authority_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Upload Csv
 */
export const requestUploadCsv = <ThrowOnError extends boolean = false>(options: Options<RequestUploadCsvData, ThrowOnError>): RequestResult<RequestUploadCsvResponses, RequestUploadCsvErrors, ThrowOnError> => (options.client ?? client).post<RequestUploadCsvResponses, RequestUploadCsvErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/requests/import/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create Request
 */
export const createRequest = <ThrowOnError extends boolean = false>(options: Options<CreateRequestData, ThrowOnError>): RequestResult<CreateRequestResponses, CreateRequestErrors, ThrowOnError> => (options.client ?? client).post<CreateRequestResponses, CreateRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/requests/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Upload Csv No Partner Rules
 */
export const requestUploadCsvNoPartnerRules = <ThrowOnError extends boolean = false>(options: Options<RequestUploadCsvNoPartnerRulesData, ThrowOnError>): RequestResult<RequestUploadCsvNoPartnerRulesResponses, RequestUploadCsvNoPartnerRulesErrors, ThrowOnError> => (options.client ?? client).post<RequestUploadCsvNoPartnerRulesResponses, RequestUploadCsvNoPartnerRulesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/requests/import_no_rules/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Manual Request No Partner Rules
 */
export const manualRequestNoPartnerRules = <ThrowOnError extends boolean = false>(options: Options<ManualRequestNoPartnerRulesData, ThrowOnError>): RequestResult<ManualRequestNoPartnerRulesResponses, ManualRequestNoPartnerRulesErrors, ThrowOnError> => (options.client ?? client).post<ManualRequestNoPartnerRulesResponses, ManualRequestNoPartnerRulesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/requests/manual_request_no_rules/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read User Partners
 *
 * Retrieve user_partners.
 */
export const readUserPartners = <ThrowOnError extends boolean = false>(options?: Options<ReadUserPartnersData, ThrowOnError>): RequestResult<ReadUserPartnersResponses, ReadUserPartnersErrors, ThrowOnError> => (options?.client ?? client).get<ReadUserPartnersResponses, ReadUserPartnersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/user_partners/',
    ...options
});

/**
 * Create User Partner
 *
 * Create new user_partner.
 */
export const createUserPartner = <ThrowOnError extends boolean = false>(options: Options<CreateUserPartnerData, ThrowOnError>): RequestResult<CreateUserPartnerResponses, CreateUserPartnerErrors, ThrowOnError> => (options.client ?? client).post<CreateUserPartnerResponses, CreateUserPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/user_partners/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User Partner
 *
 * Delete an user_partner.
 */
export const deleteUserPartner = <ThrowOnError extends boolean = false>(options: Options<DeleteUserPartnerData, ThrowOnError>): RequestResult<DeleteUserPartnerResponses, DeleteUserPartnerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserPartnerResponses, DeleteUserPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/user_partners/{id}',
    ...options
});

/**
 * Read User Partner
 *
 * Get user_partner by ID.
 */
export const readUserPartner = <ThrowOnError extends boolean = false>(options: Options<ReadUserPartnerData, ThrowOnError>): RequestResult<ReadUserPartnerResponses, ReadUserPartnerErrors, ThrowOnError> => (options.client ?? client).get<ReadUserPartnerResponses, ReadUserPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/user_partners/{id}',
    ...options
});

/**
 * Update User Partner
 *
 * Update an user_partner.
 */
export const updateUserPartner = <ThrowOnError extends boolean = false>(options: Options<UpdateUserPartnerData, ThrowOnError>): RequestResult<UpdateUserPartnerResponses, UpdateUserPartnerErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserPartnerResponses, UpdateUserPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/user_partners/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Annies
 */
export const readAnnies = <ThrowOnError extends boolean = false>(options: Options<ReadAnniesData, ThrowOnError>): RequestResult<ReadAnniesResponses, ReadAnniesErrors, ThrowOnError> => (options.client ?? client).post<ReadAnniesResponses, ReadAnniesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/annies/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Annies Voice
 */
export const readAnniesVoice = <ThrowOnError extends boolean = false>(options?: Options<ReadAnniesVoiceData, ThrowOnError>): RequestResult<ReadAnniesVoiceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ReadAnniesVoiceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/annies/voice',
    ...options
});

/**
 * Liability Score Fast
 */
export const liabilityScoreFast = <ThrowOnError extends boolean = false>(options: Options<LiabilityScoreFastData, ThrowOnError>): RequestResult<LiabilityScoreFastResponses, LiabilityScoreFastErrors, ThrowOnError> => (options.client ?? client).post<LiabilityScoreFastResponses, LiabilityScoreFastErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/anniequickscore/score-fast',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Role Allocations
 *
 * Retrieve role_allocations.
 */
export const readRoleAllocations = <ThrowOnError extends boolean = false>(options?: Options<ReadRoleAllocationsData, ThrowOnError>): RequestResult<ReadRoleAllocationsResponses, ReadRoleAllocationsErrors, ThrowOnError> => (options?.client ?? client).get<ReadRoleAllocationsResponses, ReadRoleAllocationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_allocations/',
    ...options
});

/**
 * Create Role Allocation
 *
 * Create new role_allocation.
 */
export const createRoleAllocation = <ThrowOnError extends boolean = false>(options: Options<CreateRoleAllocationData, ThrowOnError>): RequestResult<CreateRoleAllocationResponses, CreateRoleAllocationErrors, ThrowOnError> => (options.client ?? client).post<CreateRoleAllocationResponses, CreateRoleAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_allocations/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Role Allocation
 *
 * Delete an role_allocation.
 */
export const deleteRoleAllocation = <ThrowOnError extends boolean = false>(options: Options<DeleteRoleAllocationData, ThrowOnError>): RequestResult<DeleteRoleAllocationResponses, DeleteRoleAllocationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRoleAllocationResponses, DeleteRoleAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_allocations/{id}',
    ...options
});

/**
 * Read Role Allocation
 *
 * Get role_allocation by ID.
 */
export const readRoleAllocation = <ThrowOnError extends boolean = false>(options: Options<ReadRoleAllocationData, ThrowOnError>): RequestResult<ReadRoleAllocationResponses, ReadRoleAllocationErrors, ThrowOnError> => (options.client ?? client).get<ReadRoleAllocationResponses, ReadRoleAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_allocations/{id}',
    ...options
});

/**
 * Update Role Allocation
 *
 * Update an role_allocation.
 */
export const updateRoleAllocation = <ThrowOnError extends boolean = false>(options: Options<UpdateRoleAllocationData, ThrowOnError>): RequestResult<UpdateRoleAllocationResponses, UpdateRoleAllocationErrors, ThrowOnError> => (options.client ?? client).put<UpdateRoleAllocationResponses, UpdateRoleAllocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_allocations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Roles
 *
 * Retrieve roles.
 */
export const readRoles = <ThrowOnError extends boolean = false>(options?: Options<ReadRolesData, ThrowOnError>): RequestResult<ReadRolesResponses, ReadRolesErrors, ThrowOnError> => (options?.client ?? client).get<ReadRolesResponses, ReadRolesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/roles/',
    ...options
});

/**
 * Create Role
 *
 * Create new role.
 */
export const createRole = <ThrowOnError extends boolean = false>(options: Options<CreateRoleData, ThrowOnError>): RequestResult<CreateRoleResponses, CreateRoleErrors, ThrowOnError> => (options.client ?? client).post<CreateRoleResponses, CreateRoleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/roles/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Role
 *
 * Delete an role.
 */
export const deleteRole = <ThrowOnError extends boolean = false>(options: Options<DeleteRoleData, ThrowOnError>): RequestResult<DeleteRoleResponses, DeleteRoleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRoleResponses, DeleteRoleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/roles/{id}',
    ...options
});

/**
 * Read Role
 *
 * Get role by ID.
 */
export const readRole = <ThrowOnError extends boolean = false>(options: Options<ReadRoleData, ThrowOnError>): RequestResult<ReadRoleResponses, ReadRoleErrors, ThrowOnError> => (options.client ?? client).get<ReadRoleResponses, ReadRoleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/roles/{id}',
    ...options
});

/**
 * Update Role
 *
 * Update an role.
 */
export const updateRole = <ThrowOnError extends boolean = false>(options: Options<UpdateRoleData, ThrowOnError>): RequestResult<UpdateRoleResponses, UpdateRoleErrors, ThrowOnError> => (options.client ?? client).put<UpdateRoleResponses, UpdateRoleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/roles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Role Permissions
 *
 * Retrieve role_permissions.
 */
export const readRolePermissions = <ThrowOnError extends boolean = false>(options?: Options<ReadRolePermissionsData, ThrowOnError>): RequestResult<ReadRolePermissionsResponses, ReadRolePermissionsErrors, ThrowOnError> => (options?.client ?? client).get<ReadRolePermissionsResponses, ReadRolePermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_permissions/',
    ...options
});

/**
 * Create Role Permission
 *
 * Create new role_permission.
 */
export const createRolePermission = <ThrowOnError extends boolean = false>(options: Options<CreateRolePermissionData, ThrowOnError>): RequestResult<CreateRolePermissionResponses, CreateRolePermissionErrors, ThrowOnError> => (options.client ?? client).post<CreateRolePermissionResponses, CreateRolePermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_permissions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Role Permission
 *
 * Delete an role_permission.
 */
export const deleteRolePermission = <ThrowOnError extends boolean = false>(options: Options<DeleteRolePermissionData, ThrowOnError>): RequestResult<DeleteRolePermissionResponses, DeleteRolePermissionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRolePermissionResponses, DeleteRolePermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_permissions/{id}',
    ...options
});

/**
 * Read Role Permission
 *
 * Get role_permission by ID.
 */
export const readRolePermission = <ThrowOnError extends boolean = false>(options: Options<ReadRolePermissionData, ThrowOnError>): RequestResult<ReadRolePermissionResponses, ReadRolePermissionErrors, ThrowOnError> => (options.client ?? client).get<ReadRolePermissionResponses, ReadRolePermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_permissions/{id}',
    ...options
});

/**
 * Update Role Permission
 *
 * Update an role_permission.
 */
export const updateRolePermission = <ThrowOnError extends boolean = false>(options: Options<UpdateRolePermissionData, ThrowOnError>): RequestResult<UpdateRolePermissionResponses, UpdateRolePermissionErrors, ThrowOnError> => (options.client ?? client).put<UpdateRolePermissionResponses, UpdateRolePermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/role_permissions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Otp
 */
export const validateOtp = <ThrowOnError extends boolean = false>(options: Options<ValidateOtpData, ThrowOnError>): RequestResult<ValidateOtpResponses, ValidateOtpErrors, ThrowOnError> => (options.client ?? client).post<ValidateOtpResponses, ValidateOtpErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/otp/validate-otp/{user_id}',
    ...options
});

/**
 * Upload Files
 */
export const uploadFiles = <ThrowOnError extends boolean = false>(options: Options<UploadFilesData, ThrowOnError>): RequestResult<UploadFilesResponses, UploadFilesErrors, ThrowOnError> => (options.client ?? client).post<UploadFilesResponses, UploadFilesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/uploads/upload_files/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download Claim File
 */
export const downloadClaimFile = <ThrowOnError extends boolean = false>(options: Options<DownloadClaimFileData, ThrowOnError>): RequestResult<DownloadClaimFileResponses, DownloadClaimFileErrors, ThrowOnError> => (options.client ?? client).get<DownloadClaimFileResponses, DownloadClaimFileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/uploads/download',
    ...options
});

/**
 * Get Download Status
 *
 * Get download status for all files in a referral for the current user.
 */
export const getDownloadStatus = <ThrowOnError extends boolean = false>(options: Options<GetDownloadStatusData, ThrowOnError>): RequestResult<GetDownloadStatusResponses, GetDownloadStatusErrors, ThrowOnError> => (options.client ?? client).get<GetDownloadStatusResponses, GetDownloadStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/uploads/download-status',
    ...options
});

/**
 * Download Multiple Files
 *
 * Download multiple files as a zip archive.
 */
export const downloadMultipleFiles = <ThrowOnError extends boolean = false>(options: Options<DownloadMultipleFilesData, ThrowOnError>): RequestResult<DownloadMultipleFilesResponses, DownloadMultipleFilesErrors, ThrowOnError> => (options.client ?? client).post<DownloadMultipleFilesResponses, DownloadMultipleFilesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/uploads/download-multiple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Notification Options
 *
 * Get available partners for email notifications on note creation.
 */
export const getNotificationOptions = <ThrowOnError extends boolean = false>(options: Options<GetNotificationOptionsData, ThrowOnError>): RequestResult<GetNotificationOptionsResponses, GetNotificationOptionsErrors, ThrowOnError> => (options.client ?? client).get<GetNotificationOptionsResponses, GetNotificationOptionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/{referral_id}/notification-options',
    ...options
});

/**
 * Add Notes Batch
 */
export const addNotesBatch = <ThrowOnError extends boolean = false>(options: Options<AddNotesBatchData, ThrowOnError>): RequestResult<AddNotesBatchResponses, AddNotesBatchErrors, ThrowOnError> => (options.client ?? client).post<AddNotesBatchResponses, AddNotesBatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/notes/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Notes
 */
export const getNotes = <ThrowOnError extends boolean = false>(options: Options<GetNotesData, ThrowOnError>): RequestResult<GetNotesResponses, GetNotesErrors, ThrowOnError> => (options.client ?? client).get<GetNotesResponses, GetNotesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/{referral_id}/notes',
    ...options
});

/**
 * Add Note
 */
export const addNote = <ThrowOnError extends boolean = false>(options: Options<AddNoteData, ThrowOnError>): RequestResult<AddNoteResponses, AddNoteErrors, ThrowOnError> => (options.client ?? client).post<AddNoteResponses, AddNoteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/{referral_id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Note
 *
 * Delete a note.
 *
 * SECURITY (AUTHZ-VULN-12): Users can only delete notes they created,
 * unless they are a System Administrator.
 */
export const deleteNote = <ThrowOnError extends boolean = false>(options: Options<DeleteNoteData, ThrowOnError>): RequestResult<DeleteNoteResponses, DeleteNoteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteNoteResponses, DeleteNoteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/notes/{note_id}',
    ...options
});

/**
 * Update Note
 *
 * Update a note.
 *
 * SECURITY (AUTHZ-VULN-12): Users can only update notes they created,
 * unless they are a System Administrator.
 */
export const updateNote = <ThrowOnError extends boolean = false>(options: Options<UpdateNoteData, ThrowOnError>): RequestResult<UpdateNoteResponses, UpdateNoteErrors, ThrowOnError> => (options.client ?? client).put<UpdateNoteResponses, UpdateNoteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/notes/{note_id}',
    ...options
});

/**
 * Get Complaint Notes
 */
export const getComplaintNotes = <ThrowOnError extends boolean = false>(options: Options<GetComplaintNotesData, ThrowOnError>): RequestResult<GetComplaintNotesResponses, GetComplaintNotesErrors, ThrowOnError> => (options.client ?? client).get<GetComplaintNotesResponses, GetComplaintNotesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/complaints/{complaint_id}/notes',
    ...options
});

/**
 * Add Complaint Note
 */
export const addComplaintNote = <ThrowOnError extends boolean = false>(options: Options<AddComplaintNoteData, ThrowOnError>): RequestResult<AddComplaintNoteResponses, AddComplaintNoteErrors, ThrowOnError> => (options.client ?? client).post<AddComplaintNoteResponses, AddComplaintNoteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral_notes/complaints/{complaint_id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Referral Csv Columns
 */
export const listReferralCsvColumns = <ThrowOnError extends boolean = false>(options?: Options<ListReferralCsvColumnsData, ThrowOnError>): RequestResult<ListReferralCsvColumnsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListReferralCsvColumnsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/referral-reports/columns',
    ...options
});

/**
 * Parse Email
 *
 * @deprecated
 */
export const parseEmail = <ThrowOnError extends boolean = false>(options?: Options<ParseEmailData, ThrowOnError>): RequestResult<ParseEmailResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ParseEmailResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/newrefparser/parse-email/',
    ...options
});

/**
 * Incoming Call
 *
 * Twilio voice webhook. Requires valid X-Twilio-Signature.
 */
export const incomingCall = <ThrowOnError extends boolean = false>(options: Options<IncomingCallData, ThrowOnError>): RequestResult<IncomingCallResponses, IncomingCallErrors, ThrowOnError> => (options.client ?? client).post<IncomingCallResponses, IncomingCallErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    url: '/api/v1/calls/incoming-call/',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Generate Invoice Request Pdf Bulk
 *
 * Create invoice requests for all ready invoice request lines.
 * If partner_id is provided, only process that partner.
 * If partner_id is None, process all partners with ready lines.
 * Creates the Invoice record and updates all lines to 'requested' status.
 * Only accessible by System Administrator.
 */
export const generateInvoiceRequestPdfBulk = <ThrowOnError extends boolean = false>(options?: Options<GenerateInvoiceRequestPdfBulkData, ThrowOnError>): RequestResult<GenerateInvoiceRequestPdfBulkResponses, GenerateInvoiceRequestPdfBulkErrors, ThrowOnError> => (options?.client ?? client).post<GenerateInvoiceRequestPdfBulkResponses, GenerateInvoiceRequestPdfBulkErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-invoice-request-pdf-bulk',
    ...options
});

/**
 * Read Invoices
 *
 * Retrieve invoices. Only accessible by System Administrator.
 */
export const readInvoices = <ThrowOnError extends boolean = false>(options?: Options<ReadInvoicesData, ThrowOnError>): RequestResult<ReadInvoicesResponses, ReadInvoicesErrors, ThrowOnError> => (options?.client ?? client).get<ReadInvoicesResponses, ReadInvoicesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/',
    ...options
});

/**
 * Update Invoice Status
 *
 * Update invoice status. Only accessible by System Administrator.
 * Valid statuses: Pending, Paid, Part Paid, Cancelled, Credited
 */
export const updateInvoiceStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceStatusData, ThrowOnError>): RequestResult<UpdateInvoiceStatusResponses, UpdateInvoiceStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceStatusResponses, UpdateInvoiceStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{id}/status',
    ...options
});

/**
 * Pay Invoice
 *
 * Mark invoice as paid and also mark all related invoice lines as paid.
 * Only accessible by System Administrator.
 */
export const payInvoice = <ThrowOnError extends boolean = false>(options: Options<PayInvoiceData, ThrowOnError>): RequestResult<PayInvoiceResponses, PayInvoiceErrors, ThrowOnError> => (options.client ?? client).patch<PayInvoiceResponses, PayInvoiceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{id}/pay',
    ...options
});

/**
 * Pay Invoice With Lines
 *
 * Mark invoice as paid and also mark all related invoice lines as paid.
 * Only accessible by System Administrator.
 */
export const payInvoiceWithLines = <ThrowOnError extends boolean = false>(options: Options<PayInvoiceWithLinesData, ThrowOnError>): RequestResult<PayInvoiceWithLinesResponses, PayInvoiceWithLinesErrors, ThrowOnError> => (options.client ?? client).patch<PayInvoiceWithLinesResponses, PayInvoiceWithLinesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{id}/pay-with-lines',
    ...options
});

/**
 * Credit Invoice
 *
 * Mark invoice as credited. Only accessible by System Administrator.
 */
export const creditInvoice = <ThrowOnError extends boolean = false>(options: Options<CreditInvoiceData, ThrowOnError>): RequestResult<CreditInvoiceResponses, CreditInvoiceErrors, ThrowOnError> => (options.client ?? client).patch<CreditInvoiceResponses, CreditInvoiceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{id}/credit',
    ...options
});

/**
 * Delete Invoice
 *
 * Delete invoice. Only accessible by System Administrator.
 */
export const deleteInvoice = <ThrowOnError extends boolean = false>(options: Options<DeleteInvoiceData, ThrowOnError>): RequestResult<DeleteInvoiceResponses, DeleteInvoiceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvoiceResponses, DeleteInvoiceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{id}',
    ...options
});

/**
 * Read Invoice
 *
 * Get invoice by ID. Only accessible by System Administrator.
 */
export const readInvoice = <ThrowOnError extends boolean = false>(options: Options<ReadInvoiceData, ThrowOnError>): RequestResult<ReadInvoiceResponses, ReadInvoiceErrors, ThrowOnError> => (options.client ?? client).get<ReadInvoiceResponses, ReadInvoiceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{id}',
    ...options
});

/**
 * Trigger Invoice Generation
 *
 * Trigger generation of invoices for a specific billing date.
 * Only accessible by System Administrator.
 */
export const triggerInvoiceGeneration = <ThrowOnError extends boolean = false>(options: Options<TriggerInvoiceGenerationData, ThrowOnError>): RequestResult<TriggerInvoiceGenerationResponses, TriggerInvoiceGenerationErrors, ThrowOnError> => (options.client ?? client).post<TriggerInvoiceGenerationResponses, TriggerInvoiceGenerationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate',
    ...options
});

/**
 * Get Invoice Task Status
 *
 * Poll the status/result of an invoice generation task.
 *
 * Restricted to system administrators; responses omit worker hostnames, internal IDs,
 * and raw Celery exception payloads.
 */
export const getInvoiceTaskStatus = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceTaskStatusData, ThrowOnError>): RequestResult<GetInvoiceTaskStatusResponses, GetInvoiceTaskStatusErrors, ThrowOnError> => (options.client ?? client).get<GetInvoiceTaskStatusResponses, GetInvoiceTaskStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/status/{task_id}',
    ...options
});

/**
 * Generate Invoice Lines Direct
 *
 * Generate invoice lines directly for a specific billing date.
 * This is the direct call version of generate_invoices_only from celery.
 * Only accessible by System Administrator.
 */
export const generateInvoiceLinesDirect = <ThrowOnError extends boolean = false>(options: Options<GenerateInvoiceLinesDirectData, ThrowOnError>): RequestResult<GenerateInvoiceLinesDirectResponses, GenerateInvoiceLinesDirectErrors, ThrowOnError> => (options.client ?? client).post<GenerateInvoiceLinesDirectResponses, GenerateInvoiceLinesDirectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-invoice-lines',
    ...options
});

/**
 * Generate Invoice Request Lines Direct
 *
 * Generate invoice request lines directly for a specific billing date.
 * This creates invoice requests from eligible referrals.
 * Only accessible by System Administrator.
 */
export const generateInvoiceRequestLinesDirect = <ThrowOnError extends boolean = false>(options: Options<GenerateInvoiceRequestLinesDirectData, ThrowOnError>): RequestResult<GenerateInvoiceRequestLinesDirectResponses, GenerateInvoiceRequestLinesDirectErrors, ThrowOnError> => (options.client ?? client).post<GenerateInvoiceRequestLinesDirectResponses, GenerateInvoiceRequestLinesDirectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-invoice-request-lines',
    ...options
});

/**
 * Get Invoice Lines
 *
 * Retrieve invoice lines with optional filtering.
 * Supports both regular invoice lines (type='invoice') and repair billing lines (type='repair_billing').
 * Only accessible by System Administrator.
 */
export const getInvoiceLines = <ThrowOnError extends boolean = false>(options?: Options<GetInvoiceLinesData, ThrowOnError>): RequestResult<GetInvoiceLinesResponses, GetInvoiceLinesErrors, ThrowOnError> => (options?.client ?? client).get<GetInvoiceLinesResponses, GetInvoiceLinesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/invoice-lines',
    ...options
});

/**
 * Update Invoice Line Status
 *
 * Update invoice line status.
 * Valid statuses for invoice lines: pending, ready, on_hold, rejected, invoiced, paid
 * Valid statuses for request lines: pending, ready, on_hold, rejected, requested
 * Valid statuses for repair billing lines: pending, ready, on_hold, rejected, invoiced, paid, cancelled, credited
 * Only accessible by System Administrator.
 */
export const updateInvoiceLineStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceLineStatusData, ThrowOnError>): RequestResult<UpdateInvoiceLineStatusResponses, UpdateInvoiceLineStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceLineStatusResponses, UpdateInvoiceLineStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/invoice-lines/{id}/status',
    ...options
});

/**
 * Update Invoice Line Rate
 *
 * Update invoice line rate and recalculate amount.
 * Only accessible by System Administrator.
 */
export const updateInvoiceLineRate = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceLineRateData, ThrowOnError>): RequestResult<UpdateInvoiceLineRateResponses, UpdateInvoiceLineRateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceLineRateResponses, UpdateInvoiceLineRateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/invoice-lines/{id}/rate',
    ...options
});

/**
 * Update Invoice Line Amount
 *
 * Update invoice line amount and/or billed amount.
 * Useful for repair billing where amounts may need manual adjustment.
 * Only accessible by System Administrator.
 */
export const updateInvoiceLineAmount = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceLineAmountData, ThrowOnError>): RequestResult<UpdateInvoiceLineAmountResponses, UpdateInvoiceLineAmountErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceLineAmountResponses, UpdateInvoiceLineAmountErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/invoice-lines/{id}/amount',
    ...options
});

/**
 * Pay Invoice Line
 *
 * Mark invoice line as paid and update invoice status accordingly.
 * Only accessible by System Administrator.
 */
export const payInvoiceLine = <ThrowOnError extends boolean = false>(options: Options<PayInvoiceLineData, ThrowOnError>): RequestResult<PayInvoiceLineResponses, PayInvoiceLineErrors, ThrowOnError> => (options.client ?? client).patch<PayInvoiceLineResponses, PayInvoiceLineErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/invoice-lines/{id}/pay',
    ...options
});

/**
 * Generate Invoice To Xero
 *
 * Generate invoices for all invoice lines with status 'ready'.
 * This will send to Xero, create invoice records in WyseHub, and update status to 'invoiced'.
 * Invoice lines are grouped by supplier (partner_id from related referral allocations).
 * Supports both regular invoice lines (type='invoice') and repair billing lines (type='repair_billing').
 * Only accessible by System Administrator.
 */
export const generateInvoiceToXero = <ThrowOnError extends boolean = false>(options?: Options<GenerateInvoiceToXeroData, ThrowOnError>): RequestResult<GenerateInvoiceToXeroResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateInvoiceToXeroResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-invoice',
    ...options
});

/**
 * Get Invoice Request Lines
 *
 * Retrieve invoice request lines with optional status filter.
 * Only accessible by System Administrator.
 * Valid statuses: pending, ready, on_hold, rejected, requested
 */
export const getInvoiceRequestLines = <ThrowOnError extends boolean = false>(options?: Options<GetInvoiceRequestLinesData, ThrowOnError>): RequestResult<GetInvoiceRequestLinesResponses, GetInvoiceRequestLinesErrors, ThrowOnError> => (options?.client ?? client).get<GetInvoiceRequestLinesResponses, GetInvoiceRequestLinesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/invoice-request-lines',
    ...options
});

/**
 * Get Pending Request Lines By Supplier
 *
 * Retrieve pending, ready, and on hold invoice request lines grouped by supplier/partner.
 * Only accessible by System Administrator.
 */
export const getPendingRequestLinesBySupplier = <ThrowOnError extends boolean = false>(options?: Options<GetPendingRequestLinesBySupplierData, ThrowOnError>): RequestResult<GetPendingRequestLinesBySupplierResponses, GetPendingRequestLinesBySupplierErrors, ThrowOnError> => (options?.client ?? client).get<GetPendingRequestLinesBySupplierResponses, GetPendingRequestLinesBySupplierErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/pending-request-lines-by-supplier',
    ...options
});

/**
 * Generate Invoice Request Pdf
 *
 * Create an invoice request for a single request line and update status to 'requested'.
 * Only accessible by System Administrator.
 */
export const generateInvoiceRequestPdf = <ThrowOnError extends boolean = false>(options: Options<GenerateInvoiceRequestPdfData, ThrowOnError>): RequestResult<GenerateInvoiceRequestPdfResponses, GenerateInvoiceRequestPdfErrors, ThrowOnError> => (options.client ?? client).post<GenerateInvoiceRequestPdfResponses, GenerateInvoiceRequestPdfErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-invoice-request-pdf/{line_id}',
    ...options
});

/**
 * Generate Api Usage Billing Lines Direct
 *
 * Generate API usage billing lines for all partners with active billing configurations.
 */
export const generateApiUsageBillingLinesDirect = <ThrowOnError extends boolean = false>(options: Options<GenerateApiUsageBillingLinesDirectData, ThrowOnError>): RequestResult<GenerateApiUsageBillingLinesDirectResponses, GenerateApiUsageBillingLinesDirectErrors, ThrowOnError> => (options.client ?? client).post<GenerateApiUsageBillingLinesDirectResponses, GenerateApiUsageBillingLinesDirectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-api-usage-billing-lines',
    ...options
});

/**
 * Generate Partner Api Usage Billing Direct
 *
 * Generate API usage billing for a specific partner.
 * If generate_invoice is True (default), will also create the invoice immediately.
 */
export const generatePartnerApiUsageBillingDirect = <ThrowOnError extends boolean = false>(options: Options<GeneratePartnerApiUsageBillingDirectData, ThrowOnError>): RequestResult<GeneratePartnerApiUsageBillingDirectResponses, GeneratePartnerApiUsageBillingDirectErrors, ThrowOnError> => (options.client ?? client).post<GeneratePartnerApiUsageBillingDirectResponses, GeneratePartnerApiUsageBillingDirectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-partner-api-usage-billing/{partner_id}',
    ...options
});

/**
 * Get Api Usage Billing Summary All
 *
 * Get API usage billing summary.
 *
 * If a partner_id is provided as a query parameter, return that partner's
 * summary; otherwise return an empty summary payload.
 */
export const getApiUsageBillingSummaryAll = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsageBillingSummaryAllData, ThrowOnError>): RequestResult<GetApiUsageBillingSummaryAllResponses, GetApiUsageBillingSummaryAllErrors, ThrowOnError> => (options?.client ?? client).get<GetApiUsageBillingSummaryAllResponses, GetApiUsageBillingSummaryAllErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/api-usage-billing-summary',
    ...options
});

/**
 * Get Api Usage Billing Summary
 *
 * Get API usage billing summary for a partner.
 */
export const getApiUsageBillingSummary = <ThrowOnError extends boolean = false>(options: Options<GetApiUsageBillingSummaryData, ThrowOnError>): RequestResult<GetApiUsageBillingSummaryResponses, GetApiUsageBillingSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetApiUsageBillingSummaryResponses, GetApiUsageBillingSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/api-usage-billing-summary/{partner_id}',
    ...options
});

/**
 * Generate Api Usage Invoices
 *
 * Generate invoices for all API usage billing lines with status 'pending'.
 * This will create invoices in WyseHub and Xero for API usage billing.
 * Only accessible by System Administrator.
 */
export const generateApiUsageInvoices = <ThrowOnError extends boolean = false>(options?: Options<GenerateApiUsageInvoicesData, ThrowOnError>): RequestResult<GenerateApiUsageInvoicesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateApiUsageInvoicesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/generate-api-usage-invoices',
    ...options
});

/**
 * Get Xero Online Invoice Url
 *
 * Get the Xero online invoice URL for an invoice.
 * Requires the invoice to have a xero_invoice_id.
 * Note: This URL is now automatically fetched and stored in file_location when creating invoices.
 */
export const getXeroOnlineInvoiceUrl = <ThrowOnError extends boolean = false>(options: Options<GetXeroOnlineInvoiceUrlData, ThrowOnError>): RequestResult<GetXeroOnlineInvoiceUrlResponses, GetXeroOnlineInvoiceUrlErrors, ThrowOnError> => (options.client ?? client).get<GetXeroOnlineInvoiceUrlResponses, GetXeroOnlineInvoiceUrlErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/invoices/{invoice_id}/xero-online-url',
    ...options
});

/**
 * Get Partner Api Billing Configs
 *
 * Get all partner API billing configurations.
 */
export const getPartnerApiBillingConfigs = <ThrowOnError extends boolean = false>(options?: Options<GetPartnerApiBillingConfigsData, ThrowOnError>): RequestResult<GetPartnerApiBillingConfigsResponses, GetPartnerApiBillingConfigsErrors, ThrowOnError> => (options?.client ?? client).get<GetPartnerApiBillingConfigsResponses, GetPartnerApiBillingConfigsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/partner-configs',
    ...options
});

/**
 * Create Partner Api Billing Config
 *
 * Create API billing configuration for a partner.
 */
export const createPartnerApiBillingConfig = <ThrowOnError extends boolean = false>(options: Options<CreatePartnerApiBillingConfigData, ThrowOnError>): RequestResult<CreatePartnerApiBillingConfigResponses, CreatePartnerApiBillingConfigErrors, ThrowOnError> => (options.client ?? client).post<CreatePartnerApiBillingConfigResponses, CreatePartnerApiBillingConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/partner-configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Partner Api Billing Config
 *
 * Delete API billing configuration for a partner.
 */
export const deletePartnerApiBillingConfig = <ThrowOnError extends boolean = false>(options: Options<DeletePartnerApiBillingConfigData, ThrowOnError>): RequestResult<DeletePartnerApiBillingConfigResponses, DeletePartnerApiBillingConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeletePartnerApiBillingConfigResponses, DeletePartnerApiBillingConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/partner-configs/{partner_id}',
    ...options
});

/**
 * Get Partner Api Billing Config
 *
 * Get API billing configuration for a specific partner.
 */
export const getPartnerApiBillingConfig = <ThrowOnError extends boolean = false>(options: Options<GetPartnerApiBillingConfigData, ThrowOnError>): RequestResult<GetPartnerApiBillingConfigResponses, GetPartnerApiBillingConfigErrors, ThrowOnError> => (options.client ?? client).get<GetPartnerApiBillingConfigResponses, GetPartnerApiBillingConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/partner-configs/{partner_id}',
    ...options
});

/**
 * Update Partner Api Billing Config
 *
 * Update API billing configuration for a partner.
 */
export const updatePartnerApiBillingConfig = <ThrowOnError extends boolean = false>(options: Options<UpdatePartnerApiBillingConfigData, ThrowOnError>): RequestResult<UpdatePartnerApiBillingConfigResponses, UpdatePartnerApiBillingConfigErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePartnerApiBillingConfigResponses, UpdatePartnerApiBillingConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/partner-configs/{partner_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Api Usage
 *
 * Get API usage records from RequestLog with optional filtering.
 */
export const getApiUsage = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsageData, ThrowOnError>): RequestResult<GetApiUsageResponses, GetApiUsageErrors, ThrowOnError> => (options?.client ?? client).get<GetApiUsageResponses, GetApiUsageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/usage',
    ...options
});

/**
 * Update Api Usage Billing Status
 *
 * Update billing status of an API usage record.
 */
export const updateApiUsageBillingStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateApiUsageBillingStatusData, ThrowOnError>): RequestResult<UpdateApiUsageBillingStatusResponses, UpdateApiUsageBillingStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateApiUsageBillingStatusResponses, UpdateApiUsageBillingStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/usage/{usage_id}/billing-status',
    ...options
});

/**
 * Get Workflow Billing Ledger Summary
 *
 * Aggregate workflow billing ledger rows for a partner and billing month.
 *
 * Mirrors Annie/API usage summaries on the admin billing page: counts billable
 * (non-evaluation) runs by status. Evaluation-mode runs are counted separately.
 */
export const getWorkflowBillingLedgerSummary = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowBillingLedgerSummaryData, ThrowOnError>): RequestResult<GetWorkflowBillingLedgerSummaryResponses, GetWorkflowBillingLedgerSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowBillingLedgerSummaryResponses, GetWorkflowBillingLedgerSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-ledger/summary',
    ...options
});

/**
 * List Workflow Billing Ledger Events
 *
 * Paginated workflow billing ledger rows for the admin billing UI.
 */
export const listWorkflowBillingLedgerEvents = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowBillingLedgerEventsData, ThrowOnError>): RequestResult<ListWorkflowBillingLedgerEventsResponses, ListWorkflowBillingLedgerEventsErrors, ThrowOnError> => (options.client ?? client).get<ListWorkflowBillingLedgerEventsResponses, ListWorkflowBillingLedgerEventsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-ledger/events',
    ...options
});

/**
 * Get Workflow Rate Configs
 *
 * Get workflow rate configurations.
 * Optionally filter by partner_id and/or workflow_key.
 */
export const getWorkflowRateConfigs = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowRateConfigsData, ThrowOnError>): RequestResult<GetWorkflowRateConfigsResponses, GetWorkflowRateConfigsErrors, ThrowOnError> => (options?.client ?? client).get<GetWorkflowRateConfigsResponses, GetWorkflowRateConfigsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-rates',
    ...options
});

/**
 * Create Workflow Rate Config
 *
 * Create a new workflow rate configuration for a partner.
 */
export const createWorkflowRateConfig = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowRateConfigData, ThrowOnError>): RequestResult<CreateWorkflowRateConfigResponses, CreateWorkflowRateConfigErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkflowRateConfigResponses, CreateWorkflowRateConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-rates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Partner Workflow Rates
 *
 * Get all workflow rates for a specific partner.
 */
export const getPartnerWorkflowRates = <ThrowOnError extends boolean = false>(options: Options<GetPartnerWorkflowRatesData, ThrowOnError>): RequestResult<GetPartnerWorkflowRatesResponses, GetPartnerWorkflowRatesErrors, ThrowOnError> => (options.client ?? client).get<GetPartnerWorkflowRatesResponses, GetPartnerWorkflowRatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-rates/partner/{partner_id}',
    ...options
});

/**
 * Delete Workflow Rate Config
 *
 * Delete a workflow rate configuration.
 */
export const deleteWorkflowRateConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkflowRateConfigData, ThrowOnError>): RequestResult<DeleteWorkflowRateConfigResponses, DeleteWorkflowRateConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWorkflowRateConfigResponses, DeleteWorkflowRateConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-rates/{config_id}',
    ...options
});

/**
 * Get Workflow Rate Config
 *
 * Get a specific workflow rate configuration.
 */
export const getWorkflowRateConfig = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowRateConfigData, ThrowOnError>): RequestResult<GetWorkflowRateConfigResponses, GetWorkflowRateConfigErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowRateConfigResponses, GetWorkflowRateConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-rates/{config_id}',
    ...options
});

/**
 * Update Workflow Rate Config
 *
 * Update a workflow rate configuration.
 */
export const updateWorkflowRateConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowRateConfigData, ThrowOnError>): RequestResult<UpdateWorkflowRateConfigResponses, UpdateWorkflowRateConfigErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWorkflowRateConfigResponses, UpdateWorkflowRateConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/api-billing/workflow-rates/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger Repair Billing
 *
 * Trigger repair billing for specific date ranges.
 *
 * Creates invoice lines for repair allocations with invoice dates in the specified range.
 * Only accessible by superuser.
 *
 * Args:
 * start_date: Start date for repair_invoice_date filter (YYYY-MM-DD)
 * end_date: End date for repair_invoice_date filter (YYYY-MM-DD)
 * partner_id: Optional partner ID to filter repairs
 *
 * Returns:
 * Summary of repairs processed and invoice lines created
 */
export const triggerRepairBilling = <ThrowOnError extends boolean = false>(options: Options<TriggerRepairBillingData, ThrowOnError>): RequestResult<TriggerRepairBillingResponses, TriggerRepairBillingErrors, ThrowOnError> => (options.client ?? client).post<TriggerRepairBillingResponses, TriggerRepairBillingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/repair-billing/trigger',
    ...options
});

/**
 * Get Eligible Repairs
 *
 * Get repair allocations eligible for billing.
 *
 * Returns repairs with invoice dates that can be processed for billing.
 * Only accessible by superuser.
 *
 * Args:
 * start_date: Optional start date filter for repair_invoice_date
 * end_date: Optional end date filter for repair_invoice_date
 * partner_id: Optional partner ID filter
 * include_billed: Whether to include already billed repairs
 *
 * Returns:
 * List of eligible repair allocations with billing status
 */
export const getEligibleRepairs = <ThrowOnError extends boolean = false>(options?: Options<GetEligibleRepairsData, ThrowOnError>): RequestResult<GetEligibleRepairsResponses, GetEligibleRepairsErrors, ThrowOnError> => (options?.client ?? client).get<GetEligibleRepairsResponses, GetEligibleRepairsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/repair-billing/eligible-repairs',
    ...options
});

/**
 * Get Repair Allocation Billing Status
 *
 * Get the current billing status for a repair allocation.
 *
 * Returns detailed information about the billing state including:
 * - Whether the allocation is a repair
 * - Current billing status (unbilled, pending, ready, invoiced, paid, etc.)
 * - Associated invoice line information
 * - Repair invoice date
 *
 * Only accessible by System Administrator.
 */
export const getRepairAllocationBillingStatus = <ThrowOnError extends boolean = false>(options: Options<GetRepairAllocationBillingStatusData, ThrowOnError>): RequestResult<GetRepairAllocationBillingStatusResponses, GetRepairAllocationBillingStatusErrors, ThrowOnError> => (options.client ?? client).get<GetRepairAllocationBillingStatusResponses, GetRepairAllocationBillingStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/repair-billing/repair-allocations/{allocation_id}/billing-status',
    ...options
});

/**
 * Get Profiler Stats
 *
 * Get database query profiler statistics.
 */
export const getProfilerStats = <ThrowOnError extends boolean = false>(options?: Options<GetProfilerStatsData, ThrowOnError>): RequestResult<GetProfilerStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetProfilerStatsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/db-profiler/stats',
    ...options
});

/**
 * Enable Profiler
 *
 * Enable database query profiling.
 */
export const enableProfiler = <ThrowOnError extends boolean = false>(options?: Options<EnableProfilerData, ThrowOnError>): RequestResult<EnableProfilerResponses, unknown, ThrowOnError> => (options?.client ?? client).post<EnableProfilerResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/db-profiler/enable/',
    ...options
});

/**
 * Disable Profiler
 *
 * Disable database query profiling.
 */
export const disableProfiler = <ThrowOnError extends boolean = false>(options?: Options<DisableProfilerData, ThrowOnError>): RequestResult<DisableProfilerResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DisableProfilerResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/db-profiler/disable/',
    ...options
});

/**
 * Reset Profiler
 *
 * Reset all profiler statistics.
 */
export const resetProfiler = <ThrowOnError extends boolean = false>(options?: Options<ResetProfilerData, ThrowOnError>): RequestResult<ResetProfilerResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ResetProfilerResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/db-profiler/reset/',
    ...options
});

/**
 * Upload Edge Csv
 *
 * Upload an Edge CSV/Excel file for processing referral allocations.
 *
 * This endpoint accepts CSV or Excel files exported from the Edge system and processes
 * them using the referral allocation import system. The file is temporarily saved
 * and then processed asynchronously by a Celery task.
 *
 * Args:
 * current_user: The authenticated user (must be superuser)
 * partner_id: The partner ID to associate with all allocations
 * file: The CSV/Excel file to process
 *
 * Returns:
 * Dictionary with task ID and status information
 */
export const uploadEdgeCsv = <ThrowOnError extends boolean = false>(options: Options<UploadEdgeCsvData, ThrowOnError>): RequestResult<UploadEdgeCsvResponses, UploadEdgeCsvErrors, ThrowOnError> => (options.client ?? client).post<UploadEdgeCsvResponses, UploadEdgeCsvErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/edge-import/edge-csv-upload/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Edge Import Status
 *
 * Check the status of an Edge CSV/Excel import task.
 *
 * Access is limited to the submitting user (same partner) or System Administrators.
 */
export const getEdgeImportStatus = <ThrowOnError extends boolean = false>(options: Options<GetEdgeImportStatusData, ThrowOnError>): RequestResult<GetEdgeImportStatusResponses, GetEdgeImportStatusErrors, ThrowOnError> => (options.client ?? client).get<GetEdgeImportStatusResponses, GetEdgeImportStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/edge-import/edge-import-status/{task_id}',
    ...options
});

/**
 * Create Access Request
 *
 * Submit an access request.
 *
 * This endpoint processes access requests from the public Annie page
 * and sends a notification email to administrators.
 */
export const createAccessRequest = <ThrowOnError extends boolean = false>(options: Options<CreateAccessRequestData, ThrowOnError>): RequestResult<CreateAccessRequestResponses, CreateAccessRequestErrors, ThrowOnError> => (options.client ?? client).post<CreateAccessRequestResponses, CreateAccessRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/access-requests/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Xero Seed
 *
 * Seed Redis with a known refresh_token and tenant_id without interactive login.
 *
 * This is useful if you already have a refresh_token from a prior consent and want a
 * backend-only flow. We verify the token by exchanging it for an access token once and
 * store the payload in Redis with an expiry.
 */
export const xeroSeed = <ThrowOnError extends boolean = false>(options: Options<XeroSeedData, ThrowOnError>): RequestResult<XeroSeedResponses, XeroSeedErrors, ThrowOnError> => (options.client ?? client).post<XeroSeedResponses, XeroSeedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/seed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Xero Login
 *
 * Redirect the superuser to Xero for OAuth authorization.
 */
export const xeroLogin = <ThrowOnError extends boolean = false>(options?: Options<XeroLoginData, ThrowOnError>): RequestResult<XeroLoginResponses, unknown, ThrowOnError> => (options?.client ?? client).get<XeroLoginResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/login',
    ...options
});

/**
 * Xero Callback
 *
 * Handle Xero OAuth callback, exchange code, store tokens and tenant in Redis.
 */
export const xeroCallback = <ThrowOnError extends boolean = false>(options?: Options<XeroCallbackData, ThrowOnError>): RequestResult<XeroCallbackResponses, XeroCallbackErrors, ThrowOnError> => (options?.client ?? client).get<XeroCallbackResponses, XeroCallbackErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/callback/',
    ...options
});

/**
 * Xero Status
 *
 * Return whether we have Xero tokens in Redis and tenant id.
 */
export const xeroStatus = <ThrowOnError extends boolean = false>(options?: Options<XeroStatusData, ThrowOnError>): RequestResult<XeroStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<XeroStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/status',
    ...options
});

/**
 * Xero Logout
 *
 * Remove Xero tokens from Redis.
 */
export const xeroLogout = <ThrowOnError extends boolean = false>(options?: Options<XeroLogoutData, ThrowOnError>): RequestResult<XeroLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<XeroLogoutResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/logout',
    ...options
});

/**
 * List Xero Companies
 *
 * List all available Xero companies/organizations for the authenticated user.
 */
export const listXeroCompanies = <ThrowOnError extends boolean = false>(options?: Options<ListXeroCompaniesData, ThrowOnError>): RequestResult<ListXeroCompaniesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListXeroCompaniesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/companies',
    ...options
});

/**
 * Switch Xero Company
 *
 * Switch to a different Xero company/organization.
 */
export const switchXeroCompany = <ThrowOnError extends boolean = false>(options: Options<SwitchXeroCompanyData, ThrowOnError>): RequestResult<SwitchXeroCompanyResponses, SwitchXeroCompanyErrors, ThrowOnError> => (options.client ?? client).post<SwitchXeroCompanyResponses, SwitchXeroCompanyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/switch-company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Xero Webhook
 *
 * Receive Xero webhook notifications.
 *
 * Xero sends webhook notifications for various events like:
 * - Invoice created, updated, or deleted
 * - Contact created, updated, or deleted
 * - Payment created, updated, or deleted
 * - And other accounting events
 *
 * For now, we'll store all webhook data in the RequestLog table for analysis.
 * Once we understand the webhook payloads and timing, we can implement
 * specific handling for different event types.
 *
 * Reference: https://developer.xero.com/documentation/guides/webhooks/overview/
 */
export const xeroWebhook = <ThrowOnError extends boolean = false>(options?: Options<XeroWebhookData, ThrowOnError>): RequestResult<XeroWebhookResponses, unknown, ThrowOnError> => (options?.client ?? client).post<XeroWebhookResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/xero/webhook/',
    ...options
});

/**
 * List Batch Postprocessors
 *
 * List ai_prompt_configs eligible for post-batch processing.
 *
 * Eligibility is data-driven: rows with non-null batch_runner_spec and is_active.
 */
export const listBatchPostprocessors = <ThrowOnError extends boolean = false>(options?: Options<ListBatchPostprocessorsData, ThrowOnError>): RequestResult<ListBatchPostprocessorsResponses, ListBatchPostprocessorsErrors, ThrowOnError> => (options?.client ?? client).get<ListBatchPostprocessorsResponses, ListBatchPostprocessorsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/batch-postprocessors',
    ...options
});

/**
 * List Ai Prompt Configs
 *
 * List all AI prompt configurations.
 *
 * Requires authentication.
 */
export const listAiPromptConfigs = <ThrowOnError extends boolean = false>(options?: Options<ListAiPromptConfigsData, ThrowOnError>): RequestResult<ListAiPromptConfigsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAiPromptConfigsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/',
    ...options
});

/**
 * Create Prompt Config
 *
 * Create a new AI prompt configuration.
 *
 * Requires superuser privileges.
 */
export const createPromptConfig = <ThrowOnError extends boolean = false>(options: Options<CreatePromptConfigData, ThrowOnError>): RequestResult<CreatePromptConfigResponses, CreatePromptConfigErrors, ThrowOnError> => (options.client ?? client).post<CreatePromptConfigResponses, CreatePromptConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Ai Prompt Slots Route
 *
 * List prompt slots grouped by (agent_key, variant, model).
 */
export const listAiPromptSlotsRoute = <ThrowOnError extends boolean = false>(options?: Options<ListAiPromptSlotsRouteData, ThrowOnError>): RequestResult<ListAiPromptSlotsRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAiPromptSlotsRouteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/slots',
    ...options
});

/**
 * Get Prompt History
 *
 * Get revision history for a single prompt slot.
 */
export const getPromptHistory = <ThrowOnError extends boolean = false>(options: Options<GetPromptHistoryData, ThrowOnError>): RequestResult<GetPromptHistoryResponses, GetPromptHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetPromptHistoryResponses, GetPromptHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/history',
    ...options
});

/**
 * Get Ai Prompt Config
 *
 * Get AI prompt configuration by version and model.
 *
 * Requires authentication.
 */
export const getAiPromptConfig = <ThrowOnError extends boolean = false>(options: Options<GetAiPromptConfigData, ThrowOnError>): RequestResult<GetAiPromptConfigResponses, GetAiPromptConfigErrors, ThrowOnError> => (options.client ?? client).get<GetAiPromptConfigResponses, GetAiPromptConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/{version}/{model}',
    ...options
});

/**
 * Delete Prompt Config
 *
 * Delete an AI prompt configuration (soft delete by setting is_active=False).
 *
 * Requires superuser privileges.
 */
export const deletePromptConfig = <ThrowOnError extends boolean = false>(options: Options<DeletePromptConfigData, ThrowOnError>): RequestResult<DeletePromptConfigResponses, DeletePromptConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeletePromptConfigResponses, DeletePromptConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/{config_id}',
    ...options
});

/**
 * Update Prompt Config
 *
 * Update an AI prompt configuration.
 *
 * Requires superuser privileges.
 */
export const updatePromptConfig = <ThrowOnError extends boolean = false>(options: Options<UpdatePromptConfigData, ThrowOnError>): RequestResult<UpdatePromptConfigResponses, UpdatePromptConfigErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePromptConfigResponses, UpdatePromptConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Prompt Draft
 *
 * Create a draft revision (brand-new or cloned from an existing prompt).
 */
export const createPromptDraft = <ThrowOnError extends boolean = false>(options: Options<CreatePromptDraftData, ThrowOnError>): RequestResult<CreatePromptDraftResponses, CreatePromptDraftErrors, ThrowOnError> => (options.client ?? client).post<CreatePromptDraftResponses, CreatePromptDraftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/drafts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Prompt Draft
 *
 * Edit an existing draft revision.
 */
export const updatePromptDraft = <ThrowOnError extends boolean = false>(options: Options<UpdatePromptDraftData, ThrowOnError>): RequestResult<UpdatePromptDraftResponses, UpdatePromptDraftErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePromptDraftResponses, UpdatePromptDraftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/drafts/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Promote Prompt Draft
 *
 * Promote a draft revision to live immediately.
 */
export const promotePromptDraft = <ThrowOnError extends boolean = false>(options: Options<PromotePromptDraftData, ThrowOnError>): RequestResult<PromotePromptDraftResponses, PromotePromptDraftErrors, ThrowOnError> => (options.client ?? client).post<PromotePromptDraftResponses, PromotePromptDraftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/drafts/{config_id}/promote',
    ...options
});

/**
 * Retire Prompt Config
 *
 * Retire a prompt revision.
 */
export const retirePromptConfig = <ThrowOnError extends boolean = false>(options: Options<RetirePromptConfigData, ThrowOnError>): RequestResult<RetirePromptConfigResponses, RetirePromptConfigErrors, ThrowOnError> => (options.client ?? client).post<RetirePromptConfigResponses, RetirePromptConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai-prompt-configs/{config_id}/retire',
    ...options
});

/**
 * List Report Templates
 *
 * List all report templates. Authenticated users only.
 */
export const listReportTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListReportTemplatesData, ThrowOnError>): RequestResult<ListReportTemplatesResponses, ListReportTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<ListReportTemplatesResponses, ListReportTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/',
    ...options
});

/**
 * Create Report Template
 *
 * Create a new report template. Superuser only.
 */
export const createReportTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateReportTemplateData, ThrowOnError>): RequestResult<CreateReportTemplateResponses, CreateReportTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateReportTemplateResponses, CreateReportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Report Template
 *
 * Soft-delete a report template (sets is_active=False). Superuser only.
 */
export const deleteReportTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteReportTemplateData, ThrowOnError>): RequestResult<DeleteReportTemplateResponses, DeleteReportTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteReportTemplateResponses, DeleteReportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/{template_id}',
    ...options
});

/**
 * Get Report Template
 *
 * Get a single report template by ID.
 */
export const getReportTemplate = <ThrowOnError extends boolean = false>(options: Options<GetReportTemplateData, ThrowOnError>): RequestResult<GetReportTemplateResponses, GetReportTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetReportTemplateResponses, GetReportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/{template_id}',
    ...options
});

/**
 * Update Report Template
 *
 * Update an existing report template. Superuser only.
 */
export const updateReportTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateReportTemplateData, ThrowOnError>): RequestResult<UpdateReportTemplateResponses, UpdateReportTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateReportTemplateResponses, UpdateReportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/{template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate Report Template
 *
 * Duplicate an existing template. Superuser only.
 */
export const duplicateReportTemplate = <ThrowOnError extends boolean = false>(options: Options<DuplicateReportTemplateData, ThrowOnError>): RequestResult<DuplicateReportTemplateResponses, DuplicateReportTemplateErrors, ThrowOnError> => (options.client ?? client).post<DuplicateReportTemplateResponses, DuplicateReportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/{template_id}/duplicate',
    ...options
});

/**
 * Preview Report Template Pdf
 *
 * Render the PDF template with mock data through WeasyPrint (same path as scheduled PDFs).
 */
export const previewReportTemplatePdf = <ThrowOnError extends boolean = false>(options: Options<PreviewReportTemplatePdfData, ThrowOnError>): RequestResult<PreviewReportTemplatePdfResponses, PreviewReportTemplatePdfErrors, ThrowOnError> => (options.client ?? client).get<PreviewReportTemplatePdfResponses, PreviewReportTemplatePdfErrors, ThrowOnError>({ url: '/api/v1/report-templates/{template_id}/preview/pdf', ...options });

/**
 * Preview Report Template
 *
 * Render a template against mock data and return the result.
 *
 * ``channel`` can be ``email`` (default) or ``pdf``.
 * Returns ``{"subject": "...", "html": "..."}`` for email,
 * or ``{"html": "..."}`` for PDF (HTML before WeasyPrint).
 *
 * When ``batch_layout`` is true and ``channel`` is ``email``, the HTML matches the
 * scheduled batch email: metrics prelude + one claim card + footer (same as
 * ``email_prepend_metrics`` on).
 */
export const previewReportTemplate = <ThrowOnError extends boolean = false>(options: Options<PreviewReportTemplateData, ThrowOnError>): RequestResult<PreviewReportTemplateResponses, PreviewReportTemplateErrors, ThrowOnError> => (options.client ?? client).get<PreviewReportTemplateResponses, PreviewReportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/report-templates/{template_id}/preview',
    ...options
});

/**
 * Get Rate Limit Health
 *
 * Get comprehensive health status of the rate limiting system.
 *
 * This endpoint provides detailed health information about all rate limiting
 * components including Redis, database, configuration, and audit logging.
 *
 * Requires superuser privileges for security.
 *
 * Returns:
 * Dictionary with health status of all components
 */
export const monitoringGetRateLimitHealth = <ThrowOnError extends boolean = false>(options?: Options<MonitoringGetRateLimitHealthData, ThrowOnError>): RequestResult<MonitoringGetRateLimitHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MonitoringGetRateLimitHealthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/health',
    ...options
});

/**
 * Get Rate Limit Metrics
 *
 * Get comprehensive rate limiting metrics for monitoring dashboards.
 *
 * This endpoint provides detailed metrics about rate limiting performance,
 * usage patterns, and system health over a specified time period.
 *
 * Args:
 * hours: Number of hours of historical data to include (1-168 hours)
 *
 * Returns:
 * Dictionary with comprehensive rate limiting metrics
 */
export const monitoringGetRateLimitMetrics = <ThrowOnError extends boolean = false>(options?: Options<MonitoringGetRateLimitMetricsData, ThrowOnError>): RequestResult<MonitoringGetRateLimitMetricsResponses, MonitoringGetRateLimitMetricsErrors, ThrowOnError> => (options?.client ?? client).get<MonitoringGetRateLimitMetricsResponses, MonitoringGetRateLimitMetricsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/metrics',
    ...options
});

/**
 * Get Rate Limit Alerts
 *
 * Get current rate limiting alerts and warnings.
 *
 * This endpoint checks for various alert conditions including high activity,
 * low success rates, Redis issues, and suspicious patterns.
 *
 * Returns:
 * Dictionary with current alerts and their severity levels
 */
export const monitoringGetRateLimitAlerts = <ThrowOnError extends boolean = false>(options?: Options<MonitoringGetRateLimitAlertsData, ThrowOnError>): RequestResult<MonitoringGetRateLimitAlertsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MonitoringGetRateLimitAlertsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/alerts',
    ...options
});

/**
 * Get Rate Limit Statistics
 *
 * Get detailed rate limiting statistics and trends.
 *
 * This endpoint provides comprehensive statistical analysis of rate limiting
 * patterns, trends, and performance over a specified time period.
 *
 * Args:
 * days: Number of days of historical data to analyze (1-30 days)
 *
 * Returns:
 * Dictionary with detailed statistical analysis
 */
export const monitoringGetRateLimitStatistics = <ThrowOnError extends boolean = false>(options?: Options<MonitoringGetRateLimitStatisticsData, ThrowOnError>): RequestResult<MonitoringGetRateLimitStatisticsResponses, MonitoringGetRateLimitStatisticsErrors, ThrowOnError> => (options?.client ?? client).get<MonitoringGetRateLimitStatisticsResponses, MonitoringGetRateLimitStatisticsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/statistics',
    ...options
});

/**
 * Get Redis Status
 *
 * Get detailed Redis status for rate limiting operations.
 *
 * This endpoint provides comprehensive information about Redis health,
 * performance, and rate limiting key statistics.
 *
 * Returns:
 * Dictionary with Redis status and performance metrics
 */
export const monitoringGetRedisStatus = <ThrowOnError extends boolean = false>(options?: Options<MonitoringGetRedisStatusData, ThrowOnError>): RequestResult<MonitoringGetRedisStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MonitoringGetRedisStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/redis-status',
    ...options
});

/**
 * Force Cleanup
 *
 * Force cleanup of expired rate limiting data.
 *
 * This endpoint manually triggers cleanup of expired rate limiting entries
 * in Redis to free up memory and maintain performance.
 *
 * Requires superuser privileges.
 *
 * Returns:
 * Dictionary with cleanup results
 */
export const monitoringForceCleanup = <ThrowOnError extends boolean = false>(options?: Options<MonitoringForceCleanupData, ThrowOnError>): RequestResult<MonitoringForceCleanupResponses, unknown, ThrowOnError> => (options?.client ?? client).post<MonitoringForceCleanupResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/cleanup',
    ...options
});

/**
 * Get Dashboard Data
 *
 * Get comprehensive dashboard data for rate limiting monitoring.
 *
 * This endpoint provides all the data needed for a monitoring dashboard
 * including real-time metrics, health status, alerts, and trends.
 *
 * Returns:
 * Dictionary with comprehensive dashboard data
 */
export const monitoringGetDashboardData = <ThrowOnError extends boolean = false>(options?: Options<MonitoringGetDashboardDataData, ThrowOnError>): RequestResult<MonitoringGetDashboardDataResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MonitoringGetDashboardDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/rate-limiting/dashboard-data',
    ...options
});

/**
 * Reset User Rate Limit
 *
 * Reset Redis-backed rate limits for a specific user ID.
 *
 * If no resource is provided, this clears all known USER/PATH_USER resources.
 */
export const adminResetUserRateLimit = <ThrowOnError extends boolean = false>(options: Options<AdminResetUserRateLimitData, ThrowOnError>): RequestResult<AdminResetUserRateLimitResponses, AdminResetUserRateLimitErrors, ThrowOnError> => (options.client ?? client).post<AdminResetUserRateLimitResponses, AdminResetUserRateLimitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit/reset-user',
    ...options
});

/**
 * Reset Ip Rate Limit
 *
 * Reset Redis-backed rate limits for a specific client IP address.
 *
 * If no resource is provided, this clears all known IP-scoped resources.
 */
export const adminResetIpRateLimit = <ThrowOnError extends boolean = false>(options: Options<AdminResetIpRateLimitData, ThrowOnError>): RequestResult<AdminResetIpRateLimitResponses, AdminResetIpRateLimitErrors, ThrowOnError> => (options.client ?? client).post<AdminResetIpRateLimitResponses, AdminResetIpRateLimitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit/reset-ip',
    ...options
});

/**
 * Get Llm Cost Cap
 *
 * Get the daily LLM API cost cap (USD) and current usage.
 *
 * Requires superuser permissions.
 */
export const adminGetLlmCostCap = <ThrowOnError extends boolean = false>(options?: Options<AdminGetLlmCostCapData, ThrowOnError>): RequestResult<AdminGetLlmCostCapResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminGetLlmCostCapResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/llm-cost-cap',
    ...options
});

/**
 * Update Llm Cost Cap
 *
 * Update the daily LLM API cost cap (USD). Set to 0 to disable.
 *
 * Requires superuser permissions.
 */
export const adminUpdateLlmCostCap = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateLlmCostCapData, ThrowOnError>): RequestResult<AdminUpdateLlmCostCapResponses, AdminUpdateLlmCostCapErrors, ThrowOnError> => (options.client ?? client).put<AdminUpdateLlmCostCapResponses, AdminUpdateLlmCostCapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/llm-cost-cap',
    ...options
});

/**
 * Get Configuration Summary
 *
 * Get a summary of current rate limiting configuration.
 *
 * Requires superuser permissions.
 */
export const adminGetConfigurationSummary = <ThrowOnError extends boolean = false>(options?: Options<AdminGetConfigurationSummaryData, ThrowOnError>): RequestResult<AdminGetConfigurationSummaryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminGetConfigurationSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/summary',
    ...options
});

/**
 * Validate Configuration
 *
 * Validate current rate limiting configuration.
 *
 * Requires superuser permissions.
 */
export const adminValidateConfiguration = <ThrowOnError extends boolean = false>(options?: Options<AdminValidateConfigurationData, ThrowOnError>): RequestResult<AdminValidateConfigurationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminValidateConfigurationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/validate',
    ...options
});

/**
 * Reload Configuration
 *
 * Reload rate limiting configuration from database.
 *
 * This endpoint triggers a configuration reload in the unified rate limiting system.
 * Requires superuser permissions.
 */
export const reloadConfiguration = <ThrowOnError extends boolean = false>(options?: Options<ReloadConfigurationData, ThrowOnError>): RequestResult<ReloadConfigurationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ReloadConfigurationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/reload',
    ...options
});

/**
 * Seed Default Config
 *
 * Seed the database with default rate limiting configurations.
 *
 * Creates default configurations for common endpoints if they don't exist.
 * Requires superuser permissions.
 */
export const seedDefaultConfig = <ThrowOnError extends boolean = false>(options?: Options<SeedDefaultConfigData, ThrowOnError>): RequestResult<SeedDefaultConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SeedDefaultConfigResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/seed',
    ...options
});

/**
 * Read Rate Limit Configs
 *
 * Retrieve rate limiting configurations.
 *
 * Requires superuser permissions.
 */
export const adminReadRateLimitConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminReadRateLimitConfigsData, ThrowOnError>): RequestResult<AdminReadRateLimitConfigsResponses, AdminReadRateLimitConfigsErrors, ThrowOnError> => (options?.client ?? client).get<AdminReadRateLimitConfigsResponses, AdminReadRateLimitConfigsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit-configs/',
    ...options
});

/**
 * Create Rate Limit Config Endpoint
 *
 * Create new rate limiting configuration.
 *
 * Requires superuser permissions.
 */
export const createRateLimitConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateRateLimitConfigEndpointData, ThrowOnError>): RequestResult<CreateRateLimitConfigEndpointResponses, CreateRateLimitConfigEndpointErrors, ThrowOnError> => (options.client ?? client).post<CreateRateLimitConfigEndpointResponses, CreateRateLimitConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit-configs/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Rate Limit Config Endpoint
 *
 * Delete rate limiting configuration.
 *
 * Requires superuser permissions.
 */
export const deleteRateLimitConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteRateLimitConfigEndpointData, ThrowOnError>): RequestResult<DeleteRateLimitConfigEndpointResponses, DeleteRateLimitConfigEndpointErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRateLimitConfigEndpointResponses, DeleteRateLimitConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit-configs/{config_id}',
    ...options
});

/**
 * Read Rate Limit Config
 *
 * Get rate limiting configuration by ID.
 *
 * Requires superuser permissions.
 */
export const readRateLimitConfig = <ThrowOnError extends boolean = false>(options: Options<ReadRateLimitConfigData, ThrowOnError>): RequestResult<ReadRateLimitConfigResponses, ReadRateLimitConfigErrors, ThrowOnError> => (options.client ?? client).get<ReadRateLimitConfigResponses, ReadRateLimitConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit-configs/{config_id}',
    ...options
});

/**
 * Update Rate Limit Config Endpoint
 *
 * Update rate limiting configuration.
 *
 * Requires superuser permissions.
 */
export const updateRateLimitConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateRateLimitConfigEndpointData, ThrowOnError>): RequestResult<UpdateRateLimitConfigEndpointResponses, UpdateRateLimitConfigEndpointErrors, ThrowOnError> => (options.client ?? client).put<UpdateRateLimitConfigEndpointResponses, UpdateRateLimitConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit-configs/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Rate Limit Config By Endpoint
 *
 * Get rate limiting configuration by endpoint path and method.
 *
 * Requires superuser permissions.
 */
export const readRateLimitConfigByEndpoint = <ThrowOnError extends boolean = false>(options: Options<ReadRateLimitConfigByEndpointData, ThrowOnError>): RequestResult<ReadRateLimitConfigByEndpointResponses, ReadRateLimitConfigByEndpointErrors, ThrowOnError> => (options.client ?? client).get<ReadRateLimitConfigByEndpointResponses, ReadRateLimitConfigByEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/rate-limit-configs/endpoint/{endpoint_path}',
    ...options
});

/**
 * Read Bulk Operation Configs
 *
 * Retrieve bulk operation configurations.
 *
 * Requires superuser permissions.
 */
export const adminReadBulkOperationConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminReadBulkOperationConfigsData, ThrowOnError>): RequestResult<AdminReadBulkOperationConfigsResponses, AdminReadBulkOperationConfigsErrors, ThrowOnError> => (options?.client ?? client).get<AdminReadBulkOperationConfigsResponses, AdminReadBulkOperationConfigsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/bulk-configs/',
    ...options
});

/**
 * Create Bulk Operation Config Endpoint
 *
 * Create new bulk operation configuration.
 *
 * Requires superuser permissions.
 */
export const createBulkOperationConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateBulkOperationConfigEndpointData, ThrowOnError>): RequestResult<CreateBulkOperationConfigEndpointResponses, CreateBulkOperationConfigEndpointErrors, ThrowOnError> => (options.client ?? client).post<CreateBulkOperationConfigEndpointResponses, CreateBulkOperationConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/bulk-configs/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Bulk Operation Config Endpoint
 *
 * Delete bulk operation configuration.
 *
 * Requires superuser permissions.
 */
export const deleteBulkOperationConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteBulkOperationConfigEndpointData, ThrowOnError>): RequestResult<DeleteBulkOperationConfigEndpointResponses, DeleteBulkOperationConfigEndpointErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulkOperationConfigEndpointResponses, DeleteBulkOperationConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/bulk-configs/{config_id}',
    ...options
});

/**
 * Read Bulk Operation Config
 *
 * Get bulk operation configuration by ID.
 *
 * Requires superuser permissions.
 */
export const readBulkOperationConfig = <ThrowOnError extends boolean = false>(options: Options<ReadBulkOperationConfigData, ThrowOnError>): RequestResult<ReadBulkOperationConfigResponses, ReadBulkOperationConfigErrors, ThrowOnError> => (options.client ?? client).get<ReadBulkOperationConfigResponses, ReadBulkOperationConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/bulk-configs/{config_id}',
    ...options
});

/**
 * Update Bulk Operation Config Endpoint
 *
 * Update bulk operation configuration.
 *
 * Requires superuser permissions.
 */
export const updateBulkOperationConfigEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateBulkOperationConfigEndpointData, ThrowOnError>): RequestResult<UpdateBulkOperationConfigEndpointResponses, UpdateBulkOperationConfigEndpointErrors, ThrowOnError> => (options.client ?? client).put<UpdateBulkOperationConfigEndpointResponses, UpdateBulkOperationConfigEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/bulk-configs/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Bulk Operation Config By Name
 *
 * Get bulk operation configuration by name.
 *
 * Requires superuser permissions.
 */
export const readBulkOperationConfigByName = <ThrowOnError extends boolean = false>(options: Options<ReadBulkOperationConfigByNameData, ThrowOnError>): RequestResult<ReadBulkOperationConfigByNameResponses, ReadBulkOperationConfigByNameErrors, ThrowOnError> => (options.client ?? client).get<ReadBulkOperationConfigByNameResponses, ReadBulkOperationConfigByNameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/bulk-configs/name/{config_name}',
    ...options
});

/**
 * Clear Configuration Cache
 *
 * Clear the configuration cache and force reload from database.
 *
 * Requires superuser permissions.
 */
export const clearConfigurationCache = <ThrowOnError extends boolean = false>(options?: Options<ClearConfigurationCacheData, ThrowOnError>): RequestResult<ClearConfigurationCacheResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ClearConfigurationCacheResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/cache/clear',
    ...options
});

/**
 * Get Cache Status
 *
 * Get the current configuration cache status.
 *
 * Requires superuser permissions.
 */
export const getCacheStatus = <ThrowOnError extends boolean = false>(options?: Options<GetCacheStatusData, ThrowOnError>): RequestResult<GetCacheStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCacheStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/cache/status',
    ...options
});

/**
 * Update Cache Ttl
 *
 * Update the configuration cache TTL (Time To Live).
 *
 * Requires superuser permissions.
 */
export const updateCacheTtl = <ThrowOnError extends boolean = false>(options: Options<UpdateCacheTtlData, ThrowOnError>): RequestResult<UpdateCacheTtlResponses, UpdateCacheTtlErrors, ThrowOnError> => (options.client ?? client).put<UpdateCacheTtlResponses, UpdateCacheTtlErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/config/cache/ttl',
    ...options
});

/**
 * Get Endpoint Analytics
 *
 * Get comprehensive endpoint usage analytics for rate limiting management.
 *
 * Returns:
 * - Top endpoints by request count
 * - Rate limiting statistics
 * - Hourly request distribution
 * - Performance metrics
 */
export const getEndpointAnalytics = <ThrowOnError extends boolean = false>(options?: Options<GetEndpointAnalyticsData, ThrowOnError>): RequestResult<GetEndpointAnalyticsResponses, GetEndpointAnalyticsErrors, ThrowOnError> => (options?.client ?? client).get<GetEndpointAnalyticsResponses, GetEndpointAnalyticsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/analytics/endpoint-usage',
    ...options
});

/**
 * Get Rate Limit Recommendations
 *
 * Get intelligent recommendations for rate limit adjustments based on usage patterns.
 *
 * Analyzes the last 7 days of request data to identify:
 * - Endpoints with high rate limiting
 * - Potential configuration issues
 * - Suggested adjustments
 */
export const getRateLimitRecommendations = <ThrowOnError extends boolean = false>(options?: Options<GetRateLimitRecommendationsData, ThrowOnError>): RequestResult<GetRateLimitRecommendationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRateLimitRecommendationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/analytics/recommendations',
    ...options
});

/**
 * Get Real Time Stats
 *
 * Get real-time rate limiting statistics from Prometheus metrics and database.
 *
 * Returns current request rates, active rate limits, and system health.
 */
export const getRealTimeStats = <ThrowOnError extends boolean = false>(options?: Options<GetRealTimeStatsData, ThrowOnError>): RequestResult<GetRealTimeStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRealTimeStatsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/analytics/real-time-stats',
    ...options
});

/**
 * Get Request Logs
 *
 * Get detailed request logs for debugging and analysis.
 *
 * Useful for investigating specific rate limiting issues or understanding
 * traffic patterns for particular endpoints.
 */
export const getRequestLogs = <ThrowOnError extends boolean = false>(options?: Options<GetRequestLogsData, ThrowOnError>): RequestResult<GetRequestLogsResponses, GetRequestLogsErrors, ThrowOnError> => (options?.client ?? client).get<GetRequestLogsResponses, GetRequestLogsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/analytics/request-logs',
    ...options
});

/**
 * Export Analytics Data
 *
 * Export comprehensive analytics data for external analysis.
 *
 * Generates a downloadable report containing:
 * - Endpoint usage statistics
 * - Rate limiting events
 * - Performance metrics
 * - Configuration recommendations
 */
export const exportAnalyticsData = <ThrowOnError extends boolean = false>(options?: Options<ExportAnalyticsDataData, ThrowOnError>): RequestResult<ExportAnalyticsDataResponses, ExportAnalyticsDataErrors, ThrowOnError> => (options?.client ?? client).post<ExportAnalyticsDataResponses, ExportAnalyticsDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/analytics/export',
    ...options
});

/**
 * List Tables
 *
 * List allowlisted tables available via admin database endpoints.
 */
export const listTables = <ThrowOnError extends boolean = false>(options?: Options<ListTablesData, ThrowOnError>): RequestResult<ListTablesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTablesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/database/tables',
    ...options
});

/**
 * Read Table Rows
 *
 * Retrieve paginated rows for an allowlisted table with redaction and audit logging.
 */
export const readTableRows = <ThrowOnError extends boolean = false>(options: Options<ReadTableRowsData, ThrowOnError>): RequestResult<ReadTableRowsResponses, ReadTableRowsErrors, ThrowOnError> => (options.client ?? client).get<ReadTableRowsResponses, ReadTableRowsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/database/tables/{table_name}',
    ...options
});

/**
 * Create Table Row
 *
 * Create a new row in an allowlisted table.
 */
export const createTableRow = <ThrowOnError extends boolean = false>(options: Options<CreateTableRowData, ThrowOnError>): RequestResult<CreateTableRowResponses, CreateTableRowErrors, ThrowOnError> => (options.client ?? client).post<CreateTableRowResponses, CreateTableRowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/database/tables/{table_name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Table Row
 *
 * Delete a row from an allowlisted table.
 */
export const deleteTableRow = <ThrowOnError extends boolean = false>(options: Options<DeleteTableRowData, ThrowOnError>): RequestResult<DeleteTableRowResponses, DeleteTableRowErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTableRowResponses, DeleteTableRowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/database/tables/{table_name}/{row_id}',
    ...options
});

/**
 * Read Table Row
 *
 * Get a single row by ID from an allowlisted table.
 */
export const readTableRow = <ThrowOnError extends boolean = false>(options: Options<ReadTableRowData, ThrowOnError>): RequestResult<ReadTableRowResponses, ReadTableRowErrors, ThrowOnError> => (options.client ?? client).get<ReadTableRowResponses, ReadTableRowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/database/tables/{table_name}/{row_id}',
    ...options
});

/**
 * Update Table Row
 *
 * Update an existing row in an allowlisted table.
 */
export const updateTableRow = <ThrowOnError extends boolean = false>(options: Options<UpdateTableRowData, ThrowOnError>): RequestResult<UpdateTableRowResponses, UpdateTableRowErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTableRowResponses, UpdateTableRowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/database/tables/{table_name}/{row_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List App Settings
 *
 * List application settings for the current environment.
 *
 * Requires superuser permissions.
 */
export const listAppSettings = <ThrowOnError extends boolean = false>(options?: Options<ListAppSettingsData, ThrowOnError>): RequestResult<ListAppSettingsResponses, ListAppSettingsErrors, ThrowOnError> => (options?.client ?? client).get<ListAppSettingsResponses, ListAppSettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/settings/',
    ...options
});

/**
 * Create Setting
 *
 * Create a new application setting.
 *
 * Requires superuser permissions.
 */
export const createSetting = <ThrowOnError extends boolean = false>(options: Options<CreateSettingData, ThrowOnError>): RequestResult<CreateSettingResponses, CreateSettingErrors, ThrowOnError> => (options.client ?? client).post<CreateSettingResponses, CreateSettingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/settings/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Setting
 *
 * Delete an application setting.
 *
 * Requires superuser permissions.
 */
export const deleteSetting = <ThrowOnError extends boolean = false>(options: Options<DeleteSettingData, ThrowOnError>): RequestResult<DeleteSettingResponses, DeleteSettingErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSettingResponses, DeleteSettingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/settings/{setting_id}',
    ...options
});

/**
 * Get App Setting Endpoint
 *
 * Get an application setting by ID.
 *
 * Requires superuser permissions.
 */
export const getAppSettingEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetAppSettingEndpointData, ThrowOnError>): RequestResult<GetAppSettingEndpointResponses, GetAppSettingEndpointErrors, ThrowOnError> => (options.client ?? client).get<GetAppSettingEndpointResponses, GetAppSettingEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/settings/{setting_id}',
    ...options
});

/**
 * Update Setting
 *
 * Update an application setting.
 *
 * Requires superuser permissions.
 */
export const updateSetting = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingData, ThrowOnError>): RequestResult<UpdateSettingResponses, UpdateSettingErrors, ThrowOnError> => (options.client ?? client).put<UpdateSettingResponses, UpdateSettingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/settings/{setting_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Setting By Key
 *
 * Validate a setting exists by key and environment.
 *
 * Requires superuser permissions.
 */
export const validateSettingByKey = <ThrowOnError extends boolean = false>(options: Options<ValidateSettingByKeyData, ThrowOnError>): RequestResult<ValidateSettingByKeyResponses, ValidateSettingByKeyErrors, ThrowOnError> => (options.client ?? client).get<ValidateSettingByKeyResponses, ValidateSettingByKeyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/settings/validate/by-key',
    ...options
});

/**
 * Rehydrate Privacy Token
 *
 * Resolve a scoped privacy token for approved incident/audit workflows.
 */
export const rehydratePrivacyToken = <ThrowOnError extends boolean = false>(options: Options<RehydratePrivacyTokenData, ThrowOnError>): RequestResult<RehydratePrivacyTokenResponses, RehydratePrivacyTokenErrors, ThrowOnError> => (options.client ?? client).post<RehydratePrivacyTokenResponses, RehydratePrivacyTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/privacy/rehydrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Purge Expired Privacy Mappings
 *
 * Admin endpoint to purge expired scoped privacy mappings immediately.
 */
export const purgeExpiredPrivacyMappings = <ThrowOnError extends boolean = false>(options?: Options<PurgeExpiredPrivacyMappingsData, ThrowOnError>): RequestResult<PurgeExpiredPrivacyMappingsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PurgeExpiredPrivacyMappingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/privacy/purge-expired',
    ...options
});

/**
 * List Metabase Report Schedules
 */
export const listMetabaseReportSchedules = <ThrowOnError extends boolean = false>(options?: Options<ListMetabaseReportSchedulesData, ThrowOnError>): RequestResult<ListMetabaseReportSchedulesResponses, ListMetabaseReportSchedulesErrors, ThrowOnError> => (options?.client ?? client).get<ListMetabaseReportSchedulesResponses, ListMetabaseReportSchedulesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-reports/',
    ...options
});

/**
 * Create Metabase Report Schedule Endpoint
 */
export const createMetabaseReportScheduleEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateMetabaseReportScheduleEndpointData, ThrowOnError>): RequestResult<CreateMetabaseReportScheduleEndpointResponses, CreateMetabaseReportScheduleEndpointErrors, ThrowOnError> => (options.client ?? client).post<CreateMetabaseReportScheduleEndpointResponses, CreateMetabaseReportScheduleEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-reports/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Metabase Report Schedule Endpoint
 */
export const deleteMetabaseReportScheduleEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteMetabaseReportScheduleEndpointData, ThrowOnError>): RequestResult<DeleteMetabaseReportScheduleEndpointResponses, DeleteMetabaseReportScheduleEndpointErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMetabaseReportScheduleEndpointResponses, DeleteMetabaseReportScheduleEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-reports/{schedule_id}',
    ...options
});

/**
 * Get Metabase Report Schedule Endpoint
 */
export const getMetabaseReportScheduleEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetMetabaseReportScheduleEndpointData, ThrowOnError>): RequestResult<GetMetabaseReportScheduleEndpointResponses, GetMetabaseReportScheduleEndpointErrors, ThrowOnError> => (options.client ?? client).get<GetMetabaseReportScheduleEndpointResponses, GetMetabaseReportScheduleEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-reports/{schedule_id}',
    ...options
});

/**
 * Update Metabase Report Schedule Endpoint
 */
export const updateMetabaseReportScheduleEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateMetabaseReportScheduleEndpointData, ThrowOnError>): RequestResult<UpdateMetabaseReportScheduleEndpointResponses, UpdateMetabaseReportScheduleEndpointErrors, ThrowOnError> => (options.client ?? client).put<UpdateMetabaseReportScheduleEndpointResponses, UpdateMetabaseReportScheduleEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-reports/{schedule_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Metabase Report Catalog
 */
export const listMetabaseReportCatalog = <ThrowOnError extends boolean = false>(options?: Options<ListMetabaseReportCatalogData, ThrowOnError>): RequestResult<ListMetabaseReportCatalogResponses, ListMetabaseReportCatalogErrors, ThrowOnError> => (options?.client ?? client).get<ListMetabaseReportCatalogResponses, ListMetabaseReportCatalogErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-report-catalog/',
    ...options
});

/**
 * Create Metabase Report Catalog Endpoint
 */
export const createMetabaseReportCatalogEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateMetabaseReportCatalogEndpointData, ThrowOnError>): RequestResult<CreateMetabaseReportCatalogEndpointResponses, CreateMetabaseReportCatalogEndpointErrors, ThrowOnError> => (options.client ?? client).post<CreateMetabaseReportCatalogEndpointResponses, CreateMetabaseReportCatalogEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-report-catalog/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Metabase Report Catalog Endpoint
 */
export const deleteMetabaseReportCatalogEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteMetabaseReportCatalogEndpointData, ThrowOnError>): RequestResult<DeleteMetabaseReportCatalogEndpointResponses, DeleteMetabaseReportCatalogEndpointErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMetabaseReportCatalogEndpointResponses, DeleteMetabaseReportCatalogEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-report-catalog/{catalog_id}',
    ...options
});

/**
 * Get Metabase Report Catalog Endpoint
 */
export const getMetabaseReportCatalogEndpoint = <ThrowOnError extends boolean = false>(options: Options<GetMetabaseReportCatalogEndpointData, ThrowOnError>): RequestResult<GetMetabaseReportCatalogEndpointResponses, GetMetabaseReportCatalogEndpointErrors, ThrowOnError> => (options.client ?? client).get<GetMetabaseReportCatalogEndpointResponses, GetMetabaseReportCatalogEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-report-catalog/{catalog_id}',
    ...options
});

/**
 * Update Metabase Report Catalog Endpoint
 */
export const updateMetabaseReportCatalogEndpoint = <ThrowOnError extends boolean = false>(options: Options<UpdateMetabaseReportCatalogEndpointData, ThrowOnError>): RequestResult<UpdateMetabaseReportCatalogEndpointResponses, UpdateMetabaseReportCatalogEndpointErrors, ThrowOnError> => (options.client ?? client).put<UpdateMetabaseReportCatalogEndpointResponses, UpdateMetabaseReportCatalogEndpointErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-report-catalog/{catalog_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Available Metabase Embeds
 */
export const listAvailableMetabaseEmbeds = <ThrowOnError extends boolean = false>(options?: Options<ListAvailableMetabaseEmbedsData, ThrowOnError>): RequestResult<ListAvailableMetabaseEmbedsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAvailableMetabaseEmbedsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-embeds/available',
    ...options
});

/**
 * Create Metabase Embed Token
 */
export const createMetabaseEmbedToken = <ThrowOnError extends boolean = false>(options: Options<CreateMetabaseEmbedTokenData, ThrowOnError>): RequestResult<CreateMetabaseEmbedTokenResponses, CreateMetabaseEmbedTokenErrors, ThrowOnError> => (options.client ?? client).post<CreateMetabaseEmbedTokenResponses, CreateMetabaseEmbedTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/metabase-embeds/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Performance Metric
 *
 * Record a performance metric from the frontend.
 *
 * This endpoint receives Core Web Vitals and other performance metrics
 * from the frontend performance monitoring system.
 */
export const recordPerformanceMetric = <ThrowOnError extends boolean = false>(options: Options<RecordPerformanceMetricData, ThrowOnError>): RequestResult<RecordPerformanceMetricResponses, RecordPerformanceMetricErrors, ThrowOnError> => (options.client ?? client).post<RecordPerformanceMetricResponses, RecordPerformanceMetricErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/analytics/performance/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Analytics Health
 *
 * Health check for analytics service.
 */
export const analyticsHealth = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsHealthData, ThrowOnError>): RequestResult<AnalyticsHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AnalyticsHealthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/analytics/health/',
    ...options
});

/**
 * Read Security Test Results
 *
 * Retrieve security test results with optional filters.
 */
export const readSecurityTestResults = <ThrowOnError extends boolean = false>(options?: Options<ReadSecurityTestResultsData, ThrowOnError>): RequestResult<ReadSecurityTestResultsResponses, ReadSecurityTestResultsErrors, ThrowOnError> => (options?.client ?? client).get<ReadSecurityTestResultsResponses, ReadSecurityTestResultsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/results',
    ...options
});

/**
 * Create Test Result
 *
 * Create a new security test result (internal use by test runner).
 */
export const createTestResult = <ThrowOnError extends boolean = false>(options: Options<CreateTestResultData, ThrowOnError>): RequestResult<CreateTestResultResponses, CreateTestResultErrors, ThrowOnError> => (options.client ?? client).post<CreateTestResultResponses, CreateTestResultErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Security Test Result
 *
 * Get security test result by ID.
 */
export const readSecurityTestResult = <ThrowOnError extends boolean = false>(options: Options<ReadSecurityTestResultData, ThrowOnError>): RequestResult<ReadSecurityTestResultResponses, ReadSecurityTestResultErrors, ThrowOnError> => (options.client ?? client).get<ReadSecurityTestResultResponses, ReadSecurityTestResultErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/results/{result_id}',
    ...options
});

/**
 * Read Security Test Summary
 *
 * Get aggregate summary of security test results.
 */
export const readSecurityTestSummary = <ThrowOnError extends boolean = false>(options?: Options<ReadSecurityTestSummaryData, ThrowOnError>): RequestResult<ReadSecurityTestSummaryResponses, ReadSecurityTestSummaryErrors, ThrowOnError> => (options?.client ?? client).get<ReadSecurityTestSummaryResponses, ReadSecurityTestSummaryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/summary',
    ...options
});

/**
 * Cleanup Old Results
 *
 * Delete security test results older than retention period (admin only).
 * Default is 3 years (1095 days).
 */
export const cleanupOldResults = <ThrowOnError extends boolean = false>(options?: Options<CleanupOldResultsData, ThrowOnError>): RequestResult<CleanupOldResultsResponses, CleanupOldResultsErrors, ThrowOnError> => (options?.client ?? client).post<CleanupOldResultsResponses, CleanupOldResultsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/cleanup',
    ...options
});

/**
 * Run Security Tests
 *
 * Trigger security test suite execution (admin only).
 * This endpoint queues a Celery task for async execution.
 */
export const runSecurityTests = <ThrowOnError extends boolean = false>(options: Options<RunSecurityTestsData, ThrowOnError>): RequestResult<RunSecurityTestsResponses, RunSecurityTestsErrors, ThrowOnError> => (options.client ?? client).post<RunSecurityTestsResponses, RunSecurityTestsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/run/{test_suite}',
    ...options
});

/**
 * Check Test Suite Health
 *
 * Check security test suite health status.
 */
export const checkTestSuiteHealth = <ThrowOnError extends boolean = false>(options?: Options<CheckTestSuiteHealthData, ThrowOnError>): RequestResult<CheckTestSuiteHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CheckTestSuiteHealthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/security-tests/health',
    ...options
});

/**
 * Get Available Tasks
 *
 * List all available tasks from registry.
 *
 * Returns metadata for all registered tasks including constraints and filters.
 * Requires admin role.
 */
export const getAvailableTasks = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableTasksData, ThrowOnError>): RequestResult<GetAvailableTasksResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAvailableTasksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/tasks',
    ...options
});

/**
 * List Task Configs
 *
 * List all task schedule configurations with optional filters.
 *
 * Query parameters:
 * - skip: Number of records to skip (default: 0)
 * - limit: Maximum records to return (default: 100, max: 1000)
 * - enabled: Filter by enabled status (true/false, optional)
 *
 * Requires admin role.
 */
export const listTaskConfigs = <ThrowOnError extends boolean = false>(options?: Options<ListTaskConfigsData, ThrowOnError>): RequestResult<ListTaskConfigsResponses, ListTaskConfigsErrors, ThrowOnError> => (options?.client ?? client).get<ListTaskConfigsResponses, ListTaskConfigsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config',
    ...options
});

/**
 * Create Task Schedule
 *
 * Create new task schedule configuration.
 *
 * Validates:
 * - Task exists in registry
 * - Schedule frequency is within allowed range
 * - Filter criteria contains only supported fields
 *
 * Requires admin role.
 *
 * SECURITY FIX (INJ-DOS-001): Request body size limited to 64KB.
 */
export const createTaskSchedule = <ThrowOnError extends boolean = false>(options: Options<CreateTaskScheduleData, ThrowOnError>): RequestResult<CreateTaskScheduleResponses, CreateTaskScheduleErrors, ThrowOnError> => (options.client ?? client).post<CreateTaskScheduleResponses, CreateTaskScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Task Schedule
 *
 * Delete task schedule configuration while preserving history.
 *
 * Marks the schedule as deleted and removes it from active use.
 *
 * Requires admin role.
 */
export const deleteTaskSchedule = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskScheduleData, ThrowOnError>): RequestResult<DeleteTaskScheduleResponses, DeleteTaskScheduleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskScheduleResponses, DeleteTaskScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config/{config_id}',
    ...options
});

/**
 * Get Task Config
 *
 * Get task schedule configuration by ID.
 *
 * Requires admin role.
 */
export const getTaskConfig = <ThrowOnError extends boolean = false>(options: Options<GetTaskConfigData, ThrowOnError>): RequestResult<GetTaskConfigResponses, GetTaskConfigErrors, ThrowOnError> => (options.client ?? client).get<GetTaskConfigResponses, GetTaskConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config/{config_id}',
    ...options
});

/**
 * Update Task Schedule
 *
 * Update task schedule configuration.
 *
 * Can modify:
 * - enabled: Toggle task on/off
 * - schedule_type, schedule_value: Change schedule
 * - queue_name: Change task queue
 * - email_recipients: Update recipient list
 * - filter_criteria: Modify task-specific filters
 *
 * Requires admin role.
 *
 * SECURITY FIX (INJ-DOS-001): Request body size limited to 64KB.
 */
export const updateTaskSchedule = <ThrowOnError extends boolean = false>(options: Options<UpdateTaskScheduleData, ThrowOnError>): RequestResult<UpdateTaskScheduleResponses, UpdateTaskScheduleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTaskScheduleResponses, UpdateTaskScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Task Schedule
 *
 * Update task schedule configuration.
 *
 * Can modify:
 * - enabled: Toggle task on/off
 * - schedule_type, schedule_value: Change schedule
 * - queue_name: Change task queue
 * - email_recipients: Update recipient list
 * - filter_criteria: Modify task-specific filters
 *
 * Requires admin role.
 *
 * SECURITY FIX (INJ-DOS-001): Request body size limited to 64KB.
 */
export const schedulerUpdateTaskSchedule = <ThrowOnError extends boolean = false>(options: Options<SchedulerUpdateTaskScheduleData, ThrowOnError>): RequestResult<SchedulerUpdateTaskScheduleResponses, SchedulerUpdateTaskScheduleErrors, ThrowOnError> => (options.client ?? client).put<SchedulerUpdateTaskScheduleResponses, SchedulerUpdateTaskScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Task Execution History
 *
 * Get task execution history with optional filters.
 *
 * Query parameters:
 * - task_schedule_id: Filter by specific task schedule
 * - status: Filter by status (pending, running, success, failed)
 * - skip: Number of records to skip (default: 0)
 * - limit: Maximum records to return (default: 20, max: 200)
 *
 * Results ordered by most recent first.
 *
 * Requires admin role.
 */
export const getTaskExecutionHistory = <ThrowOnError extends boolean = false>(options?: Options<GetTaskExecutionHistoryData, ThrowOnError>): RequestResult<GetTaskExecutionHistoryResponses, GetTaskExecutionHistoryErrors, ThrowOnError> => (options?.client ?? client).get<GetTaskExecutionHistoryResponses, GetTaskExecutionHistoryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/history',
    ...options
});

/**
 * Get Execution Detail
 *
 * Get detailed task execution record by ID.
 *
 * Requires admin role.
 */
export const getExecutionDetail = <ThrowOnError extends boolean = false>(options: Options<GetExecutionDetailData, ThrowOnError>): RequestResult<GetExecutionDetailResponses, GetExecutionDetailErrors, ThrowOnError> => (options.client ?? client).get<GetExecutionDetailResponses, GetExecutionDetailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/history/{execution_id}',
    ...options
});

/**
 * Trigger Task Now
 *
 * Manually trigger a scheduled task immediately.
 *
 * Creates execution record and enqueues task.
 * Task executes with default/configured parameters.
 *
 * Returns execution ID for tracking status.
 *
 * Requires admin role.
 */
export const triggerTaskNow = <ThrowOnError extends boolean = false>(options: Options<TriggerTaskNowData, ThrowOnError>): RequestResult<TriggerTaskNowResponses, TriggerTaskNowErrors, ThrowOnError> => (options.client ?? client).post<TriggerTaskNowResponses, TriggerTaskNowErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/run-now/{config_id}',
    ...options
});

/**
 * Get Redbeat Status
 *
 * Get Redbeat scheduler status and sync info.
 *
 * Returns information about Redbeat configuration and synced tasks.
 *
 * Requires admin role.
 */
export const getRedbeatStatus = <ThrowOnError extends boolean = false>(options?: Options<GetRedbeatStatusData, ThrowOnError>): RequestResult<GetRedbeatStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRedbeatStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/redbeat-status',
    ...options
});

/**
 * Preview Schedule Config
 *
 * Dry-run all enabled exporters for a schedule config without sending email or writing to DB.
 *
 * Uses an empty sample bot payload to exercise PDF, Excel, and CSV exporters
 * based on the config's output_layout_profile.
 *
 * Returns availability flags, sample CSV rows, and any exporter errors.
 *
 * Requires admin role.
 */
export const previewScheduleConfig = <ThrowOnError extends boolean = false>(options: Options<PreviewScheduleConfigData, ThrowOnError>): RequestResult<PreviewScheduleConfigResponses, PreviewScheduleConfigErrors, ThrowOnError> => (options.client ?? client).post<PreviewScheduleConfigResponses, PreviewScheduleConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/config/{config_id}/preview',
    ...options
});

/**
 * Trigger Redbeat Sync
 *
 * Trigger manual synchronization of Redbeat schedules from database.
 *
 * Requires admin role.
 */
export const triggerRedbeatSync = <ThrowOnError extends boolean = false>(options?: Options<TriggerRedbeatSyncData, ThrowOnError>): RequestResult<TriggerRedbeatSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TriggerRedbeatSyncResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduler/redbeat-sync',
    ...options
});

/**
 * List Workflow Runs
 */
export const listWorkflowRuns = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowRunsData, ThrowOnError>): RequestResult<ListWorkflowRunsResponses, ListWorkflowRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkflowRunsResponses, ListWorkflowRunsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/workflow-runs/',
    ...options
});

/**
 * Get Workflow Run
 */
export const getWorkflowRun = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowRunData, ThrowOnError>): RequestResult<GetWorkflowRunResponses, GetWorkflowRunErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowRunResponses, GetWorkflowRunErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/admin/workflow-runs/{task_id}',
    ...options
});

/**
 * Get Partner Issue Rollup
 */
export const getPartnerIssueRollup = <ThrowOnError extends boolean = false>(options?: Options<GetPartnerIssueRollupData, ThrowOnError>): RequestResult<GetPartnerIssueRollupResponses, GetPartnerIssueRollupErrors, ThrowOnError> => (options?.client ?? client).get<GetPartnerIssueRollupResponses, GetPartnerIssueRollupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner-issue-insights/rollup',
    ...options
});

/**
 * Export Partner Issue Csv
 */
export const exportPartnerIssueCsv = <ThrowOnError extends boolean = false>(options?: Options<ExportPartnerIssueCsvData, ThrowOnError>): RequestResult<ExportPartnerIssueCsvResponses, ExportPartnerIssueCsvErrors, ThrowOnError> => (options?.client ?? client).get<ExportPartnerIssueCsvResponses, ExportPartnerIssueCsvErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/partner-issue-insights/export.csv',
    ...options
});
